// Austria border coordinates — 7237 points from OpenStreetMap (simplified)
// Source: OpenStreetMap via Nominatim, Douglas-Peucker simplified (epsilon=0.0004)
// High-res on purpose (matches switzerland-border.ts fidelity) — low-poly
// drafts of the Austria map were rejected. Landlocked: single outer ring.
export const AUSTRIA_COORDS: [number, number][] = [
  [10.4544, 47.5558],
  [10.4387, 47.5235],
  [10.4421, 47.5188],
  [10.4405, 47.5135],
  [10.4361, 47.5095],
  [10.4349, 47.5063],
  [10.4313, 47.5038],
  [10.4377, 47.4917],
  [10.4374, 47.4911],
  [10.4402, 47.4894],
  [10.4403, 47.4865],
  [10.4415, 47.4861],
  [10.4426, 47.4846],
  [10.4457, 47.4841],
  [10.4515, 47.4858],
  [10.4575, 47.4826],
  [10.4637, 47.4828],
  [10.4637, 47.4804],
  [10.468, 47.4771],
  [10.4667, 47.4752],
  [10.4666, 47.4735],
  [10.4675, 47.4726],
  [10.4677, 47.4712],
  [10.47, 47.4688],
  [10.4678, 47.4672],
  [10.4655, 47.4639],
  [10.4676, 47.4609],
  [10.4673, 47.4598],
  [10.4683, 47.4588],
  [10.4659, 47.453],
  [10.4667, 47.4522],
  [10.4671, 47.4505],
  [10.4703, 47.4484],
  [10.4698, 47.4461],
  [10.4703, 47.4448],
  [10.4731, 47.4431],
  [10.472, 47.4408],
  [10.4734, 47.4377],
  [10.4732, 47.4368],
  [10.4749, 47.4347],
  [10.4759, 47.4322],
  [10.4752, 47.4315],
  [10.4713, 47.4319],
  [10.4661, 47.4307],
  [10.4645, 47.4296],
  [10.4592, 47.4281],
  [10.4582, 47.4271],
  [10.4573, 47.4243],
  [10.4561, 47.4235],
  [10.4568, 47.422],
  [10.4558, 47.4203],
  [10.4562, 47.4192],
  [10.4465, 47.4147],
  [10.4385, 47.4135],
  [10.4374, 47.4127],
  [10.4356, 47.4097],
  [10.4358, 47.4084],
  [10.4375, 47.4068],
  [10.4355, 47.4048],
  [10.4313, 47.4028],
  [10.4313, 47.4018],
  [10.4343, 47.4],
  [10.4321, 47.3981],
  [10.4319, 47.3972],
  [10.4305, 47.3965],
  [10.4306, 47.3953],
  [10.4296, 47.394],
  [10.4292, 47.3912],
  [10.4368, 47.3804],
  [10.4309, 47.3839],
  [10.428, 47.3835],
  [10.4252, 47.3845],
  [10.4197, 47.3846],
  [10.4188, 47.3832],
  [10.419, 47.3824],
  [10.4166, 47.3801],
  [10.4134, 47.3786],
  [10.4062, 47.3771],
  [10.4005, 47.3776],
  [10.3947, 47.3756],
  [10.3934, 47.3746],
  [10.3914, 47.3715],
  [10.3894, 47.3706],
  [10.3888, 47.3696],
  [10.3892, 47.3672],
  [10.3857, 47.3618],
  [10.3873, 47.3598],
  [10.3865, 47.3566],
  [10.3847, 47.356],
  [10.3835, 47.3543],
  [10.3818, 47.3542],
  [10.3803, 47.3526],
  [10.3775, 47.3525],
  [10.3709, 47.3453],
  [10.3682, 47.3447],
  [10.3649, 47.3415],
  [10.3569, 47.337],
  [10.3563, 47.335],
  [10.3567, 47.3334],
  [10.3491, 47.3246],
  [10.3471, 47.3235],
  [10.3458, 47.322],
  [10.3454, 47.3199],
  [10.3487, 47.3174],
  [10.3463, 47.3151],
  [10.3407, 47.3142],
  [10.3394, 47.3105],
  [10.3356, 47.3088],
  [10.3303, 47.3048],
  [10.3244, 47.3039],
  [10.3238, 47.3056],
  [10.3212, 47.3064],
  [10.3186, 47.3059],
  [10.3166, 47.3067],
  [10.315, 47.3065],
  [10.3088, 47.3023],
  [10.3068, 47.3021],
  [10.3014, 47.2987],
  [10.298, 47.2987],
  [10.2975, 47.2997],
  [10.2957, 47.2999],
  [10.2936, 47.2982],
  [10.2923, 47.2945],
  [10.2849, 47.2912],
  [10.2816, 47.2877],
  [10.2658, 47.2881],
  [10.2669, 47.2868],
  [10.2661, 47.2852],
  [10.2615, 47.2843],
  [10.2595, 47.2814],
  [10.2547, 47.281],
  [10.2485, 47.2791],
  [10.2456, 47.2804],
  [10.2454, 47.279],
  [10.2423, 47.2781],
  [10.2412, 47.2757],
  [10.2392, 47.2742],
  [10.2382, 47.2719],
  [10.2362, 47.272],
  [10.2324, 47.2706],
  [10.2224, 47.2758],
  [10.2076, 47.2753],
  [10.2012, 47.2769],
  [10.1957, 47.2744],
  [10.195, 47.2731],
  [10.1873, 47.2726],
  [10.1795, 47.2709],
  [10.1783, 47.2701],
  [10.174, 47.2702],
  [10.1737, 47.2729],
  [10.1725, 47.2741],
  [10.1752, 47.2758],
  [10.1721, 47.2791],
  [10.1759, 47.282],
  [10.1749, 47.2892],
  [10.1772, 47.2905],
  [10.1782, 47.2946],
  [10.1796, 47.296],
  [10.1817, 47.2961],
  [10.1848, 47.2939],
  [10.1896, 47.2939],
  [10.1956, 47.2972],
  [10.1991, 47.2975],
  [10.2027, 47.3002],
  [10.204, 47.3024],
  [10.2059, 47.3029],
  [10.2107, 47.3063],
  [10.2101, 47.3072],
  [10.2117, 47.3107],
  [10.2142, 47.3115],
  [10.216, 47.3111],
  [10.2109, 47.3175],
  [10.2111, 47.319],
  [10.2089, 47.3206],
  [10.2076, 47.3207],
  [10.2063, 47.3226],
  [10.2021, 47.3244],
  [10.1995, 47.3265],
  [10.201, 47.3282],
  [10.2057, 47.3304],
  [10.2074, 47.3323],
  [10.2076, 47.335],
  [10.2042, 47.3368],
  [10.2057, 47.3389],
  [10.2118, 47.3442],
  [10.2133, 47.3467],
  [10.2171, 47.3499],
  [10.2176, 47.3506],
  [10.217, 47.3544],
  [10.2246, 47.3588],
  [10.2243, 47.3594],
  [10.2253, 47.3616],
  [10.229, 47.3634],
  [10.2292, 47.3661],
  [10.2307, 47.3681],
  [10.2348, 47.3706],
  [10.2372, 47.3736],
  [10.2355, 47.3762],
  [10.2317, 47.379],
  [10.2334, 47.3807],
  [10.2362, 47.3819],
  [10.2309, 47.3861],
  [10.2298, 47.3879],
  [10.2271, 47.3889],
  [10.2262, 47.3875],
  [10.223, 47.3862],
  [10.2185, 47.3824],
  [10.2148, 47.382],
  [10.2126, 47.3804],
  [10.2083, 47.3829],
  [10.2069, 47.3833],
  [10.2033, 47.3826],
  [10.2013, 47.383],
  [10.2009, 47.3837],
  [10.1999, 47.3833],
  [10.1989, 47.3843],
  [10.1991, 47.3849],
  [10.1971, 47.3858],
  [10.1951, 47.3893],
  [10.1872, 47.39],
  [10.1818, 47.3924],
  [10.1814, 47.3899],
  [10.1818, 47.3884],
  [10.1827, 47.3881],
  [10.1813, 47.3873],
  [10.1765, 47.3853],
  [10.1694, 47.3858],
  [10.169, 47.3751],
  [10.1696, 47.3713],
  [10.1659, 47.3689],
  [10.1499, 47.3671],
  [10.1417, 47.3672],
  [10.1379, 47.3679],
  [10.1193, 47.3756],
  [10.0999, 47.3548],
  [10.0829, 47.3938],
  [10.0843, 47.3965],
  [10.0862, 47.3983],
  [10.0862, 47.3995],
  [10.0817, 47.4014],
  [10.0808, 47.4035],
  [10.0798, 47.4043],
  [10.0768, 47.4043],
  [10.073, 47.4061],
  [10.0705, 47.4077],
  [10.0709, 47.4091],
  [10.0691, 47.4102],
  [10.0707, 47.4101],
  [10.0721, 47.4112],
  [10.0723, 47.4133],
  [10.0742, 47.4147],
  [10.0766, 47.4144],
  [10.0792, 47.4153],
  [10.0855, 47.4145],
  [10.0892, 47.416],
  [10.0937, 47.4169],
  [10.0957, 47.4179],
  [10.0952, 47.4194],
  [10.0959, 47.4222],
  [10.1006, 47.426],
  [10.1056, 47.4287],
  [10.0938, 47.4405],
  [10.093, 47.4439],
  [10.0931, 47.4475],
  [10.095, 47.4498],
  [10.0944, 47.4506],
  [10.0946, 47.4516],
  [10.0933, 47.4532],
  [10.0934, 47.4543],
  [10.0917, 47.4568],
  [10.092, 47.4576],
  [10.0912, 47.4582],
  [10.0916, 47.4589],
  [10.0902, 47.4594],
  [10.0895, 47.4604],
  [10.0886, 47.4603],
  [10.0876, 47.4598],
  [10.0878, 47.4588],
  [10.0855, 47.4592],
  [10.0842, 47.4588],
  [10.0827, 47.4566],
  [10.0806, 47.4554],
  [10.0756, 47.4564],
  [10.0736, 47.4556],
  [10.0721, 47.4563],
  [10.07, 47.456],
  [10.0703, 47.4575],
  [10.0683, 47.4612],
  [10.0662, 47.4619],
  [10.0647, 47.4636],
  [10.0535, 47.4669],
  [10.0529, 47.4692],
  [10.0517, 47.4702],
  [10.0517, 47.471],
  [10.0532, 47.4733],
  [10.0545, 47.4742],
  [10.0541, 47.4759],
  [10.0527, 47.4763],
  [10.0453, 47.4849],
  [10.0472, 47.4863],
  [10.0448, 47.4876],
  [10.0423, 47.4876],
  [10.0374, 47.4892],
  [10.0348, 47.4885],
  [10.0282, 47.4854],
  [10.023, 47.4841],
  [10.0198, 47.4838],
  [10.0163, 47.4848],
  [10.0127, 47.4826],
  [10.0102, 47.4818],
  [10.006, 47.4824],
  [10.0032, 47.4818],
  [10.0008, 47.4821],
  [9.9951, 47.4863],
  [9.9874, 47.4985],
  [9.9957, 47.5028],
  [9.9896, 47.5057],
  [9.9874, 47.5087],
  [9.9846, 47.511],
  [9.9825, 47.5102],
  [9.9812, 47.5105],
  [9.9781, 47.5135],
  [9.9733, 47.5155],
  [9.9717, 47.5155],
  [9.971, 47.5175],
  [9.9653, 47.5209],
  [9.965, 47.523],
  [9.9677, 47.5246],
  [9.9673, 47.5269],
  [9.9684, 47.528],
  [9.9672, 47.5303],
  [9.9656, 47.5297],
  [9.9653, 47.5301],
  [9.9649, 47.5322],
  [9.9656, 47.5335],
  [9.9647, 47.5354],
  [9.9659, 47.5359],
  [9.9648, 47.538],
  [9.967, 47.5385],
  [9.9675, 47.5394],
  [9.9671, 47.5413],
  [9.9708, 47.5435],
  [9.9713, 47.5443],
  [9.9707, 47.5457],
  [9.968, 47.5464],
  [9.9661, 47.5443],
  [9.9648, 47.5444],
  [9.9632, 47.5423],
  [9.9589, 47.5432],
  [9.959, 47.5421],
  [9.9605, 47.5415],
  [9.9595, 47.5382],
  [9.9638, 47.5353],
  [9.9637, 47.5347],
  [9.9624, 47.5345],
  [9.9614, 47.5351],
  [9.9587, 47.5346],
  [9.9442, 47.5369],
  [9.9411, 47.5382],
  [9.9366, 47.5342],
  [9.9335, 47.5326],
  [9.9311, 47.5326],
  [9.9279, 47.5311],
  [9.9265, 47.5312],
  [9.9219, 47.5296],
  [9.9177, 47.5301],
  [9.9161, 47.5316],
  [9.9136, 47.5325],
  [9.9115, 47.5362],
  [9.9085, 47.5384],
  [9.9085, 47.5407],
  [9.9067, 47.5422],
  [9.8994, 47.5448],
  [9.8891, 47.544],
  [9.8865, 47.5452],
  [9.8867, 47.5459],
  [9.8851, 47.5468],
  [9.8812, 47.5481],
  [9.8799, 47.5477],
  [9.8751, 47.5434],
  [9.8753, 47.5427],
  [9.8778, 47.5418],
  [9.878, 47.5388],
  [9.8761, 47.5361],
  [9.8761, 47.5349],
  [9.8739, 47.5336],
  [9.8757, 47.5319],
  [9.8745, 47.5285],
  [9.8735, 47.529],
  [9.8732, 47.53],
  [9.8685, 47.532],
  [9.8672, 47.5317],
  [9.8635, 47.5336],
  [9.8584, 47.5339],
  [9.8581, 47.535],
  [9.8557, 47.5361],
  [9.8554, 47.5378],
  [9.8535, 47.5399],
  [9.8506, 47.5408],
  [9.8502, 47.5416],
  [9.847, 47.5421],
  [9.8445, 47.5413],
  [9.8406, 47.542],
  [9.8392, 47.543],
  [9.8371, 47.5428],
  [9.8345, 47.5434],
  [9.8337, 47.5442],
  [9.8299, 47.5443],
  [9.8293, 47.5462],
  [9.8282, 47.5466],
  [9.8243, 47.5474],
  [9.8158, 47.5477],
  [9.8151, 47.5496],
  [9.8168, 47.5513],
  [9.8171, 47.5533],
  [9.8211, 47.555],
  [9.8218, 47.5562],
  [9.8236, 47.5572],
  [9.8236, 47.5582],
  [9.8256, 47.5592],
  [9.8259, 47.5626],
  [9.8232, 47.5654],
  [9.8218, 47.5685],
  [9.8219, 47.5699],
  [9.8208, 47.5709],
  [9.8258, 47.5738],
  [9.8262, 47.5764],
  [9.8271, 47.5774],
  [9.8273, 47.58],
  [9.8246, 47.5809],
  [9.8246, 47.5859],
  [9.8238, 47.5871],
  [9.8204, 47.5876],
  [9.8177, 47.5889],
  [9.8141, 47.5881],
  [9.8131, 47.5893],
  [9.811, 47.59],
  [9.8109, 47.5911],
  [9.8092, 47.5918],
  [9.8091, 47.5924],
  [9.8059, 47.5942],
  [9.8047, 47.5942],
  [9.8025, 47.5959],
  [9.8, 47.5961],
  [9.7986, 47.5948],
  [9.7958, 47.5937],
  [9.7945, 47.5944],
  [9.7915, 47.5935],
  [9.7869, 47.5943],
  [9.7852, 47.5937],
  [9.7842, 47.5948],
  [9.7804, 47.594],
  [9.7787, 47.5955],
  [9.777, 47.5954],
  [9.7762, 47.5935],
  [9.7721, 47.5892],
  [9.7695, 47.5886],
  [9.7693, 47.5874],
  [9.7666, 47.5892],
  [9.7656, 47.5891],
  [9.7651, 47.5873],
  [9.7659, 47.5854],
  [9.7632, 47.5864],
  [9.7624, 47.5847],
  [9.7607, 47.5835],
  [9.762, 47.581],
  [9.7563, 47.5796],
  [9.7554, 47.576],
  [9.7564, 47.5728],
  [9.7557, 47.5722],
  [9.7516, 47.5721],
  [9.7509, 47.5712],
  [9.7481, 47.5705],
  [9.7485, 47.5695],
  [9.7516, 47.5684],
  [9.7521, 47.5675],
  [9.7474, 47.5643],
  [9.7469, 47.5606],
  [9.7434, 47.5588],
  [9.7435, 47.5579],
  [9.7468, 47.557],
  [9.7471, 47.5557],
  [9.7452, 47.5547],
  [9.743, 47.5552],
  [9.7417, 47.5549],
  [9.7407, 47.5534],
  [9.7406, 47.5518],
  [9.7386, 47.5508],
  [9.7376, 47.5483],
  [9.7352, 47.5466],
  [9.7363, 47.54],
  [9.7361, 47.5375],
  [9.7368, 47.5359],
  [9.7365, 47.5347],
  [9.7348, 47.534],
  [9.7303, 47.5341],
  [9.6804, 47.5234],
  [9.5587, 47.5419],
  [9.5618, 47.5046],
  [9.5613, 47.4985],
  [9.562, 47.4963],
  [9.5656, 47.4925],
  [9.5817, 47.4833],
  [9.5951, 47.4633],
  [9.6004, 47.4616],
  [9.6029, 47.462],
  [9.6051, 47.464],
  [9.6066, 47.4698],
  [9.609, 47.4705],
  [9.6118, 47.4693],
  [9.617, 47.4619],
  [9.6223, 47.4575],
  [9.6263, 47.4567],
  [9.6458, 47.4556],
  [9.6554, 47.454],
  [9.659, 47.4522],
  [9.6594, 47.4514],
  [9.659, 47.4491],
  [9.658, 47.4478],
  [9.6459, 47.4389],
  [9.6444, 47.4359],
  [9.6445, 47.4337],
  [9.6492, 47.4244],
  [9.6504, 47.4204],
  [9.6519, 47.4084],
  [9.6516, 47.4046],
  [9.6544, 47.4044],
  [9.6573, 47.4002],
  [9.6601, 47.3975],
  [9.6718, 47.3931],
  [9.6741, 47.3901],
  [9.6738, 47.3839],
  [9.6731, 47.3811],
  [9.6703, 47.3774],
  [9.6624, 47.3711],
  [9.6567, 47.3688],
  [9.6505, 47.3675],
  [9.6354, 47.3674],
  [9.6263, 47.3651],
  [9.6245, 47.3661],
  [9.6053, 47.3515],
  [9.5997, 47.3455],
  [9.5883, 47.3175],
  [9.5814, 47.3111],
  [9.5656, 47.3041],
  [9.5565, 47.2984],
  [9.5547, 47.2961],
  [9.5513, 47.2868],
  [9.5462, 47.28],
  [9.5329, 47.273],
  [9.5307, 47.2706],
  [9.5364, 47.266],
  [9.5382, 47.266],
  [9.5398, 47.2651],
  [9.5404, 47.2628],
  [9.5394, 47.2619],
  [9.5395, 47.2614],
  [9.544, 47.2585],
  [9.5485, 47.2571],
  [9.5556, 47.2528],
  [9.5573, 47.2511],
  [9.5595, 47.2505],
  [9.5672, 47.2419],
  [9.5674, 47.2409],
  [9.5667, 47.2401],
  [9.5581, 47.2327],
  [9.5544, 47.2275],
  [9.5546, 47.2265],
  [9.5518, 47.2238],
  [9.5554, 47.2238],
  [9.5554, 47.2225],
  [9.5585, 47.2241],
  [9.562, 47.2229],
  [9.5642, 47.2206],
  [9.5686, 47.2198],
  [9.5757, 47.2137],
  [9.5785, 47.2089],
  [9.5849, 47.2053],
  [9.5812, 47.2],
  [9.5803, 47.1958],
  [9.5791, 47.1957],
  [9.5786, 47.1944],
  [9.5726, 47.1908],
  [9.5735, 47.186],
  [9.5735, 47.1788],
  [9.5743, 47.1781],
  [9.5733, 47.1772],
  [9.5731, 47.1756],
  [9.5673, 47.1732],
  [9.5646, 47.1702],
  [9.5728, 47.1695],
  [9.5795, 47.1711],
  [9.5909, 47.1647],
  [9.5968, 47.1629],
  [9.6009, 47.1588],
  [9.6002, 47.1568],
  [9.602, 47.1556],
  [9.6029, 47.154],
  [9.6034, 47.1526],
  [9.6028, 47.1516],
  [9.6053, 47.1492],
  [9.6087, 47.1478],
  [9.614, 47.1475],
  [9.6187, 47.1498],
  [9.6206, 47.1516],
  [9.6217, 47.1513],
  [9.6214, 47.1504],
  [9.6233, 47.1471],
  [9.6259, 47.1459],
  [9.6226, 47.1412],
  [9.625, 47.1385],
  [9.6243, 47.1351],
  [9.6247, 47.1326],
  [9.63, 47.1304],
  [9.6332, 47.1283],
  [9.635, 47.1281],
  [9.6326, 47.1248],
  [9.6252, 47.1191],
  [9.6246, 47.1146],
  [9.6236, 47.1128],
  [9.6208, 47.1105],
  [9.623, 47.108],
  [9.6285, 47.1075],
  [9.6282, 47.1055],
  [9.6302, 47.1047],
  [9.6344, 47.1012],
  [9.6356, 47.0946],
  [9.6354, 47.0906],
  [9.6332, 47.0862],
  [9.6335, 47.0834],
  [9.6235, 47.0825],
  [9.6187, 47.0781],
  [9.6135, 47.0787],
  [9.6116, 47.0795],
  [9.6114, 47.0766],
  [9.6105, 47.0752],
  [9.6134, 47.0714],
  [9.6134, 47.0695],
  [9.6127, 47.0679],
  [9.6112, 47.0668],
  [9.6117, 47.0645],
  [9.6071, 47.0608],
  [9.6104, 47.0578],
  [9.6157, 47.0553],
  [9.6172, 47.0536],
  [9.625, 47.0524],
  [9.6263, 47.0513],
  [9.6275, 47.0518],
  [9.6327, 47.0513],
  [9.6365, 47.0517],
  [9.6413, 47.0539],
  [9.6416, 47.056],
  [9.6434, 47.0576],
  [9.6437, 47.0591],
  [9.6451, 47.0598],
  [9.6582, 47.0582],
  [9.6644, 47.0598],
  [9.6693, 47.0593],
  [9.6727, 47.0597],
  [9.6798, 47.0622],
  [9.6818, 47.0621],
  [9.6826, 47.0603],
  [9.6821, 47.0589],
  [9.6882, 47.0552],
  [9.6925, 47.0546],
  [9.6976, 47.0524],
  [9.7016, 47.0522],
  [9.7076, 47.0538],
  [9.7086, 47.0517],
  [9.7057, 47.0504],
  [9.707, 47.048],
  [9.7168, 47.0449],
  [9.7182, 47.0434],
  [9.7253, 47.044],
  [9.732, 47.0434],
  [9.7341, 47.0424],
  [9.7381, 47.0419],
  [9.7418, 47.0427],
  [9.7422, 47.0415],
  [9.7452, 47.0411],
  [9.7453, 47.0391],
  [9.746, 47.0391],
  [9.7481, 47.0369],
  [9.7541, 47.0369],
  [9.7569, 47.0378],
  [9.7631, 47.0374],
  [9.7691, 47.039],
  [9.7749, 47.0391],
  [9.7769, 47.0384],
  [9.7784, 47.0388],
  [9.7811, 47.038],
  [9.7849, 47.0385],
  [9.7853, 47.0367],
  [9.7896, 47.0348],
  [9.7919, 47.0317],
  [9.7953, 47.0309],
  [9.7959, 47.0301],
  [9.8014, 47.0291],
  [9.801, 47.0281],
  [9.8045, 47.0263],
  [9.8076, 47.0236],
  [9.8094, 47.0235],
  [9.8099, 47.0227],
  [9.8117, 47.0225],
  [9.8123, 47.0217],
  [9.8154, 47.0225],
  [9.8235, 47.0199],
  [9.8258, 47.0176],
  [9.8289, 47.0167],
  [9.8308, 47.0143],
  [9.8335, 47.0145],
  [9.8361, 47.0125],
  [9.8397, 47.0127],
  [9.8381, 47.0129],
  [9.841, 47.0151],
  [9.8465, 47.0163],
  [9.8527, 47.0164],
  [9.857, 47.0188],
  [9.8597, 47.0232],
  [9.8654, 47.0216],
  [9.8695, 47.0212],
  [9.8733, 47.0216],
  [9.8775, 47.0207],
  [9.8795, 47.0195],
  [9.8793, 47.0182],
  [9.8803, 47.018],
  [9.8803, 47.0172],
  [9.8773, 47.0162],
  [9.8754, 47.0142],
  [9.8712, 47.0131],
  [9.872, 47.0102],
  [9.8707, 47.0097],
  [9.8726, 47.0085],
  [9.8733, 47.0063],
  [9.8834, 47.0021],
  [9.8888, 47.0007],
  [9.8897, 46.9963],
  [9.8895, 46.9942],
  [9.8902, 46.9938],
  [9.8906, 46.9919],
  [9.8923, 46.9904],
  [9.892, 46.9889],
  [9.8911, 46.9883],
  [9.8848, 46.9855],
  [9.8846, 46.9844],
  [9.8831, 46.9833],
  [9.8845, 46.9808],
  [9.8799, 46.9771],
  [9.8791, 46.9752],
  [9.8757, 46.9737],
  [9.8747, 46.9717],
  [9.8762, 46.9701],
  [9.8756, 46.9675],
  [9.8707, 46.9632],
  [9.8727, 46.9618],
  [9.8734, 46.9604],
  [9.8769, 46.9587],
  [9.8787, 46.9571],
  [9.8773, 46.9543],
  [9.8778, 46.9529],
  [9.8772, 46.9527],
  [9.8772, 46.9516],
  [9.8749, 46.9504],
  [9.8768, 46.9476],
  [9.8765, 46.9442],
  [9.8773, 46.9419],
  [9.8766, 46.9407],
  [9.8807, 46.9401],
  [9.8795, 46.9386],
  [9.8777, 46.9381],
  [9.8761, 46.9346],
  [9.8777, 46.9343],
  [9.8787, 46.935],
  [9.8807, 46.935],
  [9.8832, 46.9342],
  [9.8844, 46.933],
  [9.8945, 46.9316],
  [9.8977, 46.9302],
  [9.9, 46.9273],
  [9.9062, 46.9258],
  [9.9063, 46.9253],
  [9.908, 46.9249],
  [9.9123, 46.9261],
  [9.9152, 46.9243],
  [9.9165, 46.9217],
  [9.9215, 46.9188],
  [9.9284, 46.9169],
  [9.9372, 46.9133],
  [9.9433, 46.9132],
  [9.9461, 46.9123],
  [9.9499, 46.9143],
  [9.9591, 46.916],
  [9.9618, 46.9146],
  [9.9631, 46.9124],
  [9.9644, 46.9128],
  [9.9666, 46.9122],
  [9.9717, 46.9134],
  [9.9731, 46.9152],
  [9.9779, 46.9159],
  [9.9805, 46.9139],
  [9.9806, 46.9128],
  [9.9818, 46.9119],
  [9.9813, 46.9113],
  [9.9822, 46.9093],
  [9.9813, 46.9081],
  [9.9824, 46.9062],
  [9.9868, 46.9055],
  [9.9901, 46.9024],
  [9.9974, 46.902],
  [10.0007, 46.8999],
  [10.0059, 46.8988],
  [10.0098, 46.9005],
  [10.0149, 46.9002],
  [10.0178, 46.9016],
  [10.0199, 46.8988],
  [10.0222, 46.8978],
  [10.0234, 46.8965],
  [10.0265, 46.8958],
  [10.0286, 46.892],
  [10.0316, 46.8894],
  [10.0322, 46.888],
  [10.0347, 46.8866],
  [10.0376, 46.8868],
  [10.0393, 46.8858],
  [10.0412, 46.8839],
  [10.0424, 46.8804],
  [10.0455, 46.8799],
  [10.0504, 46.8769],
  [10.0519, 46.8768],
  [10.0516, 46.8762],
  [10.0526, 46.8757],
  [10.0526, 46.8747],
  [10.0515, 46.8738],
  [10.0519, 46.8722],
  [10.0505, 46.8709],
  [10.0513, 46.8704],
  [10.0507, 46.8686],
  [10.0513, 46.8679],
  [10.0508, 46.8651],
  [10.0512, 46.8639],
  [10.0533, 46.8631],
  [10.0549, 46.8617],
  [10.0572, 46.862],
  [10.0596, 46.8608],
  [10.0633, 46.8616],
  [10.0686, 46.8612],
  [10.0749, 46.8619],
  [10.0838, 46.8602],
  [10.0875, 46.8612],
  [10.0887, 46.8598],
  [10.0927, 46.8581],
  [10.093, 46.857],
  [10.0917, 46.8549],
  [10.0924, 46.8524],
  [10.092, 46.8514],
  [10.096, 46.8498],
  [10.098, 46.8476],
  [10.1005, 46.8462],
  [10.1052, 46.8409],
  [10.1131, 46.8422],
  [10.1156, 46.8439],
  [10.1192, 46.8442],
  [10.1202, 46.8464],
  [10.1199, 46.8474],
  [10.1222, 46.8473],
  [10.1231, 46.8485],
  [10.1316, 46.8474],
  [10.1394, 46.8474],
  [10.1434, 46.8488],
  [10.1447, 46.8498],
  [10.1451, 46.8511],
  [10.1473, 46.8514],
  [10.1546, 46.8503],
  [10.1557, 46.8497],
  [10.1559, 46.8479],
  [10.1574, 46.8479],
  [10.1627, 46.851],
  [10.1691, 46.8507],
  [10.1703, 46.8513],
  [10.1709, 46.853],
  [10.1718, 46.8537],
  [10.1785, 46.854],
  [10.182, 46.8555],
  [10.1835, 46.859],
  [10.1857, 46.8607],
  [10.1886, 46.8614],
  [10.1912, 46.863],
  [10.1937, 46.8664],
  [10.199, 46.8666],
  [10.2038, 46.8646],
  [10.207, 46.8652],
  [10.2092, 46.8648],
  [10.2192, 46.8673],
  [10.2229, 46.8663],
  [10.2327, 46.8663],
  [10.2319, 46.8667],
  [10.2308, 46.8694],
  [10.2327, 46.8709],
  [10.2328, 46.873],
  [10.232, 46.8758],
  [10.2339, 46.8778],
  [10.2346, 46.8806],
  [10.234, 46.8831],
  [10.2348, 46.8847],
  [10.2307, 46.889],
  [10.2276, 46.8902],
  [10.2275, 46.892],
  [10.2266, 46.8931],
  [10.2273, 46.8942],
  [10.2269, 46.8954],
  [10.2257, 46.8959],
  [10.2267, 46.8971],
  [10.2304, 46.8983],
  [10.2333, 46.9016],
  [10.2344, 46.9041],
  [10.2339, 46.9057],
  [10.2346, 46.9065],
  [10.2346, 46.9079],
  [10.2366, 46.9122],
  [10.2359, 46.9134],
  [10.2372, 46.915],
  [10.237, 46.9157],
  [10.2399, 46.9166],
  [10.242, 46.9188],
  [10.2406, 46.924],
  [10.2416, 46.9295],
  [10.2406, 46.9314],
  [10.2525, 46.9307],
  [10.2669, 46.9288],
  [10.2899, 46.9229],
  [10.291, 46.9233],
  [10.2969, 46.9199],
  [10.3008, 46.9247],
  [10.3095, 46.9258],
  [10.3161, 46.9252],
  [10.317, 46.9261],
  [10.3172, 46.931],
  [10.3128, 46.9345],
  [10.3102, 46.9356],
  [10.3062, 46.9401],
  [10.3067, 46.9417],
  [10.3086, 46.9435],
  [10.3077, 46.9473],
  [10.3093, 46.9502],
  [10.3162, 46.9516],
  [10.3208, 46.9514],
  [10.3246, 46.9522],
  [10.3278, 46.954],
  [10.3297, 46.9589],
  [10.3291, 46.9618],
  [10.3295, 46.9643],
  [10.3312, 46.9669],
  [10.3331, 46.968],
  [10.3341, 46.9695],
  [10.3345, 46.9725],
  [10.3407, 46.9784],
  [10.3398, 46.9797],
  [10.34, 46.9813],
  [10.3418, 46.9823],
  [10.3438, 46.9822],
  [10.3448, 46.9831],
  [10.3463, 46.9859],
  [10.3465, 46.9896],
  [10.3481, 46.9896],
  [10.349, 46.9907],
  [10.355, 46.9924],
  [10.3588, 46.9914],
  [10.3659, 46.9916],
  [10.3684, 46.9908],
  [10.3721, 46.9907],
  [10.3736, 46.9926],
  [10.3784, 46.9948],
  [10.3834, 46.9993],
  [10.3847, 47],
  [10.3893, 47.0005],
  [10.3987, 46.9969],
  [10.4022, 46.9909],
  [10.4068, 46.9885],
  [10.4125, 46.9826],
  [10.4206, 46.9799],
  [10.421, 46.9792],
  [10.4236, 46.9783],
  [10.4268, 46.9754],
  [10.4275, 46.9729],
  [10.4271, 46.9712],
  [10.4259, 46.9685],
  [10.423, 46.9656],
  [10.4234, 46.9642],
  [10.4229, 46.9618],
  [10.422, 46.9608],
  [10.4261, 46.9575],
  [10.4295, 46.956],
  [10.4342, 46.9564],
  [10.4375, 46.9559],
  [10.4395, 46.9541],
  [10.4426, 46.9541],
  [10.4491, 46.9523],
  [10.4556, 46.9528],
  [10.4569, 46.9509],
  [10.4611, 46.9497],
  [10.4639, 46.9481],
  [10.4688, 46.9471],
  [10.4707, 46.9452],
  [10.4717, 46.9451],
  [10.4731, 46.9429],
  [10.4749, 46.9425],
  [10.4762, 46.941],
  [10.4812, 46.9401],
  [10.4834, 46.939],
  [10.4878, 46.9388],
  [10.4894, 46.9378],
  [10.4873, 46.936],
  [10.4869, 46.9346],
  [10.488, 46.9344],
  [10.4859, 46.933],
  [10.4853, 46.9314],
  [10.4855, 46.9298],
  [10.4881, 46.928],
  [10.4883, 46.9263],
  [10.4865, 46.9223],
  [10.4868, 46.9204],
  [10.4853, 46.9186],
  [10.4862, 46.9155],
  [10.4833, 46.9125],
  [10.4785, 46.9106],
  [10.4787, 46.9076],
  [10.4775, 46.905],
  [10.4777, 46.9034],
  [10.4752, 46.9011],
  [10.475, 46.8987],
  [10.4757, 46.8976],
  [10.4751, 46.8943],
  [10.4724, 46.8925],
  [10.4719, 46.8908],
  [10.4692, 46.8893],
  [10.4647, 46.8843],
  [10.4669, 46.8835],
  [10.4692, 46.8811],
  [10.4697, 46.8772],
  [10.4713, 46.873],
  [10.4703, 46.8667],
  [10.468, 46.8621],
  [10.4697, 46.8549],
  [10.4787, 46.8591],
  [10.481, 46.8587],
  [10.4829, 46.8566],
  [10.4803, 46.8559],
  [10.4811, 46.8553],
  [10.4832, 46.8542],
  [10.487, 46.8549],
  [10.4887, 46.8528],
  [10.4911, 46.8523],
  [10.4907, 46.85],
  [10.4924, 46.8501],
  [10.4944, 46.8526],
  [10.4955, 46.8521],
  [10.4964, 46.8501],
  [10.4941, 46.8487],
  [10.4968, 46.8487],
  [10.4988, 46.8475],
  [10.505, 46.8483],
  [10.506, 46.8476],
  [10.5111, 46.8469],
  [10.5166, 46.8468],
  [10.521, 46.8454],
  [10.538, 46.8487],
  [10.5525, 46.85],
  [10.5553, 46.8486],
  [10.5555, 46.8476],
  [10.5564, 46.8469],
  [10.5499, 46.8398],
  [10.546, 46.8379],
  [10.5462, 46.8373],
  [10.5511, 46.8394],
  [10.5558, 46.8398],
  [10.5582, 46.8411],
  [10.5622, 46.8407],
  [10.5703, 46.8423],
  [10.5734, 46.8461],
  [10.5757, 46.8465],
  [10.5783, 46.8482],
  [10.5809, 46.8478],
  [10.5838, 46.8493],
  [10.5902, 46.8503],
  [10.5913, 46.8526],
  [10.5955, 46.8573],
  [10.6017, 46.858],
  [10.6051, 46.8577],
  [10.6099, 46.8587],
  [10.615, 46.8602],
  [10.6174, 46.8625],
  [10.6233, 46.8637],
  [10.6248, 46.8645],
  [10.6492, 46.8655],
  [10.6539, 46.8668],
  [10.6559, 46.8681],
  [10.656, 46.8695],
  [10.6593, 46.8713],
  [10.6626, 46.8743],
  [10.6674, 46.8755],
  [10.6716, 46.8706],
  [10.6753, 46.8699],
  [10.6781, 46.8708],
  [10.6803, 46.8701],
  [10.6811, 46.8687],
  [10.6822, 46.8683],
  [10.6856, 46.8686],
  [10.6882, 46.8673],
  [10.6904, 46.8677],
  [10.6937, 46.8639],
  [10.6968, 46.8626],
  [10.6957, 46.8594],
  [10.6933, 46.858],
  [10.6946, 46.8564],
  [10.6938, 46.856],
  [10.6929, 46.8537],
  [10.6941, 46.8522],
  [10.7005, 46.8505],
  [10.7019, 46.8496],
  [10.7021, 46.8483],
  [10.7036, 46.8472],
  [10.7108, 46.8467],
  [10.7167, 46.8471],
  [10.7169, 46.8461],
  [10.7159, 46.8431],
  [10.7186, 46.8421],
  [10.7221, 46.8379],
  [10.7319, 46.838],
  [10.7326, 46.8377],
  [10.734, 46.8354],
  [10.7368, 46.8344],
  [10.7552, 46.833],
  [10.7569, 46.8312],
  [10.7577, 46.8275],
  [10.7616, 46.8254],
  [10.7635, 46.8235],
  [10.7639, 46.8226],
  [10.7628, 46.8205],
  [10.7586, 46.8176],
  [10.7556, 46.8158],
  [10.7513, 46.8151],
  [10.7507, 46.8133],
  [10.7473, 46.8098],
  [10.7461, 46.8069],
  [10.7461, 46.8049],
  [10.744, 46.803],
  [10.7358, 46.7994],
  [10.7261, 46.7979],
  [10.726, 46.7967],
  [10.7287, 46.7931],
  [10.7282, 46.7907],
  [10.7303, 46.7883],
  [10.735, 46.7883],
  [10.7377, 46.7872],
  [10.7419, 46.7866],
  [10.7508, 46.7875],
  [10.7511, 46.7867],
  [10.7547, 46.7851],
  [10.7574, 46.7852],
  [10.7603, 46.7861],
  [10.7623, 46.7875],
  [10.7667, 46.7876],
  [10.7712, 46.7889],
  [10.773, 46.7903],
  [10.7783, 46.7908],
  [10.7822, 46.7935],
  [10.7831, 46.7956],
  [10.7863, 46.7963],
  [10.7937, 46.791],
  [10.7959, 46.7913],
  [10.8141, 46.7751],
  [10.8154, 46.7758],
  [10.8176, 46.7748],
  [10.8235, 46.7741],
  [10.8255, 46.7731],
  [10.826, 46.774],
  [10.8289, 46.7749],
  [10.8321, 46.7804],
  [10.8359, 46.7819],
  [10.8372, 46.782],
  [10.8388, 46.7811],
  [10.8407, 46.7818],
  [10.8422, 46.7783],
  [10.846, 46.7784],
  [10.8507, 46.7749],
  [10.853, 46.774],
  [10.8674, 46.7724],
  [10.8686, 46.7658],
  [10.8796, 46.7646],
  [10.8827, 46.7629],
  [10.8877, 46.7633],
  [10.8904, 46.7643],
  [10.8922, 46.7659],
  [10.8939, 46.769],
  [10.896, 46.77],
  [10.9026, 46.7681],
  [10.9059, 46.7681],
  [10.9095, 46.7708],
  [10.9127, 46.7719],
  [10.9154, 46.7739],
  [10.9181, 46.775],
  [10.9208, 46.7747],
  [10.9233, 46.7753],
  [10.9282, 46.7729],
  [10.9312, 46.7739],
  [10.941, 46.7741],
  [10.9437, 46.7754],
  [10.9445, 46.7748],
  [10.9503, 46.775],
  [10.9733, 46.7721],
  [10.9749, 46.7726],
  [10.9778, 46.77],
  [10.9779, 46.7691],
  [10.9813, 46.7696],
  [10.9862, 46.7675],
  [10.9877, 46.7678],
  [10.9881, 46.7684],
  [10.9916, 46.7681],
  [10.9931, 46.767],
  [10.9962, 46.767],
  [11.0054, 46.769],
  [11.0139, 46.7721],
  [11.0223, 46.7654],
  [11.0253, 46.767],
  [11.0252, 46.7721],
  [11.0278, 46.7761],
  [11.0288, 46.7797],
  [11.0334, 46.7846],
  [11.034, 46.7879],
  [11.0353, 46.79],
  [11.0349, 46.7915],
  [11.0361, 46.7939],
  [11.0378, 46.7945],
  [11.0411, 46.7993],
  [11.0442, 46.8009],
  [11.0444, 46.8017],
  [11.0435, 46.8017],
  [11.0393, 46.805],
  [11.0506, 46.8086],
  [11.057, 46.8081],
  [11.0589, 46.8095],
  [11.0604, 46.8127],
  [11.0626, 46.813],
  [11.0649, 46.815],
  [11.0711, 46.8176],
  [11.0728, 46.8186],
  [11.0737, 46.82],
  [11.0813, 46.8207],
  [11.0833, 46.8223],
  [11.0826, 46.8244],
  [11.0808, 46.8266],
  [11.0814, 46.8279],
  [11.0789, 46.8314],
  [11.0777, 46.8343],
  [11.0753, 46.8361],
  [11.0733, 46.8365],
  [11.0703, 46.8384],
  [11.0748, 46.8434],
  [11.0732, 46.8459],
  [11.0748, 46.8472],
  [11.0716, 46.851],
  [11.0714, 46.8533],
  [11.0719, 46.8562],
  [11.073, 46.8581],
  [11.075, 46.8577],
  [11.0785, 46.8596],
  [11.0817, 46.8648],
  [11.082, 46.8661],
  [11.0814, 46.8672],
  [11.0821, 46.8688],
  [11.0866, 46.8732],
  [11.0867, 46.8749],
  [11.0886, 46.8772],
  [11.0888, 46.8788],
  [11.091, 46.8796],
  [11.0924, 46.8815],
  [11.0965, 46.8836],
  [11.1016, 46.8896],
  [11.0971, 46.8914],
  [11.0968, 46.8933],
  [11.0993, 46.8971],
  [11.0996, 46.8986],
  [11.0992, 46.9014],
  [11.0981, 46.9017],
  [11.0975, 46.9052],
  [11.0957, 46.9057],
  [11.0959, 46.9064],
  [11.095, 46.9075],
  [11.096, 46.9119],
  [11.0976, 46.914],
  [11.1093, 46.916],
  [11.1112, 46.9202],
  [11.1103, 46.9253],
  [11.1096, 46.926],
  [11.1102, 46.9274],
  [11.1149, 46.9314],
  [11.119, 46.931],
  [11.1247, 46.9291],
  [11.1276, 46.9293],
  [11.1296, 46.9277],
  [11.1337, 46.9286],
  [11.1388, 46.9275],
  [11.1444, 46.9304],
  [11.146, 46.9303],
  [11.1499, 46.9316],
  [11.1526, 46.9339],
  [11.1551, 46.9341],
  [11.1616, 46.9391],
  [11.1641, 46.9399],
  [11.1681, 46.945],
  [11.1645, 46.9474],
  [11.1627, 46.9499],
  [11.1646, 46.9542],
  [11.1659, 46.9553],
  [11.1638, 46.9571],
  [11.1638, 46.9603],
  [11.1647, 46.9632],
  [11.1644, 46.9658],
  [11.1745, 46.9627],
  [11.1765, 46.9626],
  [11.1784, 46.9643],
  [11.1826, 46.9659],
  [11.1869, 46.9695],
  [11.1899, 46.9705],
  [11.1923, 46.9688],
  [11.1953, 46.9705],
  [11.1957, 46.9697],
  [11.2031, 46.968],
  [11.2056, 46.9633],
  [11.207, 46.9625],
  [11.2207, 46.9692],
  [11.2258, 46.9697],
  [11.2323, 46.9688],
  [11.2362, 46.9691],
  [11.237, 46.9697],
  [11.2417, 46.9697],
  [11.2451, 46.9724],
  [11.2493, 46.9742],
  [11.2566, 46.9742],
  [11.259, 46.9784],
  [11.2635, 46.9808],
  [11.2714, 46.9796],
  [11.2729, 46.9803],
  [11.2772, 46.9806],
  [11.2792, 46.9818],
  [11.2851, 46.9832],
  [11.2881, 46.986],
  [11.295, 46.9858],
  [11.2978, 46.9851],
  [11.3018, 46.9831],
  [11.3054, 46.9842],
  [11.3078, 46.9841],
  [11.3098, 46.9854],
  [11.3127, 46.9885],
  [11.317, 46.9912],
  [11.3203, 46.9924],
  [11.3258, 46.9907],
  [11.3287, 46.9885],
  [11.3338, 46.9885],
  [11.3354, 46.9857],
  [11.337, 46.9849],
  [11.3409, 46.9852],
  [11.3423, 46.9871],
  [11.3422, 46.9882],
  [11.3457, 46.9907],
  [11.3473, 46.9904],
  [11.3483, 46.9895],
  [11.3508, 46.9893],
  [11.3553, 46.9906],
  [11.3587, 46.9906],
  [11.3613, 46.9881],
  [11.362, 46.9886],
  [11.3623, 46.988],
  [11.3648, 46.987],
  [11.3659, 46.9838],
  [11.3673, 46.9829],
  [11.3759, 46.9795],
  [11.3776, 46.9776],
  [11.3779, 46.9763],
  [11.3806, 46.975],
  [11.3812, 46.9729],
  [11.3807, 46.972],
  [11.3823, 46.9706],
  [11.3894, 46.9693],
  [11.3928, 46.9695],
  [11.3999, 46.9663],
  [11.4015, 46.965],
  [11.4056, 46.9648],
  [11.4066, 46.9659],
  [11.4099, 46.967],
  [11.4151, 46.9672],
  [11.4175, 46.9664],
  [11.4199, 46.9692],
  [11.4263, 46.9692],
  [11.4313, 46.9728],
  [11.4324, 46.9727],
  [11.4358, 46.9745],
  [11.4403, 46.9752],
  [11.4429, 46.9771],
  [11.4432, 46.9804],
  [11.4457, 46.9844],
  [11.4511, 46.9895],
  [11.4526, 46.9923],
  [11.4546, 46.9929],
  [11.4593, 46.9921],
  [11.4605, 46.9914],
  [11.462, 46.9932],
  [11.4636, 46.9931],
  [11.4653, 46.9943],
  [11.4699, 46.9952],
  [11.4685, 46.9985],
  [11.4701, 47.0026],
  [11.4716, 47.0041],
  [11.4742, 47.005],
  [11.476, 47.0084],
  [11.4788, 47.011],
  [11.489, 47.0107],
  [11.4962, 47.0093],
  [11.4989, 47.0092],
  [11.4991, 47.0099],
  [11.502, 47.0097],
  [11.5008, 47.0073],
  [11.5061, 47.0064],
  [11.5065, 47.0071],
  [11.5077, 47.0072],
  [11.5074, 47.005],
  [11.5078, 47.0047],
  [11.5126, 47.0051],
  [11.5146, 47.0028],
  [11.5156, 47.0026],
  [11.5148, 47.001],
  [11.5155, 47.0003],
  [11.52, 46.9991],
  [11.5197, 46.9984],
  [11.5219, 46.998],
  [11.5219, 46.9967],
  [11.5252, 46.9963],
  [11.5282, 46.9938],
  [11.5326, 46.9917],
  [11.5342, 46.9896],
  [11.5336, 46.9869],
  [11.5356, 46.9852],
  [11.5385, 46.9841],
  [11.5428, 46.9849],
  [11.5423, 46.9863],
  [11.5535, 46.9905],
  [11.5615, 46.9905],
  [11.5651, 46.9929],
  [11.5693, 46.993],
  [11.5772, 46.9956],
  [11.5799, 46.997],
  [11.5814, 46.9971],
  [11.5805, 47.0007],
  [11.5812, 47.0021],
  [11.5847, 47.0029],
  [11.5895, 47.0055],
  [11.5993, 47.0055],
  [11.6041, 47.0069],
  [11.6055, 47.0085],
  [11.6076, 47.0091],
  [11.6098, 47.011],
  [11.6162, 47.0126],
  [11.6216, 47.0114],
  [11.6244, 47.0128],
  [11.6272, 47.0133],
  [11.6282, 47.0104],
  [11.6299, 47.008],
  [11.633, 47.0067],
  [11.6349, 47.0031],
  [11.6434, 47.0012],
  [11.6478, 46.9985],
  [11.6496, 46.9986],
  [11.656, 46.9961],
  [11.6596, 46.9953],
  [11.6597, 46.9948],
  [11.6611, 46.9946],
  [11.6647, 46.9917],
  [11.6691, 46.9932],
  [11.6744, 46.9937],
  [11.6759, 46.9925],
  [11.6775, 46.9925],
  [11.6886, 46.9955],
  [11.7001, 46.9926],
  [11.7036, 46.9929],
  [11.7064, 46.9924],
  [11.7115, 46.9932],
  [11.7136, 46.9911],
  [11.7145, 46.9892],
  [11.7168, 46.9877],
  [11.7172, 46.9851],
  [11.7182, 46.9839],
  [11.7242, 46.98],
  [11.7249, 46.9774],
  [11.7263, 46.9762],
  [11.7277, 46.9724],
  [11.736, 46.9718],
  [11.7384, 46.9704],
  [11.747, 46.9689],
  [11.7509, 46.9702],
  [11.7521, 46.9717],
  [11.7581, 46.9728],
  [11.7641, 46.9727],
  [11.7656, 46.9735],
  [11.7675, 46.9788],
  [11.772, 46.9844],
  [11.7773, 46.988],
  [11.7809, 46.989],
  [11.7818, 46.9925],
  [11.7867, 46.9915],
  [11.7894, 46.9901],
  [11.7915, 46.99],
  [11.7976, 46.9913],
  [11.8011, 46.9909],
  [11.8038, 46.9918],
  [11.8096, 46.9902],
  [11.8153, 46.9899],
  [11.8213, 46.9911],
  [11.8275, 46.9932],
  [11.8317, 46.9924],
  [11.8362, 46.993],
  [11.8398, 46.9966],
  [11.8402, 46.9986],
  [11.8434, 47.0001],
  [11.845, 47.0017],
  [11.8524, 47.0001],
  [11.8553, 47.0033],
  [11.858, 47.0051],
  [11.8602, 47.0079],
  [11.8649, 47.0095],
  [11.868, 47.0116],
  [11.8698, 47.0119],
  [11.8741, 47.0101],
  [11.8765, 47.0116],
  [11.878, 47.0148],
  [11.8801, 47.0162],
  [11.8927, 47.0164],
  [11.8933, 47.0181],
  [11.8953, 47.0205],
  [11.9011, 47.0231],
  [11.9038, 47.025],
  [11.9084, 47.0265],
  [11.9095, 47.0276],
  [11.9144, 47.0287],
  [11.9155, 47.0324],
  [11.9167, 47.0332],
  [11.9264, 47.0349],
  [11.933, 47.0376],
  [11.9412, 47.0364],
  [11.9472, 47.0335],
  [11.9496, 47.0352],
  [11.9506, 47.0378],
  [11.9533, 47.0399],
  [11.9557, 47.043],
  [11.9567, 47.0434],
  [11.9582, 47.043],
  [11.9624, 47.0404],
  [11.9685, 47.0405],
  [11.9736, 47.0473],
  [11.9794, 47.05],
  [11.9814, 47.0496],
  [11.9862, 47.047],
  [11.9915, 47.0491],
  [11.9952, 47.0496],
  [12.0158, 47.0471],
  [12.0213, 47.0473],
  [12.0277, 47.0499],
  [12.031, 47.0506],
  [12.0323, 47.0547],
  [12.0349, 47.0578],
  [12.0399, 47.0604],
  [12.0441, 47.0614],
  [12.0486, 47.061],
  [12.051, 47.0619],
  [12.053, 47.0609],
  [12.0561, 47.0611],
  [12.0595, 47.0585],
  [12.0625, 47.0594],
  [12.0725, 47.06],
  [12.0767, 47.0589],
  [12.0783, 47.064],
  [12.0817, 47.069],
  [12.0833, 47.0699],
  [12.0873, 47.0707],
  [12.0882, 47.0719],
  [12.0898, 47.0722],
  [12.0921, 47.0738],
  [12.092, 47.0761],
  [12.0938, 47.077],
  [12.0998, 47.0783],
  [12.103, 47.0783],
  [12.1112, 47.0762],
  [12.1189, 47.0732],
  [12.1303, 47.0779],
  [12.1337, 47.0774],
  [12.136, 47.0807],
  [12.1407, 47.0798],
  [12.146, 47.0803],
  [12.1516, 47.0793],
  [12.1543, 47.0807],
  [12.1607, 47.0817],
  [12.165, 47.0835],
  [12.1699, 47.0869],
  [12.1777, 47.088],
  [12.1806, 47.0912],
  [12.1831, 47.091],
  [12.186, 47.0921],
  [12.1948, 47.0889],
  [12.198, 47.0887],
  [12.2009, 47.0873],
  [12.2069, 47.0863],
  [12.2154, 47.0861],
  [12.2172, 47.0841],
  [12.2235, 47.0834],
  [12.227, 47.0821],
  [12.2304, 47.0762],
  [12.2334, 47.0745],
  [12.2374, 47.0703],
  [12.2408, 47.0692],
  [12.2389, 47.0664],
  [12.2369, 47.0652],
  [12.2327, 47.0645],
  [12.2261, 47.0608],
  [12.2166, 47.0587],
  [12.2166, 47.0564],
  [12.2155, 47.0552],
  [12.2157, 47.0529],
  [12.2173, 47.0509],
  [12.2165, 47.05],
  [12.217, 47.0478],
  [12.2162, 47.0466],
  [12.2167, 47.0451],
  [12.2125, 47.0422],
  [12.2129, 47.0397],
  [12.2118, 47.0387],
  [12.2119, 47.0373],
  [12.2108, 47.0355],
  [12.2093, 47.0347],
  [12.2096, 47.0329],
  [12.2085, 47.0316],
  [12.2077, 47.0316],
  [12.2069, 47.0296],
  [12.2049, 47.0283],
  [12.2047, 47.0269],
  [12.2017, 47.0273],
  [12.1938, 47.0268],
  [12.1891, 47.0256],
  [12.1818, 47.0249],
  [12.1802, 47.0255],
  [12.1773, 47.0235],
  [12.1737, 47.0237],
  [12.1715, 47.023],
  [12.1644, 47.0189],
  [12.1533, 47.0239],
  [12.1505, 47.0239],
  [12.1474, 47.0249],
  [12.1419, 47.0221],
  [12.1395, 47.0188],
  [12.1311, 47.016],
  [12.13, 47.0146],
  [12.1261, 47.0131],
  [12.1239, 47.0109],
  [12.1232, 47.0084],
  [12.1214, 47.007],
  [12.1213, 47.0058],
  [12.1251, 47.0025],
  [12.1266, 47],
  [12.1259, 46.9971],
  [12.1307, 46.9932],
  [12.1286, 46.9923],
  [12.13, 46.9881],
  [12.1275, 46.9855],
  [12.1321, 46.9847],
  [12.1332, 46.983],
  [12.1378, 46.9829],
  [12.1382, 46.982],
  [12.1382, 46.9799],
  [12.1374, 46.9795],
  [12.1368, 46.9759],
  [12.136, 46.9753],
  [12.1368, 46.9747],
  [12.1371, 46.9736],
  [12.1356, 46.9726],
  [12.1358, 46.9691],
  [12.1368, 46.9671],
  [12.1366, 46.9655],
  [12.1356, 46.9646],
  [12.1311, 46.9641],
  [12.1319, 46.9623],
  [12.1357, 46.9602],
  [12.138, 46.9565],
  [12.143, 46.9556],
  [12.1477, 46.9532],
  [12.1513, 46.953],
  [12.1543, 46.9511],
  [12.1582, 46.9505],
  [12.1607, 46.9481],
  [12.1625, 46.9443],
  [12.165, 46.9427],
  [12.1667, 46.9395],
  [12.1684, 46.9383],
  [12.1687, 46.9373],
  [12.1678, 46.936],
  [12.1678, 46.9333],
  [12.1612, 46.9296],
  [12.1586, 46.9263],
  [12.1577, 46.924],
  [12.1552, 46.9214],
  [12.1528, 46.9171],
  [12.1495, 46.9155],
  [12.1489, 46.916],
  [12.1459, 46.9153],
  [12.1438, 46.9138],
  [12.1597, 46.9091],
  [12.1615, 46.9069],
  [12.1697, 46.9101],
  [12.1713, 46.909],
  [12.1746, 46.9084],
  [12.1767, 46.9068],
  [12.1806, 46.908],
  [12.1864, 46.9063],
  [12.1904, 46.9061],
  [12.1911, 46.9028],
  [12.194, 46.9037],
  [12.1945, 46.9033],
  [12.1952, 46.9023],
  [12.1944, 46.9004],
  [12.1974, 46.899],
  [12.1996, 46.8961],
  [12.1969, 46.8929],
  [12.1999, 46.8912],
  [12.2015, 46.8895],
  [12.2011, 46.8888],
  [12.1994, 46.8886],
  [12.1996, 46.8874],
  [12.2031, 46.8869],
  [12.2029, 46.8862],
  [12.2046, 46.8839],
  [12.2109, 46.8778],
  [12.2145, 46.8757],
  [12.2154, 46.874],
  [12.2185, 46.874],
  [12.2204, 46.8783],
  [12.2221, 46.8799],
  [12.2249, 46.8788],
  [12.2279, 46.8786],
  [12.2324, 46.8807],
  [12.2336, 46.8831],
  [12.2349, 46.8834],
  [12.2366, 46.8854],
  [12.2359, 46.8887],
  [12.2395, 46.8894],
  [12.2418, 46.8909],
  [12.2431, 46.8907],
  [12.245, 46.8888],
  [12.2482, 46.889],
  [12.2511, 46.8881],
  [12.253, 46.8886],
  [12.2569, 46.8882],
  [12.2602, 46.8867],
  [12.2621, 46.8874],
  [12.2638, 46.8868],
  [12.2662, 46.8874],
  [12.2694, 46.8856],
  [12.2737, 46.8844],
  [12.2753, 46.8813],
  [12.2782, 46.8791],
  [12.2755, 46.8746],
  [12.2759, 46.8727],
  [12.2802, 46.8708],
  [12.2801, 46.8698],
  [12.2809, 46.8691],
  [12.285, 46.8677],
  [12.2867, 46.868],
  [12.2907, 46.8654],
  [12.2919, 46.8652],
  [12.2918, 46.8645],
  [12.2902, 46.8642],
  [12.29, 46.8625],
  [12.291, 46.8604],
  [12.2893, 46.857],
  [12.2916, 46.8541],
  [12.291, 46.8522],
  [12.292, 46.8498],
  [12.2941, 46.8495],
  [12.2967, 46.8477],
  [12.2956, 46.8462],
  [12.2956, 46.8438],
  [12.3032, 46.8431],
  [12.3064, 46.8419],
  [12.3068, 46.8412],
  [12.3048, 46.8381],
  [12.3059, 46.8332],
  [12.3024, 46.8313],
  [12.2986, 46.8275],
  [12.2957, 46.8264],
  [12.2909, 46.8225],
  [12.2888, 46.8219],
  [12.2878, 46.8192],
  [12.2848, 46.8172],
  [12.2829, 46.8149],
  [12.2887, 46.8091],
  [12.2892, 46.8058],
  [12.2923, 46.8026],
  [12.2903, 46.8009],
  [12.2877, 46.8006],
  [12.2874, 46.7983],
  [12.2882, 46.7969],
  [12.2877, 46.795],
  [12.2823, 46.7936],
  [12.2803, 46.7919],
  [12.2808, 46.7915],
  [12.2805, 46.7896],
  [12.2829, 46.7867],
  [12.2839, 46.7829],
  [12.2936, 46.7833],
  [12.2977, 46.7844],
  [12.3007, 46.7837],
  [12.3013, 46.7827],
  [12.3041, 46.7829],
  [12.3062, 46.7832],
  [12.3069, 46.7843],
  [12.3092, 46.785],
  [12.3265, 46.7817],
  [12.3311, 46.7794],
  [12.3374, 46.7789],
  [12.3426, 46.7761],
  [12.3514, 46.777],
  [12.353, 46.7755],
  [12.3574, 46.775],
  [12.3591, 46.7733],
  [12.3593, 46.7724],
  [12.358, 46.7694],
  [12.3592, 46.7677],
  [12.3595, 46.7649],
  [12.3663, 46.7534],
  [12.3673, 46.7474],
  [12.3669, 46.7467],
  [12.3685, 46.7453],
  [12.3684, 46.7425],
  [12.3692, 46.7404],
  [12.3713, 46.7403],
  [12.3734, 46.7329],
  [12.3744, 46.732],
  [12.3757, 46.7324],
  [12.3778, 46.7266],
  [12.3776, 46.7223],
  [12.3841, 46.7163],
  [12.3867, 46.7166],
  [12.3881, 46.7156],
  [12.3874, 46.715],
  [12.3939, 46.7125],
  [12.3951, 46.7111],
  [12.3993, 46.7102],
  [12.4009, 46.709],
  [12.4007, 46.7081],
  [12.4021, 46.7071],
  [12.4073, 46.7055],
  [12.41, 46.7062],
  [12.411, 46.7029],
  [12.4136, 46.7017],
  [12.4138, 46.7008],
  [12.4192, 46.6993],
  [12.4247, 46.6997],
  [12.4276, 46.6989],
  [12.4282, 46.697],
  [12.4277, 46.6956],
  [12.4286, 46.6946],
  [12.4342, 46.6935],
  [12.4393, 46.6899],
  [12.4426, 46.6885],
  [12.4461, 46.6902],
  [12.4482, 46.6896],
  [12.4533, 46.6896],
  [12.4546, 46.688],
  [12.4604, 46.6874],
  [12.4626, 46.6866],
  [12.4655, 46.6865],
  [12.469, 46.6874],
  [12.4743, 46.6866],
  [12.476, 46.6856],
  [12.4775, 46.6828],
  [12.4779, 46.6798],
  [12.4799, 46.6773],
  [12.4875, 46.6773],
  [12.4906, 46.6767],
  [12.4942, 46.6774],
  [12.4958, 46.6769],
  [12.4972, 46.6783],
  [12.4993, 46.6778],
  [12.5018, 46.6806],
  [12.5053, 46.6797],
  [12.5062, 46.6778],
  [12.5165, 46.6785],
  [12.5185, 46.6769],
  [12.5202, 46.677],
  [12.5231, 46.6755],
  [12.5282, 46.6741],
  [12.5287, 46.6731],
  [12.528, 46.6715],
  [12.5287, 46.6701],
  [12.5332, 46.6678],
  [12.5366, 46.6674],
  [12.5402, 46.6642],
  [12.544, 46.6625],
  [12.5472, 46.6593],
  [12.5589, 46.6574],
  [12.5588, 46.6559],
  [12.5598, 46.6533],
  [12.5613, 46.6525],
  [12.5701, 46.6515],
  [12.5711, 46.6529],
  [12.5744, 46.6544],
  [12.5757, 46.6559],
  [12.5765, 46.6558],
  [12.5764, 46.6563],
  [12.5784, 46.6568],
  [12.5808, 46.6562],
  [12.5831, 46.6568],
  [12.5949, 46.6568],
  [12.6036, 46.6561],
  [12.6083, 46.658],
  [12.6129, 46.6583],
  [12.6192, 46.6619],
  [12.6222, 46.6613],
  [12.6251, 46.6617],
  [12.628, 46.6607],
  [12.631, 46.6614],
  [12.632, 46.6595],
  [12.6321, 46.657],
  [12.6336, 46.655],
  [12.6369, 46.6537],
  [12.6399, 46.6536],
  [12.6417, 46.652],
  [12.6445, 46.6528],
  [12.6506, 46.6531],
  [12.652, 46.6546],
  [12.6539, 46.6557],
  [12.6557, 46.6556],
  [12.6579, 46.6573],
  [12.6604, 46.657],
  [12.6655, 46.6579],
  [12.6695, 46.6573],
  [12.6757, 46.6576],
  [12.682, 46.6559],
  [12.6864, 46.657],
  [12.6906, 46.657],
  [12.6917, 46.6555],
  [12.6948, 46.6535],
  [12.6995, 46.6515],
  [12.7077, 46.6499],
  [12.7104, 46.6502],
  [12.7132, 46.6489],
  [12.7159, 46.6492],
  [12.7167, 46.6487],
  [12.7167, 46.6469],
  [12.7193, 46.646],
  [12.7188, 46.6453],
  [12.7194, 46.644],
  [12.7216, 46.6417],
  [12.7268, 46.6404],
  [12.7286, 46.6379],
  [12.7281, 46.6368],
  [12.7287, 46.6359],
  [12.7314, 46.6343],
  [12.735, 46.6357],
  [12.7354, 46.635],
  [12.7378, 46.6349],
  [12.7402, 46.6365],
  [12.7451, 46.6378],
  [12.7456, 46.6383],
  [12.7452, 46.6386],
  [12.7454, 46.6402],
  [12.7475, 46.643],
  [12.751, 46.6454],
  [12.7536, 46.6456],
  [12.7564, 46.6472],
  [12.7626, 46.648],
  [12.7665, 46.6464],
  [12.7759, 46.6467],
  [12.78, 46.6454],
  [12.7844, 46.645],
  [12.7869, 46.6438],
  [12.7954, 46.6424],
  [12.796, 46.6386],
  [12.8017, 46.6345],
  [12.8091, 46.6311],
  [12.8166, 46.6314],
  [12.8167, 46.6307],
  [12.8154, 46.6301],
  [12.8171, 46.6297],
  [12.819, 46.6282],
  [12.823, 46.6289],
  [12.8243, 46.6298],
  [12.8274, 46.63],
  [12.8291, 46.6313],
  [12.8313, 46.6313],
  [12.8309, 46.629],
  [12.8373, 46.6273],
  [12.8351, 46.623],
  [12.8334, 46.6214],
  [12.8342, 46.6199],
  [12.8335, 46.6169],
  [12.8345, 46.6143],
  [12.8331, 46.6122],
  [12.8337, 46.6099],
  [12.8373, 46.608],
  [12.8415, 46.6072],
  [12.8426, 46.6064],
  [12.8504, 46.6056],
  [12.8527, 46.6046],
  [12.8605, 46.6063],
  [12.8654, 46.6099],
  [12.8731, 46.6075],
  [12.8774, 46.6092],
  [12.8821, 46.6071],
  [12.8868, 46.6073],
  [12.8881, 46.6066],
  [12.891, 46.6073],
  [12.8918, 46.6081],
  [12.8939, 46.6081],
  [12.8962, 46.6095],
  [12.8991, 46.6097],
  [12.9051, 46.6076],
  [12.908, 46.6081],
  [12.91, 46.6097],
  [12.9204, 46.6087],
  [12.9242, 46.609],
  [12.9279, 46.6106],
  [12.933, 46.6099],
  [12.934, 46.6083],
  [12.9359, 46.6079],
  [12.9396, 46.6055],
  [12.9489, 46.6022],
  [12.951, 46.6034],
  [12.9506, 46.6042],
  [12.9535, 46.6045],
  [12.9543, 46.6055],
  [12.9559, 46.6054],
  [12.9565, 46.6065],
  [12.96, 46.6052],
  [12.9609, 46.6055],
  [12.9617, 46.6046],
  [12.9667, 46.6051],
  [12.9685, 46.6034],
  [12.9698, 46.6032],
  [12.9714, 46.6038],
  [12.9717, 46.6022],
  [12.9729, 46.6027],
  [12.974, 46.6021],
  [12.9742, 46.6027],
  [12.9755, 46.6017],
  [12.9769, 46.6018],
  [12.9776, 46.6007],
  [12.98, 46.6019],
  [12.982, 46.6022],
  [12.9823, 46.6012],
  [12.9834, 46.6005],
  [12.9872, 46.5994],
  [12.9916, 46.5997],
  [12.993, 46.6008],
  [12.9931, 46.6017],
  [12.9951, 46.6014],
  [12.9992, 46.6025],
  [13.0017, 46.6023],
  [13.0074, 46.5992],
  [13.017, 46.6019],
  [13.0206, 46.6006],
  [13.0215, 46.6022],
  [13.0259, 46.5999],
  [13.0259, 46.5993],
  [13.0274, 46.5985],
  [13.0276, 46.5972],
  [13.0326, 46.596],
  [13.0334, 46.5966],
  [13.041, 46.5972],
  [13.0466, 46.5953],
  [13.049, 46.5956],
  [13.0517, 46.597],
  [13.0561, 46.5976],
  [13.0605, 46.5969],
  [13.0613, 46.5972],
  [13.0624, 46.5995],
  [13.0634, 46.5999],
  [13.0686, 46.5989],
  [13.0704, 46.5997],
  [13.0725, 46.5988],
  [13.074, 46.5996],
  [13.0774, 46.5997],
  [13.079, 46.5991],
  [13.0824, 46.6],
  [13.0822, 46.6007],
  [13.0835, 46.602],
  [13.0856, 46.6018],
  [13.0923, 46.6004],
  [13.0967, 46.5973],
  [13.1059, 46.5944],
  [13.109, 46.596],
  [13.1128, 46.595],
  [13.1139, 46.5939],
  [13.1177, 46.5942],
  [13.1218, 46.5917],
  [13.1258, 46.5909],
  [13.1283, 46.5919],
  [13.1303, 46.5907],
  [13.1305, 46.5912],
  [13.1331, 46.5917],
  [13.1347, 46.5908],
  [13.1377, 46.5913],
  [13.1379, 46.5907],
  [13.1421, 46.5898],
  [13.1438, 46.5876],
  [13.1463, 46.5871],
  [13.1509, 46.59],
  [13.1532, 46.5888],
  [13.1553, 46.5891],
  [13.1626, 46.5882],
  [13.1655, 46.5893],
  [13.1686, 46.5889],
  [13.1692, 46.586],
  [13.1686, 46.585],
  [13.1745, 46.5827],
  [13.175, 46.5819],
  [13.1771, 46.5817],
  [13.1774, 46.5795],
  [13.1788, 46.5791],
  [13.1791, 46.5778],
  [13.1858, 46.5763],
  [13.1932, 46.5723],
  [13.1973, 46.5714],
  [13.2033, 46.5723],
  [13.2041, 46.5714],
  [13.209, 46.5693],
  [13.2174, 46.5705],
  [13.2188, 46.5695],
  [13.2188, 46.5681],
  [13.2207, 46.5659],
  [13.2265, 46.5642],
  [13.2289, 46.561],
  [13.2324, 46.559],
  [13.2326, 46.5536],
  [13.2361, 46.5536],
  [13.2398, 46.5517],
  [13.2401, 46.5536],
  [13.2412, 46.5555],
  [13.2422, 46.5561],
  [13.246, 46.556],
  [13.2488, 46.5592],
  [13.2517, 46.5597],
  [13.2526, 46.5604],
  [13.2558, 46.5599],
  [13.2565, 46.559],
  [13.261, 46.5573],
  [13.2695, 46.5613],
  [13.2733, 46.5609],
  [13.2745, 46.5599],
  [13.2769, 46.5601],
  [13.2792, 46.559],
  [13.2813, 46.559],
  [13.2824, 46.5582],
  [13.2846, 46.558],
  [13.2853, 46.5571],
  [13.2878, 46.5592],
  [13.295, 46.5605],
  [13.2976, 46.5603],
  [13.3072, 46.5546],
  [13.3121, 46.5531],
  [13.3138, 46.5535],
  [13.3139, 46.5528],
  [13.3152, 46.5524],
  [13.32, 46.5529],
  [13.3206, 46.5512],
  [13.322, 46.5523],
  [13.3231, 46.5545],
  [13.326, 46.5556],
  [13.3277, 46.5581],
  [13.332, 46.5595],
  [13.3323, 46.5608],
  [13.3354, 46.5634],
  [13.3382, 46.5637],
  [13.3394, 46.5664],
  [13.3425, 46.5678],
  [13.3447, 46.57],
  [13.3458, 46.5685],
  [13.3484, 46.5674],
  [13.3501, 46.5677],
  [13.3525, 46.5665],
  [13.3562, 46.5685],
  [13.3629, 46.5701],
  [13.3669, 46.569],
  [13.3705, 46.567],
  [13.3709, 46.5673],
  [13.3702, 46.5711],
  [13.3684, 46.5738],
  [13.371, 46.5766],
  [13.3722, 46.5793],
  [13.3819, 46.5769],
  [13.3886, 46.5767],
  [13.4017, 46.5717],
  [13.4099, 46.5721],
  [13.4079, 46.5685],
  [13.407, 46.5643],
  [13.4075, 46.5615],
  [13.4164, 46.5604],
  [13.4187, 46.5592],
  [13.4232, 46.5588],
  [13.4266, 46.5576],
  [13.4366, 46.5592],
  [13.4388, 46.559],
  [13.4398, 46.5578],
  [13.442, 46.5568],
  [13.446, 46.5565],
  [13.4497, 46.5574],
  [13.4508, 46.559],
  [13.4539, 46.5595],
  [13.4548, 46.5589],
  [13.4613, 46.5585],
  [13.4622, 46.5591],
  [13.4691, 46.5574],
  [13.4747, 46.5573],
  [13.4763, 46.5594],
  [13.4784, 46.5607],
  [13.4831, 46.561],
  [13.4957, 46.5644],
  [13.499, 46.5659],
  [13.5043, 46.5663],
  [13.5071, 46.5601],
  [13.5072, 46.5587],
  [13.5055, 46.5571],
  [13.5054, 46.5559],
  [13.5115, 46.5554],
  [13.5119, 46.5522],
  [13.5149, 46.5486],
  [13.5199, 46.5469],
  [13.5296, 46.5494],
  [13.5349, 46.5497],
  [13.5364, 46.551],
  [13.5383, 46.5514],
  [13.5392, 46.5529],
  [13.5411, 46.5528],
  [13.5427, 46.5536],
  [13.5461, 46.5536],
  [13.5508, 46.5522],
  [13.5575, 46.5513],
  [13.5613, 46.5518],
  [13.5637, 46.5511],
  [13.5643, 46.5486],
  [13.5666, 46.548],
  [13.5685, 46.5465],
  [13.5699, 46.541],
  [13.5693, 46.5397],
  [13.5709, 46.5389],
  [13.5766, 46.538],
  [13.5829, 46.5397],
  [13.5837, 46.5418],
  [13.5853, 46.5427],
  [13.5856, 46.5436],
  [13.5872, 46.5446],
  [13.5912, 46.5453],
  [13.592, 46.5462],
  [13.5974, 46.5457],
  [13.6009, 46.5432],
  [13.6028, 46.5429],
  [13.6106, 46.5436],
  [13.6138, 46.5425],
  [13.6229, 46.5421],
  [13.6279, 46.5413],
  [13.6318, 46.5384],
  [13.6407, 46.5348],
  [13.643, 46.5326],
  [13.6439, 46.5323],
  [13.6444, 46.5332],
  [13.6465, 46.5331],
  [13.6584, 46.5293],
  [13.659, 46.5277],
  [13.6627, 46.5268],
  [13.6667, 46.5268],
  [13.6695, 46.5251],
  [13.6712, 46.5249],
  [13.6731, 46.5231],
  [13.6738, 46.5235],
  [13.6788, 46.5228],
  [13.6804, 46.5217],
  [13.6877, 46.5218],
  [13.6911, 46.521],
  [13.694, 46.5219],
  [13.6944, 46.5226],
  [13.6983, 46.5233],
  [13.7026, 46.5224],
  [13.7053, 46.521],
  [13.7085, 46.521],
  [13.7104, 46.5212],
  [13.7137, 46.523],
  [13.7173, 46.5226],
  [13.7215, 46.5235],
  [13.7258, 46.5231],
  [13.7262, 46.522],
  [13.7374, 46.5171],
  [13.7477, 46.5172],
  [13.7541, 46.518],
  [13.7663, 46.5145],
  [13.7677, 46.5156],
  [13.7713, 46.5164],
  [13.7744, 46.516],
  [13.7764, 46.5176],
  [13.7781, 46.5174],
  [13.7787, 46.5171],
  [13.7802, 46.5121],
  [13.785, 46.5107],
  [13.7898, 46.5077],
  [13.792, 46.5079],
  [13.7945, 46.5053],
  [13.7983, 46.5065],
  [13.8046, 46.507],
  [13.8122, 46.5062],
  [13.8153, 46.5076],
  [13.8173, 46.5101],
  [13.8209, 46.5105],
  [13.8221, 46.5127],
  [13.8271, 46.5136],
  [13.8292, 46.5153],
  [13.8286, 46.5169],
  [13.8313, 46.5187],
  [13.8343, 46.5184],
  [13.8355, 46.517],
  [13.8379, 46.516],
  [13.842, 46.516],
  [13.8478, 46.5143],
  [13.852, 46.5145],
  [13.8553, 46.5139],
  [13.8586, 46.5143],
  [13.8606, 46.5154],
  [13.8624, 46.5151],
  [13.867, 46.518],
  [13.8714, 46.5192],
  [13.8748, 46.5187],
  [13.8772, 46.5195],
  [13.8788, 46.5191],
  [13.8803, 46.5203],
  [13.882, 46.5228],
  [13.8875, 46.521],
  [13.8924, 46.5212],
  [13.8957, 46.5193],
  [13.9012, 46.5188],
  [13.9067, 46.5193],
  [13.9088, 46.5206],
  [13.9121, 46.5211],
  [13.9232, 46.5186],
  [13.9254, 46.517],
  [13.928, 46.5138],
  [13.9312, 46.5137],
  [13.9375, 46.5122],
  [13.9381, 46.5115],
  [13.943, 46.5115],
  [13.9486, 46.5081],
  [13.9525, 46.5074],
  [13.9525, 46.5063],
  [13.9598, 46.5029],
  [13.9611, 46.5007],
  [13.9697, 46.4968],
  [13.9733, 46.4971],
  [13.9756, 46.4983],
  [13.9795, 46.4961],
  [13.9829, 46.4953],
  [13.9859, 46.4933],
  [13.9888, 46.4929],
  [13.9895, 46.4883],
  [13.9924, 46.4873],
  [13.9941, 46.4877],
  [13.9979, 46.487],
  [14.0037, 46.4827],
  [14.0065, 46.4814],
  [14.0133, 46.4821],
  [14.0191, 46.4814],
  [14.0209, 46.4816],
  [14.0244, 46.4834],
  [14.0249, 46.4851],
  [14.026, 46.486],
  [14.0273, 46.4861],
  [14.0278, 46.4868],
  [14.031, 46.4869],
  [14.032, 46.4894],
  [14.036, 46.4917],
  [14.0406, 46.493],
  [14.0451, 46.4924],
  [14.0508, 46.4932],
  [14.0536, 46.4915],
  [14.0579, 46.4906],
  [14.0584, 46.49],
  [14.0653, 46.4895],
  [14.0671, 46.4883],
  [14.0705, 46.4872],
  [14.0837, 46.4861],
  [14.086, 46.4866],
  [14.0883, 46.4853],
  [14.0915, 46.4857],
  [14.0946, 46.4849],
  [14.0961, 46.4836],
  [14.0996, 46.4819],
  [14.1, 46.4815],
  [14.0993, 46.4801],
  [14.1019, 46.4789],
  [14.1057, 46.4799],
  [14.1215, 46.4766],
  [14.1202, 46.475],
  [14.1204, 46.4742],
  [14.1244, 46.472],
  [14.1295, 46.4664],
  [14.1283, 46.4651],
  [14.1309, 46.4619],
  [14.1329, 46.461],
  [14.1352, 46.4586],
  [14.136, 46.454],
  [14.135, 46.451],
  [14.1381, 46.4486],
  [14.1404, 46.4483],
  [14.1421, 46.4461],
  [14.1444, 46.4458],
  [14.1446, 46.4451],
  [14.1482, 46.4431],
  [14.1513, 46.443],
  [14.1522, 46.4409],
  [14.1518, 46.4404],
  [14.1525, 46.4373],
  [14.1543, 46.4365],
  [14.1546, 46.4357],
  [14.1632, 46.4336],
  [14.1695, 46.4331],
  [14.1728, 46.434],
  [14.1765, 46.434],
  [14.1777, 46.4348],
  [14.1786, 46.4369],
  [14.1805, 46.4383],
  [14.1831, 46.4382],
  [14.1893, 46.4407],
  [14.1895, 46.4414],
  [14.1913, 46.4422],
  [14.1911, 46.4439],
  [14.1922, 46.4425],
  [14.1947, 46.4422],
  [14.1958, 46.4411],
  [14.2013, 46.4407],
  [14.2069, 46.4393],
  [14.2125, 46.4399],
  [14.2133, 46.4419],
  [14.2146, 46.4423],
  [14.2148, 46.443],
  [14.2172, 46.4425],
  [14.2193, 46.4432],
  [14.2197, 46.4425],
  [14.2217, 46.442],
  [14.2237, 46.4406],
  [14.2243, 46.4387],
  [14.227, 46.4359],
  [14.2309, 46.4339],
  [14.2344, 46.4334],
  [14.2372, 46.4322],
  [14.2386, 46.4331],
  [14.2486, 46.4345],
  [14.2546, 46.4372],
  [14.2565, 46.439],
  [14.2617, 46.4393],
  [14.2645, 46.4383],
  [14.2659, 46.4393],
  [14.2681, 46.4394],
  [14.2692, 46.4409],
  [14.2718, 46.4417],
  [14.2785, 46.443],
  [14.2812, 46.4427],
  [14.2832, 46.4435],
  [14.2944, 46.4394],
  [14.3016, 46.4383],
  [14.3028, 46.4374],
  [14.3031, 46.4354],
  [14.3081, 46.4306],
  [14.3111, 46.4304],
  [14.3167, 46.4315],
  [14.3185, 46.431],
  [14.32, 46.4316],
  [14.3262, 46.431],
  [14.3322, 46.4319],
  [14.3379, 46.435],
  [14.341, 46.4352],
  [14.3441, 46.4374],
  [14.3475, 46.4369],
  [14.3504, 46.4377],
  [14.352, 46.4373],
  [14.3551, 46.4379],
  [14.3565, 46.4387],
  [14.3645, 46.4382],
  [14.3676, 46.4387],
  [14.3685, 46.4398],
  [14.3821, 46.4391],
  [14.3964, 46.4439],
  [14.4088, 46.4454],
  [14.4096, 46.4464],
  [14.4113, 46.4464],
  [14.4123, 46.4455],
  [14.4235, 46.4454],
  [14.4296, 46.447],
  [14.4347, 46.4428],
  [14.4384, 46.4429],
  [14.4387, 46.4408],
  [14.4321, 46.4394],
  [14.4302, 46.4372],
  [14.4301, 46.4361],
  [14.4313, 46.4342],
  [14.434, 46.4331],
  [14.4351, 46.4312],
  [14.4377, 46.4308],
  [14.4422, 46.4281],
  [14.4415, 46.4255],
  [14.4426, 46.4231],
  [14.4468, 46.4216],
  [14.4515, 46.4225],
  [14.4579, 46.4211],
  [14.4668, 46.422],
  [14.4734, 46.4197],
  [14.4764, 46.4198],
  [14.4779, 46.4186],
  [14.4782, 46.4145],
  [14.4789, 46.4135],
  [14.4816, 46.4138],
  [14.4845, 46.4154],
  [14.4922, 46.4129],
  [14.4975, 46.4189],
  [14.5001, 46.4201],
  [14.5026, 46.4203],
  [14.5032, 46.4229],
  [14.5056, 46.4242],
  [14.5101, 46.4259],
  [14.5166, 46.4262],
  [14.5218, 46.4273],
  [14.5221, 46.4238],
  [14.5318, 46.4155],
  [14.5321, 46.4146],
  [14.5361, 46.4142],
  [14.5399, 46.4116],
  [14.541, 46.4068],
  [14.5405, 46.4063],
  [14.5421, 46.4036],
  [14.5479, 46.399],
  [14.5475, 46.3981],
  [14.5507, 46.3961],
  [14.5537, 46.3916],
  [14.5546, 46.3878],
  [14.5568, 46.3852],
  [14.5569, 46.3838],
  [14.556, 46.3832],
  [14.5568, 46.3816],
  [14.5559, 46.3787],
  [14.5573, 46.3776],
  [14.5569, 46.3765],
  [14.5584, 46.3752],
  [14.561, 46.3746],
  [14.5616, 46.3733],
  [14.5641, 46.3723],
  [14.5652, 46.3725],
  [14.5651, 46.3739],
  [14.5661, 46.375],
  [14.569, 46.3758],
  [14.5729, 46.3755],
  [14.5782, 46.377],
  [14.5789, 46.3788],
  [14.5803, 46.3795],
  [14.5817, 46.3817],
  [14.5816, 46.3822],
  [14.5786, 46.3832],
  [14.5787, 46.3841],
  [14.5804, 46.3861],
  [14.584, 46.3884],
  [14.5841, 46.3899],
  [14.5861, 46.3923],
  [14.5857, 46.3929],
  [14.5876, 46.396],
  [14.5867, 46.3979],
  [14.5872, 46.4006],
  [14.5866, 46.4042],
  [14.5883, 46.4056],
  [14.5885, 46.4081],
  [14.5894, 46.4096],
  [14.5884, 46.4114],
  [14.5886, 46.4144],
  [14.5833, 46.4159],
  [14.5825, 46.4181],
  [14.5838, 46.419],
  [14.5844, 46.4241],
  [14.5867, 46.428],
  [14.5864, 46.4297],
  [14.5918, 46.4313],
  [14.5954, 46.4332],
  [14.5963, 46.4341],
  [14.596, 46.4368],
  [14.6047, 46.4369],
  [14.6052, 46.4379],
  [14.6074, 46.4391],
  [14.6131, 46.4398],
  [14.6154, 46.4399],
  [14.6178, 46.4389],
  [14.6222, 46.4387],
  [14.6315, 46.4395],
  [14.6371, 46.4411],
  [14.6409, 46.443],
  [14.644, 46.4428],
  [14.6443, 46.4434],
  [14.6524, 46.445],
  [14.6553, 46.4442],
  [14.6597, 46.4445],
  [14.6632, 46.4462],
  [14.6647, 46.4487],
  [14.6666, 46.45],
  [14.671, 46.4511],
  [14.6748, 46.4507],
  [14.6761, 46.4542],
  [14.6793, 46.4578],
  [14.6763, 46.4605],
  [14.6756, 46.4618],
  [14.6786, 46.4627],
  [14.6807, 46.4656],
  [14.6832, 46.4679],
  [14.6856, 46.466],
  [14.6893, 46.4644],
  [14.6942, 46.4638],
  [14.6976, 46.4645],
  [14.6994, 46.4637],
  [14.701, 46.4655],
  [14.7009, 46.4662],
  [14.7024, 46.4673],
  [14.7011, 46.4692],
  [14.7015, 46.4709],
  [14.7011, 46.4716],
  [14.6996, 46.4722],
  [14.6976, 46.4745],
  [14.7014, 46.4782],
  [14.7021, 46.4804],
  [14.7045, 46.4802],
  [14.7092, 46.4809],
  [14.7117, 46.4894],
  [14.7117, 46.4917],
  [14.7106, 46.4927],
  [14.7133, 46.4949],
  [14.7148, 46.5],
  [14.7219, 46.4982],
  [14.725, 46.4944],
  [14.7277, 46.4928],
  [14.7284, 46.4903],
  [14.7309, 46.4928],
  [14.731, 46.4939],
  [14.7351, 46.4975],
  [14.7377, 46.5031],
  [14.7413, 46.5052],
  [14.7437, 46.5035],
  [14.7451, 46.5032],
  [14.7461, 46.5011],
  [14.7473, 46.5008],
  [14.7471, 46.4991],
  [14.7483, 46.4976],
  [14.76, 46.5045],
  [14.763, 46.5039],
  [14.7689, 46.5046],
  [14.773, 46.5039],
  [14.7768, 46.5046],
  [14.7774, 46.5031],
  [14.7798, 46.5004],
  [14.7809, 46.5014],
  [14.7831, 46.501],
  [14.7841, 46.4997],
  [14.7855, 46.4995],
  [14.7945, 46.5035],
  [14.7988, 46.5041],
  [14.806, 46.5076],
  [14.8146, 46.5082],
  [14.8186, 46.5094],
  [14.8192, 46.511],
  [14.8191, 46.5134],
  [14.8181, 46.5173],
  [14.8193, 46.5195],
  [14.8177, 46.5206],
  [14.8176, 46.522],
  [14.8221, 46.5246],
  [14.8225, 46.5273],
  [14.8252, 46.5298],
  [14.8227, 46.5323],
  [14.8229, 46.5356],
  [14.8235, 46.5364],
  [14.8261, 46.5362],
  [14.8281, 46.5378],
  [14.831, 46.5385],
  [14.8319, 46.5393],
  [14.8303, 46.5399],
  [14.8277, 46.5423],
  [14.823, 46.5433],
  [14.8231, 46.5459],
  [14.8255, 46.5457],
  [14.8253, 46.5467],
  [14.8261, 46.5481],
  [14.8277, 46.5478],
  [14.8291, 46.5486],
  [14.8313, 46.5479],
  [14.8323, 46.5485],
  [14.832, 46.5512],
  [14.8346, 46.5523],
  [14.8343, 46.5537],
  [14.8366, 46.5558],
  [14.8381, 46.5587],
  [14.8372, 46.5612],
  [14.8345, 46.5632],
  [14.8363, 46.5657],
  [14.8379, 46.5664],
  [14.8402, 46.5659],
  [14.8394, 46.5673],
  [14.8379, 46.568],
  [14.838, 46.5691],
  [14.8398, 46.5713],
  [14.8403, 46.5728],
  [14.8437, 46.5757],
  [14.8437, 46.577],
  [14.8446, 46.5776],
  [14.8482, 46.5798],
  [14.852, 46.5807],
  [14.8521, 46.5826],
  [14.8562, 46.5868],
  [14.8559, 46.5879],
  [14.8571, 46.5915],
  [14.8565, 46.5921],
  [14.8615, 46.5939],
  [14.8648, 46.5933],
  [14.8649, 46.5948],
  [14.8666, 46.5967],
  [14.8676, 46.5994],
  [14.8665, 46.6006],
  [14.8666, 46.6033],
  [14.8673, 46.6047],
  [14.8704, 46.6072],
  [14.873, 46.6075],
  [14.8741, 46.6084],
  [14.8787, 46.6083],
  [14.8803, 46.6098],
  [14.8804, 46.6107],
  [14.8796, 46.6112],
  [14.8844, 46.6118],
  [14.8864, 46.6127],
  [14.8898, 46.6127],
  [14.8905, 46.612],
  [14.8964, 46.6102],
  [14.9009, 46.612],
  [14.901, 46.6108],
  [14.9002, 46.6095],
  [14.9041, 46.6072],
  [14.9048, 46.6059],
  [14.9045, 46.6049],
  [14.9086, 46.6051],
  [14.9114, 46.6041],
  [14.9135, 46.6043],
  [14.9138, 46.6063],
  [14.916, 46.6056],
  [14.9189, 46.6019],
  [14.9196, 46.6021],
  [14.923, 46.6033],
  [14.9236, 46.6047],
  [14.9217, 46.6066],
  [14.9226, 46.611],
  [14.9216, 46.6125],
  [14.9212, 46.6156],
  [14.9204, 46.6163],
  [14.9205, 46.6174],
  [14.9228, 46.62],
  [14.9229, 46.6209],
  [14.9283, 46.6192],
  [14.9312, 46.6153],
  [14.9336, 46.6163],
  [14.937, 46.6202],
  [14.9399, 46.6196],
  [14.9418, 46.6207],
  [14.9421, 46.6212],
  [14.9415, 46.6214],
  [14.9438, 46.6229],
  [14.9434, 46.6232],
  [14.9478, 46.6258],
  [14.9512, 46.6287],
  [14.9506, 46.6291],
  [14.9518, 46.63],
  [14.9531, 46.63],
  [14.9557, 46.6327],
  [14.9671, 46.6279],
  [14.971, 46.624],
  [14.9739, 46.6171],
  [14.9748, 46.6085],
  [14.9769, 46.6043],
  [14.9794, 46.6014],
  [14.9846, 46.6036],
  [14.9847, 46.6044],
  [14.9862, 46.605],
  [14.9869, 46.6063],
  [14.9867, 46.6085],
  [14.995, 46.6139],
  [14.9962, 46.6159],
  [14.9944, 46.6178],
  [14.995, 46.6192],
  [14.9946, 46.6212],
  [14.9986, 46.624],
  [15.0004, 46.6266],
  [15.0043, 46.6288],
  [15.0064, 46.6308],
  [15.0064, 46.6321],
  [15.0079, 46.6334],
  [15.0117, 46.6347],
  [15.0132, 46.6377],
  [15.0152, 46.6389],
  [15.0162, 46.6408],
  [15.0296, 46.6449],
  [15.034, 46.6489],
  [15.0396, 46.6504],
  [15.041, 46.6518],
  [15.0651, 46.652],
  [15.0706, 46.6499],
  [15.0748, 46.6498],
  [15.0824, 46.6452],
  [15.0851, 46.6483],
  [15.089, 46.6514],
  [15.0879, 46.652],
  [15.0988, 46.6534],
  [15.1002, 46.6548],
  [15.1004, 46.6561],
  [15.1065, 46.6585],
  [15.1075, 46.6597],
  [15.1106, 46.6597],
  [15.1162, 46.657],
  [15.1147, 46.656],
  [15.1163, 46.6548],
  [15.1187, 46.6543],
  [15.1187, 46.6538],
  [15.1196, 46.6539],
  [15.1215, 46.656],
  [15.1213, 46.6545],
  [15.1247, 46.654],
  [15.1264, 46.653],
  [15.1264, 46.6509],
  [15.1286, 46.65],
  [15.1312, 46.6506],
  [15.1323, 46.652],
  [15.1321, 46.6532],
  [15.1332, 46.6539],
  [15.1338, 46.6563],
  [15.1345, 46.6568],
  [15.1378, 46.6578],
  [15.1402, 46.6564],
  [15.1422, 46.6572],
  [15.1432, 46.6594],
  [15.1453, 46.6598],
  [15.1503, 46.6583],
  [15.1526, 46.6582],
  [15.1548, 46.6559],
  [15.1559, 46.6557],
  [15.1622, 46.6577],
  [15.1645, 46.6573],
  [15.1657, 46.6551],
  [15.1671, 46.6541],
  [15.1732, 46.6542],
  [15.1747, 46.6555],
  [15.1762, 46.6552],
  [15.1823, 46.6561],
  [15.1864, 46.6536],
  [15.1893, 46.6528],
  [15.1916, 46.6507],
  [15.1919, 46.6486],
  [15.1974, 46.6457],
  [15.2017, 46.6449],
  [15.2061, 46.6452],
  [15.209, 46.6439],
  [15.2163, 46.6432],
  [15.2181, 46.6422],
  [15.2243, 46.6434],
  [15.2359, 46.6394],
  [15.2413, 46.6401],
  [15.244, 46.6418],
  [15.2535, 46.6421],
  [15.2625, 46.6447],
  [15.2678, 46.6447],
  [15.2704, 46.6439],
  [15.2774, 46.6436],
  [15.2822, 46.6452],
  [15.2841, 46.648],
  [15.2895, 46.6495],
  [15.294, 46.6525],
  [15.3011, 46.6532],
  [15.3113, 46.6521],
  [15.3146, 46.6502],
  [15.3155, 46.6491],
  [15.3194, 46.6478],
  [15.3216, 46.648],
  [15.3224, 46.6492],
  [15.3243, 46.6499],
  [15.3237, 46.6504],
  [15.328, 46.6532],
  [15.3319, 46.6524],
  [15.3338, 46.6532],
  [15.3378, 46.6532],
  [15.3405, 46.651],
  [15.3442, 46.6508],
  [15.3442, 46.6514],
  [15.3477, 46.6537],
  [15.3537, 46.655],
  [15.3554, 46.6536],
  [15.3557, 46.6515],
  [15.3681, 46.6513],
  [15.3701, 46.6499],
  [15.3723, 46.6497],
  [15.3747, 46.6506],
  [15.3759, 46.6519],
  [15.3811, 46.6523],
  [15.3834, 46.6515],
  [15.3885, 46.6529],
  [15.3943, 46.6519],
  [15.3981, 46.6533],
  [15.4141, 46.6555],
  [15.4169, 46.6548],
  [15.4204, 46.6549],
  [15.4217, 46.6533],
  [15.4233, 46.6527],
  [15.4232, 46.6509],
  [15.4217, 46.65],
  [15.4217, 46.6472],
  [15.4237, 46.6475],
  [15.4302, 46.6467],
  [15.4337, 46.6424],
  [15.4394, 46.6399],
  [15.4418, 46.6399],
  [15.4496, 46.6423],
  [15.4532, 46.6401],
  [15.4569, 46.639],
  [15.4558, 46.6377],
  [15.4563, 46.6365],
  [15.4551, 46.6329],
  [15.4559, 46.6313],
  [15.4551, 46.6301],
  [15.4572, 46.6293],
  [15.4576, 46.6282],
  [15.4593, 46.6273],
  [15.4597, 46.6262],
  [15.4621, 46.6259],
  [15.4637, 46.623],
  [15.4639, 46.6196],
  [15.4622, 46.6179],
  [15.4621, 46.6153],
  [15.4665, 46.6144],
  [15.4691, 46.6128],
  [15.4701, 46.6134],
  [15.4726, 46.6121],
  [15.4747, 46.612],
  [15.4795, 46.6138],
  [15.4828, 46.6166],
  [15.4837, 46.6188],
  [15.4871, 46.6198],
  [15.4882, 46.6207],
  [15.4927, 46.6204],
  [15.4954, 46.6187],
  [15.4996, 46.6182],
  [15.5006, 46.6176],
  [15.4999, 46.6165],
  [15.5004, 46.6147],
  [15.5023, 46.6139],
  [15.504, 46.6143],
  [15.5036, 46.6152],
  [15.5045, 46.616],
  [15.5104, 46.6159],
  [15.5118, 46.6166],
  [15.5112, 46.6178],
  [15.5116, 46.6188],
  [15.5101, 46.6201],
  [15.5118, 46.6218],
  [15.5155, 46.6234],
  [15.5188, 46.6214],
  [15.5202, 46.6216],
  [15.5229, 46.6231],
  [15.5233, 46.6244],
  [15.5256, 46.6266],
  [15.5296, 46.6283],
  [15.5303, 46.6301],
  [15.5339, 46.6313],
  [15.534, 46.6323],
  [15.5371, 46.6339],
  [15.5388, 46.6343],
  [15.5407, 46.6338],
  [15.5424, 46.63],
  [15.5435, 46.6322],
  [15.5456, 46.6332],
  [15.545, 46.6348],
  [15.5461, 46.637],
  [15.5498, 46.6385],
  [15.5511, 46.6403],
  [15.5471, 46.6419],
  [15.547, 46.6428],
  [15.5456, 46.6424],
  [15.5457, 46.6429],
  [15.5444, 46.6436],
  [15.5447, 46.6455],
  [15.5439, 46.6461],
  [15.5459, 46.6472],
  [15.5468, 46.6487],
  [15.5515, 46.6477],
  [15.5527, 46.6488],
  [15.5535, 46.6514],
  [15.553, 46.6515],
  [15.553, 46.653],
  [15.5519, 46.654],
  [15.5517, 46.6551],
  [15.5504, 46.6558],
  [15.5504, 46.6568],
  [15.5485, 46.6589],
  [15.548, 46.6649],
  [15.546, 46.6647],
  [15.5459, 46.666],
  [15.5468, 46.6669],
  [15.5442, 46.6683],
  [15.5437, 46.6693],
  [15.5463, 46.6702],
  [15.5472, 46.6693],
  [15.5479, 46.6708],
  [15.551, 46.6726],
  [15.5509, 46.6721],
  [15.553, 46.6712],
  [15.5536, 46.6722],
  [15.5532, 46.6726],
  [15.5579, 46.671],
  [15.5592, 46.6711],
  [15.5599, 46.6735],
  [15.5627, 46.675],
  [15.5648, 46.6758],
  [15.5674, 46.6753],
  [15.5681, 46.6803],
  [15.5695, 46.6799],
  [15.5702, 46.6809],
  [15.5733, 46.68],
  [15.5747, 46.6815],
  [15.5757, 46.6808],
  [15.5781, 46.6809],
  [15.5776, 46.6832],
  [15.5795, 46.6833],
  [15.5823, 46.682],
  [15.5863, 46.6843],
  [15.59, 46.6833],
  [15.5907, 46.6843],
  [15.5899, 46.6861],
  [15.5911, 46.6864],
  [15.5951, 46.69],
  [15.6002, 46.69],
  [15.604, 46.6882],
  [15.6085, 46.6877],
  [15.6067, 46.6865],
  [15.6055, 46.6871],
  [15.605, 46.6866],
  [15.6056, 46.6854],
  [15.6039, 46.6839],
  [15.6053, 46.6811],
  [15.6096, 46.683],
  [15.6114, 46.6821],
  [15.6116, 46.6831],
  [15.6132, 46.6834],
  [15.6137, 46.6822],
  [15.6152, 46.6824],
  [15.6199, 46.6798],
  [15.6218, 46.6807],
  [15.623, 46.6796],
  [15.63, 46.68],
  [15.6298, 46.6806],
  [15.6315, 46.6812],
  [15.634, 46.6812],
  [15.6331, 46.6817],
  [15.6322, 46.6846],
  [15.6341, 46.686],
  [15.6344, 46.6884],
  [15.6387, 46.6914],
  [15.6412, 46.6924],
  [15.6433, 46.6902],
  [15.6471, 46.6911],
  [15.6472, 46.6917],
  [15.6494, 46.6919],
  [15.6527, 46.6912],
  [15.6536, 46.6921],
  [15.6542, 46.6951],
  [15.6541, 46.6994],
  [15.6511, 46.7026],
  [15.6498, 46.7051],
  [15.65, 46.7058],
  [15.6718, 46.707],
  [15.6763, 46.7067],
  [15.6838, 46.7045],
  [15.6958, 46.6988],
  [15.7063, 46.6981],
  [15.7216, 46.6958],
  [15.7257, 46.6962],
  [15.7393, 46.6999],
  [15.7436, 46.6998],
  [15.7538, 46.6979],
  [15.762, 46.6994],
  [15.7685, 46.699],
  [15.7714, 46.6999],
  [15.7776, 46.7035],
  [15.7876, 46.7081],
  [15.796, 46.7132],
  [15.8007, 46.7151],
  [15.8216, 46.7201],
  [15.8326, 46.722],
  [15.8397, 46.7224],
  [15.8588, 46.7223],
  [15.8713, 46.7209],
  [15.8803, 46.7188],
  [15.8928, 46.714],
  [15.905, 46.7119],
  [15.9117, 46.7101],
  [15.9205, 46.7059],
  [15.94, 46.6924],
  [15.9471, 46.6891],
  [15.955, 46.6874],
  [15.9836, 46.6846],
  [15.9984, 46.6806],
  [16.0036, 46.6765],
  [16.0069, 46.6686],
  [16.0108, 46.6649],
  [16.015, 46.6632],
  [16.0225, 46.6623],
  [16.0279, 46.6597],
  [16.0381, 46.6561],
  [16.0401, 46.6613],
  [16.0398, 46.6655],
  [16.0408, 46.6685],
  [16.039, 46.672],
  [16.0396, 46.6764],
  [16.0425, 46.6859],
  [16.0403, 46.6883],
  [16.0396, 46.6907],
  [16.0366, 46.6951],
  [16.0347, 46.6964],
  [16.0343, 46.6975],
  [16.0288, 46.7009],
  [16.0297, 46.7027],
  [16.0294, 46.7041],
  [16.0273, 46.7056],
  [16.0288, 46.7103],
  [16.0298, 46.7116],
  [16.0281, 46.7123],
  [16.0214, 46.7109],
  [16.0168, 46.7159],
  [16.0144, 46.7169],
  [16.0118, 46.7175],
  [16.0081, 46.7161],
  [16.0036, 46.7172],
  [16.0032, 46.7184],
  [16.0017, 46.7193],
  [16.0036, 46.723],
  [15.9999, 46.7255],
  [15.9986, 46.7278],
  [15.9961, 46.7299],
  [15.9933, 46.7312],
  [15.9918, 46.7353],
  [15.9917, 46.7375],
  [15.9881, 46.7408],
  [15.9887, 46.7443],
  [15.9872, 46.7465],
  [15.9865, 46.7504],
  [15.9848, 46.752],
  [15.9885, 46.7556],
  [15.9898, 46.7578],
  [15.9882, 46.7614],
  [15.9892, 46.7638],
  [15.9893, 46.7679],
  [15.9887, 46.7694],
  [15.9903, 46.7725],
  [15.9887, 46.7764],
  [15.9901, 46.7787],
  [15.9896, 46.7807],
  [15.9916, 46.7836],
  [15.9932, 46.7881],
  [15.994, 46.7935],
  [15.9935, 46.7967],
  [15.9926, 46.7982],
  [15.9929, 46.8],
  [15.9924, 46.8031],
  [15.9956, 46.8069],
  [15.9975, 46.8079],
  [15.9981, 46.8092],
  [15.9975, 46.8114],
  [15.9917, 46.8168],
  [15.9912, 46.8181],
  [15.988, 46.8196],
  [15.9873, 46.8209],
  [15.9871, 46.8249],
  [15.9854, 46.8273],
  [15.9896, 46.8295],
  [15.9891, 46.8305],
  [15.9909, 46.832],
  [15.991, 46.8328],
  [15.9931, 46.8334],
  [15.9944, 46.8347],
  [15.9963, 46.8354],
  [16.0015, 46.8315],
  [16.0077, 46.8306],
  [16.0079, 46.8316],
  [16.0099, 46.8329],
  [16.0108, 46.8343],
  [16.0135, 46.8359],
  [16.0183, 46.8363],
  [16.0203, 46.8374],
  [16.0206, 46.8383],
  [16.0233, 46.8386],
  [16.0243, 46.84],
  [16.027, 46.8401],
  [16.0273, 46.8411],
  [16.0299, 46.8399],
  [16.0339, 46.8355],
  [16.0322, 46.8349],
  [16.0324, 46.8327],
  [16.0353, 46.8341],
  [16.0351, 46.8349],
  [16.0399, 46.8361],
  [16.0407, 46.8396],
  [16.043, 46.8408],
  [16.0445, 46.8404],
  [16.045, 46.8392],
  [16.0482, 46.839],
  [16.0512, 46.8373],
  [16.0521, 46.8386],
  [16.0546, 46.8405],
  [16.0584, 46.8387],
  [16.0599, 46.84],
  [16.0614, 46.8426],
  [16.066, 46.8461],
  [16.0662, 46.8479],
  [16.0656, 46.8499],
  [16.0696, 46.8509],
  [16.0715, 46.8531],
  [16.0793, 46.8528],
  [16.0819, 46.8558],
  [16.084, 46.8562],
  [16.0879, 46.8594],
  [16.0897, 46.8633],
  [16.0919, 46.8646],
  [16.096, 46.8641],
  [16.0978, 46.8608],
  [16.0992, 46.8604],
  [16.1001, 46.8609],
  [16.1012, 46.8628],
  [16.1068, 46.8652],
  [16.1077, 46.8668],
  [16.1103, 46.8688],
  [16.1139, 46.8691],
  [16.1187, 46.8719],
  [16.1218, 46.8726],
  [16.124, 46.8719],
  [16.1249, 46.8733],
  [16.1267, 46.8733],
  [16.1292, 46.8748],
  [16.133, 46.8756],
  [16.1338, 46.8764],
  [16.134, 46.8779],
  [16.1365, 46.8799],
  [16.1389, 46.8853],
  [16.1423, 46.885],
  [16.1451, 46.886],
  [16.1485, 46.8903],
  [16.1487, 46.8931],
  [16.154, 46.8937],
  [16.1534, 46.8964],
  [16.1558, 46.8964],
  [16.1585, 46.8973],
  [16.1581, 46.8979],
  [16.159, 46.9005],
  [16.1602, 46.9019],
  [16.1621, 46.9023],
  [16.163, 46.9049],
  [16.1677, 46.9032],
  [16.1687, 46.9043],
  [16.1712, 46.9035],
  [16.1739, 46.9059],
  [16.1757, 46.9054],
  [16.1792, 46.9067],
  [16.1805, 46.9125],
  [16.1839, 46.9185],
  [16.1877, 46.9223],
  [16.1886, 46.9256],
  [16.1903, 46.9277],
  [16.1905, 46.93],
  [16.1917, 46.9303],
  [16.1926, 46.9315],
  [16.1936, 46.9341],
  [16.1934, 46.9357],
  [16.1958, 46.939],
  [16.1975, 46.9391],
  [16.1978, 46.9404],
  [16.1989, 46.9402],
  [16.1999, 46.9418],
  [16.2059, 46.9425],
  [16.2063, 46.9421],
  [16.2056, 46.9415],
  [16.2068, 46.941],
  [16.2063, 46.94],
  [16.2077, 46.9389],
  [16.2105, 46.9404],
  [16.2094, 46.9419],
  [16.21, 46.9425],
  [16.211, 46.9418],
  [16.2107, 46.9414],
  [16.2116, 46.9411],
  [16.2118, 46.9403],
  [16.2139, 46.9407],
  [16.2138, 46.9397],
  [16.2147, 46.9404],
  [16.2159, 46.9391],
  [16.2166, 46.9392],
  [16.2176, 46.9409],
  [16.2183, 46.9381],
  [16.2175, 46.9361],
  [16.2221, 46.9356],
  [16.2231, 46.9375],
  [16.2227, 46.9386],
  [16.2241, 46.9402],
  [16.2251, 46.9398],
  [16.227, 46.9406],
  [16.227, 46.9414],
  [16.2291, 46.9413],
  [16.2284, 46.9432],
  [16.232, 46.9428],
  [16.2327, 46.9419],
  [16.2334, 46.9425],
  [16.2339, 46.945],
  [16.2369, 46.9457],
  [16.2376, 46.9469],
  [16.2396, 46.9472],
  [16.2442, 46.9461],
  [16.2457, 46.9467],
  [16.245, 46.9491],
  [16.2462, 46.9496],
  [16.2471, 46.9491],
  [16.2428, 46.956],
  [16.2495, 46.9613],
  [16.2553, 46.9642],
  [16.2631, 46.9636],
  [16.2693, 46.9612],
  [16.272, 46.9624],
  [16.2744, 46.9619],
  [16.2764, 46.9626],
  [16.2775, 46.9687],
  [16.2758, 46.9841],
  [16.2771, 46.9878],
  [16.2784, 46.9882],
  [16.2801, 46.99],
  [16.2835, 46.9975],
  [16.2819, 46.9993],
  [16.2827, 47.0042],
  [16.2868, 47.0108],
  [16.2901, 47.014],
  [16.2926, 47.0139],
  [16.2931, 47.0128],
  [16.2949, 47.0125],
  [16.2967, 47.0104],
  [16.2986, 47.0095],
  [16.2994, 47.0084],
  [16.2987, 47.0058],
  [16.2994, 47.005],
  [16.2985, 47.0046],
  [16.2986, 47.0014],
  [16.3005, 46.9996],
  [16.3034, 46.9983],
  [16.3172, 47.0006],
  [16.3225, 47.0026],
  [16.3417, 46.9962],
  [16.3434, 46.9967],
  [16.3441, 46.9981],
  [16.3428, 46.999],
  [16.3454, 47.0022],
  [16.3438, 47.0039],
  [16.3478, 47.0075],
  [16.3482, 47.0096],
  [16.3498, 47.0104],
  [16.3536, 47.0081],
  [16.3596, 47.0056],
  [16.3609, 47.0058],
  [16.3611, 47.0066],
  [16.3641, 47.0074],
  [16.3673, 47.0063],
  [16.3681, 47.0049],
  [16.3678, 47.0042],
  [16.3729, 46.9984],
  [16.3764, 47.0001],
  [16.3799, 46.9988],
  [16.3817, 46.9993],
  [16.3831, 46.9988],
  [16.3935, 47.0033],
  [16.3997, 47.004],
  [16.4, 47.0033],
  [16.4043, 47.0042],
  [16.4108, 47.004],
  [16.4126, 47.0047],
  [16.417, 47.0014],
  [16.4199, 46.9963],
  [16.4269, 46.9932],
  [16.4323, 46.9927],
  [16.4351, 46.9934],
  [16.4455, 46.9932],
  [16.447, 46.9993],
  [16.4461, 47.0026],
  [16.4478, 47.0036],
  [16.4513, 47.0034],
  [16.4515, 47.0043],
  [16.4525, 47.004],
  [16.4527, 47.0032],
  [16.4545, 47.0034],
  [16.4542, 47.0025],
  [16.4561, 47.002],
  [16.4564, 47.0011],
  [16.4582, 47.0014],
  [16.4592, 47.0006],
  [16.4594, 47.0019],
  [16.46, 47.0017],
  [16.4601, 47.0003],
  [16.4618, 46.9998],
  [16.4616, 46.9986],
  [16.4637, 46.9971],
  [16.4645, 46.9977],
  [16.466, 46.9972],
  [16.4661, 46.9983],
  [16.468, 46.9977],
  [16.4691, 46.998],
  [16.4701, 46.9972],
  [16.4707, 46.9979],
  [16.472, 46.997],
  [16.4738, 46.9974],
  [16.4742, 46.9961],
  [16.4787, 46.9953],
  [16.4779, 46.9945],
  [16.479, 46.9944],
  [16.4792, 46.9938],
  [16.4809, 46.995],
  [16.4821, 46.9941],
  [16.4834, 46.9942],
  [16.4868, 46.9957],
  [16.4873, 46.9973],
  [16.4888, 46.9974],
  [16.4886, 46.9988],
  [16.4898, 46.9995],
  [16.4892, 47.0004],
  [16.4915, 46.9996],
  [16.4937, 46.9999],
  [16.4937, 46.999],
  [16.497, 46.9982],
  [16.5014, 46.9993],
  [16.5024, 47.0001],
  [16.5026, 47.0013],
  [16.5037, 47.0009],
  [16.5041, 47.0018],
  [16.5057, 47.0003],
  [16.506, 47.0016],
  [16.5068, 47.0013],
  [16.5067, 47.0007],
  [16.5082, 47.0013],
  [16.5099, 47.0004],
  [16.5123, 47.0016],
  [16.5124, 47.0035],
  [16.5087, 47.0036],
  [16.5042, 47.007],
  [16.4964, 47.0101],
  [16.4927, 47.0101],
  [16.4912, 47.0123],
  [16.4896, 47.0127],
  [16.4885, 47.0146],
  [16.4867, 47.0152],
  [16.4863, 47.0166],
  [16.4836, 47.018],
  [16.4838, 47.02],
  [16.4824, 47.0212],
  [16.4822, 47.0227],
  [16.4777, 47.0213],
  [16.4751, 47.0273],
  [16.4722, 47.0283],
  [16.4705, 47.028],
  [16.4662, 47.0312],
  [16.465, 47.0305],
  [16.4636, 47.0323],
  [16.4593, 47.0306],
  [16.4478, 47.0227],
  [16.4451, 47.0254],
  [16.4389, 47.0297],
  [16.4441, 47.0344],
  [16.4402, 47.0359],
  [16.4451, 47.0387],
  [16.4512, 47.0401],
  [16.4563, 47.0403],
  [16.4585, 47.0427],
  [16.4613, 47.0433],
  [16.4653, 47.0433],
  [16.4658, 47.0439],
  [16.4674, 47.043],
  [16.4687, 47.0433],
  [16.4729, 47.0454],
  [16.4731, 47.0461],
  [16.4759, 47.0468],
  [16.4841, 47.0479],
  [16.4844, 47.047],
  [16.4861, 47.0471],
  [16.4936, 47.0485],
  [16.4936, 47.0491],
  [16.4978, 47.0485],
  [16.5005, 47.05],
  [16.5008, 47.0507],
  [16.5067, 47.0496],
  [16.5122, 47.0518],
  [16.5155, 47.0544],
  [16.5206, 47.0562],
  [16.5205, 47.0615],
  [16.5101, 47.0663],
  [16.5031, 47.0683],
  [16.5002, 47.0697],
  [16.4958, 47.0705],
  [16.4911, 47.0705],
  [16.487, 47.0689],
  [16.4863, 47.0704],
  [16.4847, 47.07],
  [16.4837, 47.0716],
  [16.4843, 47.0718],
  [16.4839, 47.0724],
  [16.4827, 47.0721],
  [16.4827, 47.0741],
  [16.4834, 47.0742],
  [16.4825, 47.075],
  [16.4729, 47.0736],
  [16.4708, 47.0782],
  [16.472, 47.0815],
  [16.4735, 47.0811],
  [16.474, 47.0818],
  [16.4736, 47.0819],
  [16.4747, 47.0853],
  [16.4727, 47.0871],
  [16.4708, 47.0868],
  [16.469, 47.0877],
  [16.4684, 47.0883],
  [16.4684, 47.0897],
  [16.466, 47.0893],
  [16.4665, 47.0911],
  [16.4633, 47.095],
  [16.4663, 47.0958],
  [16.4646, 47.099],
  [16.4726, 47.1006],
  [16.4717, 47.1021],
  [16.4747, 47.1052],
  [16.4777, 47.1014],
  [16.4848, 47.1026],
  [16.4829, 47.1088],
  [16.5007, 47.1102],
  [16.4999, 47.1234],
  [16.5155, 47.1247],
  [16.5293, 47.1272],
  [16.5288, 47.1373],
  [16.5266, 47.1369],
  [16.5227, 47.14],
  [16.5196, 47.1459],
  [16.5168, 47.1493],
  [16.4905, 47.1489],
  [16.4853, 47.1478],
  [16.4769, 47.1446],
  [16.4692, 47.1428],
  [16.4591, 47.1419],
  [16.459, 47.1431],
  [16.4543, 47.1423],
  [16.4526, 47.1452],
  [16.4513, 47.1448],
  [16.4498, 47.1455],
  [16.4503, 47.1464],
  [16.4491, 47.1519],
  [16.4519, 47.1534],
  [16.4531, 47.1577],
  [16.4582, 47.1573],
  [16.4582, 47.1583],
  [16.4606, 47.1591],
  [16.4602, 47.161],
  [16.4624, 47.1615],
  [16.4608, 47.1638],
  [16.4612, 47.1656],
  [16.4606, 47.1669],
  [16.461, 47.1675],
  [16.4643, 47.1682],
  [16.4634, 47.1709],
  [16.4623, 47.1707],
  [16.4593, 47.1765],
  [16.4574, 47.1768],
  [16.4531, 47.1863],
  [16.4549, 47.1874],
  [16.4533, 47.1881],
  [16.451, 47.1874],
  [16.4507, 47.1883],
  [16.4412, 47.1852],
  [16.4293, 47.1847],
  [16.4274, 47.1856],
  [16.4195, 47.1949],
  [16.4212, 47.1973],
  [16.4185, 47.202],
  [16.4181, 47.2046],
  [16.4169, 47.2053],
  [16.4189, 47.2106],
  [16.4199, 47.2111],
  [16.421, 47.2107],
  [16.422, 47.209],
  [16.4218, 47.2079],
  [16.4234, 47.2077],
  [16.4285, 47.2101],
  [16.4366, 47.2099],
  [16.4361, 47.2118],
  [16.4353, 47.2122],
  [16.435, 47.2155],
  [16.4355, 47.2164],
  [16.4376, 47.2166],
  [16.4393, 47.2179],
  [16.4367, 47.2227],
  [16.4378, 47.2236],
  [16.4382, 47.2299],
  [16.4412, 47.2304],
  [16.4407, 47.2318],
  [16.4413, 47.2321],
  [16.4411, 47.2331],
  [16.4414, 47.2337],
  [16.4428, 47.2337],
  [16.4425, 47.2408],
  [16.4413, 47.2459],
  [16.4417, 47.2486],
  [16.4305, 47.2504],
  [16.4318, 47.2529],
  [16.4424, 47.2508],
  [16.4487, 47.2505],
  [16.4466, 47.2534],
  [16.4548, 47.2537],
  [16.4611, 47.256],
  [16.4657, 47.2541],
  [16.4671, 47.2529],
  [16.469, 47.2552],
  [16.4758, 47.2591],
  [16.4799, 47.2626],
  [16.4783, 47.2631],
  [16.4773, 47.2723],
  [16.4781, 47.2759],
  [16.4795, 47.278],
  [16.4818, 47.2785],
  [16.4836, 47.2778],
  [16.4894, 47.2803],
  [16.4878, 47.2821],
  [16.4875, 47.2838],
  [16.484, 47.2872],
  [16.4837, 47.2891],
  [16.482, 47.2914],
  [16.4827, 47.2927],
  [16.4818, 47.2977],
  [16.4789, 47.3015],
  [16.4754, 47.3093],
  [16.4748, 47.3121],
  [16.4692, 47.3187],
  [16.4694, 47.3223],
  [16.4686, 47.325],
  [16.4644, 47.3289],
  [16.4639, 47.3307],
  [16.4632, 47.331],
  [16.4632, 47.3319],
  [16.4648, 47.3331],
  [16.4645, 47.3339],
  [16.4628, 47.3361],
  [16.4583, 47.3389],
  [16.4564, 47.3393],
  [16.4506, 47.3387],
  [16.4485, 47.3394],
  [16.4459, 47.3425],
  [16.4457, 47.3446],
  [16.4446, 47.3464],
  [16.439, 47.3492],
  [16.4337, 47.3528],
  [16.4346, 47.3542],
  [16.4374, 47.3554],
  [16.4435, 47.3562],
  [16.4465, 47.3575],
  [16.4523, 47.3571],
  [16.4512, 47.3611],
  [16.4542, 47.3631],
  [16.4568, 47.3667],
  [16.4569, 47.371],
  [16.456, 47.3734],
  [16.4527, 47.3757],
  [16.4512, 47.3777],
  [16.4514, 47.3797],
  [16.4532, 47.3824],
  [16.4551, 47.3837],
  [16.4614, 47.3835],
  [16.4613, 47.384],
  [16.4575, 47.3849],
  [16.4572, 47.3858],
  [16.4552, 47.387],
  [16.4555, 47.3887],
  [16.4507, 47.3929],
  [16.4475, 47.3978],
  [16.4476, 47.3993],
  [16.4461, 47.4012],
  [16.4464, 47.4036],
  [16.4455, 47.4072],
  [16.4495, 47.4101],
  [16.4535, 47.4109],
  [16.4557, 47.4125],
  [16.4582, 47.413],
  [16.461, 47.4124],
  [16.4644, 47.4128],
  [16.466, 47.4114],
  [16.471, 47.4104],
  [16.4745, 47.409],
  [16.48, 47.4094],
  [16.4853, 47.4089],
  [16.4851, 47.4085],
  [16.4878, 47.4072],
  [16.4872, 47.4061],
  [16.4893, 47.4063],
  [16.4907, 47.4057],
  [16.4881, 47.4046],
  [16.4871, 47.4032],
  [16.4866, 47.4034],
  [16.485, 47.4022],
  [16.4837, 47.3994],
  [16.485, 47.3988],
  [16.4838, 47.3979],
  [16.4844, 47.3972],
  [16.4897, 47.3997],
  [16.4877, 47.3976],
  [16.4885, 47.3968],
  [16.488, 47.3946],
  [16.4886, 47.3945],
  [16.4907, 47.3949],
  [16.4931, 47.3941],
  [16.494, 47.3959],
  [16.4966, 47.3963],
  [16.4966, 47.389],
  [16.5004, 47.3911],
  [16.5027, 47.3933],
  [16.504, 47.3934],
  [16.5099, 47.3965],
  [16.5103, 47.4005],
  [16.5082, 47.4028],
  [16.5079, 47.405],
  [16.5097, 47.4059],
  [16.5137, 47.4052],
  [16.5151, 47.4083],
  [16.5166, 47.4094],
  [16.5169, 47.4106],
  [16.5188, 47.4099],
  [16.525, 47.4104],
  [16.527, 47.4086],
  [16.5303, 47.4102],
  [16.5319, 47.4104],
  [16.5356, 47.4091],
  [16.54, 47.4101],
  [16.545, 47.406],
  [16.5463, 47.4056],
  [16.551, 47.4055],
  [16.5539, 47.4065],
  [16.5595, 47.407],
  [16.5664, 47.4059],
  [16.5695, 47.4063],
  [16.574, 47.4058],
  [16.5757, 47.4064],
  [16.5774, 47.4095],
  [16.5754, 47.4108],
  [16.5751, 47.4123],
  [16.5822, 47.4151],
  [16.5827, 47.4168],
  [16.5814, 47.4167],
  [16.5793, 47.4179],
  [16.581, 47.4193],
  [16.5839, 47.42],
  [16.5865, 47.4196],
  [16.587, 47.4189],
  [16.5889, 47.4194],
  [16.5885, 47.4208],
  [16.5914, 47.4208],
  [16.5913, 47.4214],
  [16.5876, 47.4213],
  [16.5879, 47.4228],
  [16.5909, 47.4229],
  [16.5938, 47.4221],
  [16.5947, 47.4225],
  [16.5945, 47.4231],
  [16.5951, 47.4225],
  [16.5957, 47.4232],
  [16.5968, 47.4227],
  [16.5966, 47.4238],
  [16.5996, 47.4242],
  [16.5999, 47.4255],
  [16.6037, 47.4255],
  [16.6055, 47.4271],
  [16.6063, 47.427],
  [16.6052, 47.4277],
  [16.6061, 47.4281],
  [16.6066, 47.4294],
  [16.6091, 47.4295],
  [16.6118, 47.4316],
  [16.6125, 47.4301],
  [16.6147, 47.4307],
  [16.6144, 47.4313],
  [16.6154, 47.4324],
  [16.617, 47.4323],
  [16.617, 47.4313],
  [16.6178, 47.4308],
  [16.6204, 47.4308],
  [16.6225, 47.4363],
  [16.6244, 47.4375],
  [16.6275, 47.4421],
  [16.6363, 47.4458],
  [16.6405, 47.4456],
  [16.6462, 47.4466],
  [16.6516, 47.4489],
  [16.6491, 47.4513],
  [16.6574, 47.4536],
  [16.662, 47.4557],
  [16.6609, 47.4571],
  [16.6597, 47.4614],
  [16.6603, 47.4625],
  [16.6618, 47.4628],
  [16.661, 47.4638],
  [16.6624, 47.4663],
  [16.664, 47.4674],
  [16.6675, 47.4719],
  [16.6698, 47.4732],
  [16.6705, 47.4743],
  [16.6682, 47.4793],
  [16.6661, 47.4815],
  [16.6637, 47.4817],
  [16.6623, 47.4833],
  [16.6616, 47.4858],
  [16.6571, 47.4917],
  [16.6523, 47.5003],
  [16.6542, 47.5014],
  [16.6556, 47.504],
  [16.6579, 47.5065],
  [16.6625, 47.509],
  [16.669, 47.5035],
  [16.6762, 47.5066],
  [16.6801, 47.5072],
  [16.6898, 47.5104],
  [16.6948, 47.5154],
  [16.6948, 47.5175],
  [16.6956, 47.5182],
  [16.7055, 47.5229],
  [16.7053, 47.5263],
  [16.7041, 47.5283],
  [16.7042, 47.5308],
  [16.7032, 47.5332],
  [16.7096, 47.5367],
  [16.7097, 47.5375],
  [16.7123, 47.538],
  [16.7145, 47.5399],
  [16.7112, 47.5431],
  [16.7093, 47.5432],
  [16.7059, 47.5424],
  [16.7041, 47.5457],
  [16.7026, 47.5456],
  [16.701, 47.5463],
  [16.6982, 47.5456],
  [16.6947, 47.5497],
  [16.6932, 47.5524],
  [16.6917, 47.5534],
  [16.69, 47.5555],
  [16.691, 47.5579],
  [16.6889, 47.5595],
  [16.6863, 47.5607],
  [16.6837, 47.5608],
  [16.684, 47.5613],
  [16.6779, 47.5611],
  [16.6744, 47.5598],
  [16.6722, 47.5598],
  [16.6703, 47.5606],
  [16.6687, 47.5626],
  [16.6682, 47.5646],
  [16.6646, 47.5663],
  [16.6631, 47.5687],
  [16.6641, 47.5694],
  [16.6677, 47.5696],
  [16.6711, 47.5713],
  [16.6713, 47.5752],
  [16.6738, 47.5766],
  [16.6751, 47.5788],
  [16.6751, 47.5825],
  [16.6695, 47.5928],
  [16.6664, 47.5963],
  [16.6664, 47.5979],
  [16.6705, 47.6008],
  [16.6712, 47.6018],
  [16.6705, 47.6023],
  [16.6731, 47.605],
  [16.6715, 47.6062],
  [16.6643, 47.6054],
  [16.6595, 47.6061],
  [16.6564, 47.6152],
  [16.6534, 47.6202],
  [16.6529, 47.6222],
  [16.6521, 47.6229],
  [16.635, 47.6278],
  [16.6316, 47.6282],
  [16.6189, 47.6258],
  [16.6133, 47.6225],
  [16.6042, 47.6211],
  [16.6011, 47.6197],
  [16.5934, 47.6178],
  [16.588, 47.6175],
  [16.5725, 47.6198],
  [16.5679, 47.6233],
  [16.5623, 47.6249],
  [16.5601, 47.627],
  [16.5537, 47.6299],
  [16.5514, 47.6324],
  [16.5488, 47.6336],
  [16.5394, 47.6367],
  [16.5383, 47.6378],
  [16.5355, 47.6382],
  [16.5287, 47.6415],
  [16.5238, 47.6419],
  [16.5231, 47.6412],
  [16.5221, 47.6426],
  [16.5144, 47.6461],
  [16.5133, 47.646],
  [16.5137, 47.6443],
  [16.512, 47.6426],
  [16.5088, 47.6411],
  [16.5065, 47.6384],
  [16.5024, 47.6401],
  [16.4969, 47.6393],
  [16.4926, 47.6423],
  [16.4898, 47.6414],
  [16.4873, 47.6418],
  [16.4851, 47.6446],
  [16.4832, 47.6457],
  [16.4826, 47.6479],
  [16.48, 47.6499],
  [16.475, 47.6502],
  [16.4704, 47.6516],
  [16.4627, 47.6513],
  [16.46, 47.6532],
  [16.4549, 47.6536],
  [16.4514, 47.6557],
  [16.4399, 47.6567],
  [16.433, 47.6599],
  [16.4279, 47.6608],
  [16.4236, 47.6631],
  [16.4215, 47.6653],
  [16.4256, 47.6679],
  [16.4351, 47.6703],
  [16.4434, 47.6741],
  [16.4425, 47.6773],
  [16.446, 47.686],
  [16.446, 47.6896],
  [16.4476, 47.6917],
  [16.4473, 47.6963],
  [16.454, 47.6968],
  [16.46, 47.6841],
  [16.462, 47.6827],
  [16.4649, 47.6823],
  [16.4661, 47.6817],
  [16.4663, 47.6808],
  [16.4675, 47.6814],
  [16.4697, 47.6812],
  [16.4699, 47.682],
  [16.4709, 47.6824],
  [16.472, 47.6823],
  [16.4729, 47.6813],
  [16.4747, 47.6813],
  [16.4755, 47.6832],
  [16.475, 47.6841],
  [16.4761, 47.6872],
  [16.4755, 47.6892],
  [16.476, 47.6901],
  [16.4772, 47.6908],
  [16.481, 47.6903],
  [16.4846, 47.6914],
  [16.4861, 47.6928],
  [16.4845, 47.6954],
  [16.4863, 47.6974],
  [16.4872, 47.698],
  [16.4937, 47.6987],
  [16.4964, 47.7015],
  [16.4973, 47.7016],
  [16.4975, 47.7033],
  [16.4998, 47.7047],
  [16.5041, 47.7035],
  [16.5055, 47.7039],
  [16.5052, 47.7044],
  [16.5067, 47.7044],
  [16.5095, 47.7054],
  [16.511, 47.707],
  [16.5127, 47.7067],
  [16.5142, 47.7076],
  [16.5169, 47.7069],
  [16.5206, 47.7123],
  [16.5235, 47.7109],
  [16.5275, 47.7104],
  [16.5343, 47.7106],
  [16.5355, 47.7114],
  [16.5411, 47.7122],
  [16.5422, 47.7129],
  [16.5413, 47.7136],
  [16.5446, 47.717],
  [16.5522, 47.7225],
  [16.5365, 47.7366],
  [16.5388, 47.7383],
  [16.5376, 47.74],
  [16.5428, 47.7424],
  [16.5441, 47.7426],
  [16.5449, 47.7413],
  [16.5488, 47.7432],
  [16.5466, 47.7453],
  [16.5482, 47.746],
  [16.546, 47.7493],
  [16.5476, 47.7493],
  [16.547, 47.751],
  [16.548, 47.7515],
  [16.5665, 47.7516],
  [16.5831, 47.755],
  [16.588, 47.7555],
  [16.5889, 47.7569],
  [16.5926, 47.7591],
  [16.5988, 47.7561],
  [16.6022, 47.7581],
  [16.6091, 47.7604],
  [16.6157, 47.7596],
  [16.6202, 47.7577],
  [16.6254, 47.7569],
  [16.628, 47.7571],
  [16.6305, 47.7584],
  [16.6343, 47.7591],
  [16.6346, 47.7578],
  [16.6374, 47.756],
  [16.6384, 47.7546],
  [16.639, 47.7518],
  [16.6386, 47.7496],
  [16.6397, 47.7483],
  [16.656, 47.7417],
  [16.6572, 47.7416],
  [16.6582, 47.7433],
  [16.6716, 47.7404],
  [16.7209, 47.7353],
  [16.7215, 47.7226],
  [16.749, 47.6814],
  [16.8283, 47.6827],
  [16.8321, 47.6881],
  [16.8328, 47.6916],
  [16.8391, 47.7046],
  [16.8555, 47.7111],
  [16.8669, 47.7216],
  [16.8688, 47.7213],
  [16.8716, 47.6901],
  [16.8752, 47.6883],
  [16.9125, 47.6877],
  [16.9764, 47.6945],
  [17.0404, 47.7044],
  [17.0931, 47.7083],
  [17.0742, 47.7232],
  [17.0703, 47.7282],
  [17.071, 47.7389],
  [17.0708, 47.7499],
  [17.0697, 47.7573],
  [17.0684, 47.7571],
  [17.0656, 47.7663],
  [17.0656, 47.7669],
  [17.0672, 47.7669],
  [17.0638, 47.7778],
  [17.0608, 47.7776],
  [17.0582, 47.7862],
  [17.051, 47.794],
  [17.0535, 47.7976],
  [17.0718, 47.8082],
  [17.0744, 47.8083],
  [17.0597, 47.8201],
  [17.0609, 47.8227],
  [17.0469, 47.8284],
  [17.0497, 47.8312],
  [17.0466, 47.8329],
  [17.0516, 47.8379],
  [17.01, 47.8584],
  [17.0147, 47.8644],
  [17.0162, 47.8675],
  [17.0178, 47.8684],
  [17.0289, 47.8677],
  [17.0375, 47.868],
  [17.04, 47.8668],
  [17.0496, 47.8701],
  [17.0487, 47.8719],
  [17.0627, 47.8737],
  [17.0778, 47.8775],
  [17.0804, 47.8745],
  [17.0852, 47.8744],
  [17.1042, 47.8993],
  [17.0956, 47.9043],
  [17.0973, 47.9053],
  [17.0963, 47.9061],
  [17.1027, 47.9104],
  [17.1024, 47.9107],
  [17.1127, 47.9274],
  [17.0909, 47.9344],
  [17.0965, 47.9394],
  [17.1006, 47.942],
  [17.1028, 47.9452],
  [17.1078, 47.9495],
  [17.1099, 47.9544],
  [17.1141, 47.9588],
  [17.117, 47.9609],
  [17.1119, 47.9636],
  [17.1105, 47.964],
  [17.1082, 47.9635],
  [17.1044, 47.9659],
  [17.0997, 47.9672],
  [17.0966, 47.9686],
  [17.0947, 47.9709],
  [17.112, 47.9795],
  [17.1188, 47.9848],
  [17.1314, 47.9908],
  [17.135, 47.9933],
  [17.1342, 47.994],
  [17.1466, 48],
  [17.157, 48.004],
  [17.1608, 48.0067],
  [17.1501, 48.0136],
  [17.1438, 48.0202],
  [17.1424, 48.0195],
  [17.1364, 48.0229],
  [17.133, 48.0224],
  [17.1308, 48.023],
  [17.1267, 48.0209],
  [17.1175, 48.0282],
  [17.1101, 48.0312],
  [17.0899, 48.0198],
  [17.0882, 48.0218],
  [17.0848, 48.0238],
  [17.0674, 48.0314],
  [17.0751, 48.0358],
  [17.0742, 48.0363],
  [17.0878, 48.0457],
  [17.0857, 48.0493],
  [17.0843, 48.0504],
  [17.074, 48.0529],
  [17.0683, 48.0554],
  [17.0702, 48.057],
  [17.0717, 48.0562],
  [17.0755, 48.0591],
  [17.0868, 48.0654],
  [17.0722, 48.0705],
  [17.0789, 48.0782],
  [17.0716, 48.0809],
  [17.0748, 48.0826],
  [17.0731, 48.0834],
  [17.0746, 48.0859],
  [17.0764, 48.0862],
  [17.0896, 48.0922],
  [17.0913, 48.0906],
  [17.0931, 48.0914],
  [17.0878, 48.0966],
  [17.0927, 48.0996],
  [17.0837, 48.103],
  [17.0833, 48.1025],
  [17.0774, 48.106],
  [17.0791, 48.1079],
  [17.0729, 48.1103],
  [17.0771, 48.1151],
  [17.0728, 48.1145],
  [17.0686, 48.1161],
  [17.068, 48.1166],
  [17.068, 48.1182],
  [17.0628, 48.1215],
  [17.0624, 48.1232],
  [17.068, 48.1235],
  [17.0688, 48.1242],
  [17.0671, 48.1264],
  [17.0676, 48.1274],
  [17.0663, 48.1282],
  [17.0643, 48.1281],
  [17.0641, 48.1287],
  [17.0656, 48.1293],
  [17.0614, 48.1335],
  [17.0601, 48.1358],
  [17.0616, 48.136],
  [17.0613, 48.1382],
  [17.0594, 48.1404],
  [17.0594, 48.1412],
  [17.0574, 48.1418],
  [17.0572, 48.1437],
  [17.0383, 48.1398],
  [17.0338, 48.1398],
  [17.0261, 48.1412],
  [17.023, 48.1431],
  [17.0168, 48.15],
  [17.0126, 48.1533],
  [16.9952, 48.1608],
  [16.9837, 48.1683],
  [16.9762, 48.1722],
  [16.9755, 48.1766],
  [16.9774, 48.1823],
  [16.9765, 48.1857],
  [16.9764, 48.1894],
  [16.9718, 48.1958],
  [16.9698, 48.2017],
  [16.9671, 48.2053],
  [16.9652, 48.2102],
  [16.9625, 48.2136],
  [16.9618, 48.2208],
  [16.9575, 48.2265],
  [16.949, 48.2319],
  [16.9471, 48.2339],
  [16.9461, 48.2359],
  [16.9467, 48.2417],
  [16.9483, 48.2439],
  [16.9498, 48.2488],
  [16.9498, 48.2522],
  [16.9514, 48.2567],
  [16.9567, 48.262],
  [16.9573, 48.263],
  [16.9571, 48.2638],
  [16.9521, 48.2658],
  [16.9489, 48.269],
  [16.9456, 48.2705],
  [16.9298, 48.2709],
  [16.9227, 48.2721],
  [16.9199, 48.2741],
  [16.9202, 48.2762],
  [16.9193, 48.2781],
  [16.9144, 48.281],
  [16.9075, 48.2884],
  [16.9056, 48.2943],
  [16.9015, 48.2971],
  [16.9001, 48.2988],
  [16.8989, 48.3039],
  [16.8951, 48.3091],
  [16.8945, 48.3112],
  [16.8965, 48.3149],
  [16.9042, 48.3184],
  [16.9087, 48.3229],
  [16.9093, 48.3248],
  [16.9085, 48.3262],
  [16.8995, 48.3285],
  [16.8943, 48.3315],
  [16.8892, 48.332],
  [16.8819, 48.3358],
  [16.8744, 48.3368],
  [16.8717, 48.338],
  [16.8699, 48.3395],
  [16.8694, 48.3409],
  [16.8704, 48.3425],
  [16.8741, 48.3443],
  [16.8752, 48.3455],
  [16.8751, 48.3471],
  [16.8734, 48.3487],
  [16.8714, 48.349],
  [16.8668, 48.3479],
  [16.8599, 48.3493],
  [16.8549, 48.348],
  [16.8508, 48.348],
  [16.8449, 48.3499],
  [16.8427, 48.3524],
  [16.8423, 48.3545],
  [16.8432, 48.3586],
  [16.8405, 48.3619],
  [16.8391, 48.3653],
  [16.8412, 48.3697],
  [16.8412, 48.3717],
  [16.8336, 48.3793],
  [16.8333, 48.3813],
  [16.8347, 48.3832],
  [16.8371, 48.3839],
  [16.8396, 48.3837],
  [16.8446, 48.3818],
  [16.8485, 48.3821],
  [16.8503, 48.383],
  [16.8509, 48.3844],
  [16.8505, 48.3905],
  [16.8549, 48.3941],
  [16.8559, 48.3962],
  [16.8552, 48.3992],
  [16.8509, 48.4057],
  [16.8503, 48.4078],
  [16.8505, 48.41],
  [16.8532, 48.4131],
  [16.8618, 48.4173],
  [16.8636, 48.4194],
  [16.8629, 48.4211],
  [16.8595, 48.4233],
  [16.8574, 48.4257],
  [16.8517, 48.4349],
  [16.8509, 48.4449],
  [16.8495, 48.4473],
  [16.85, 48.4492],
  [16.8527, 48.4512],
  [16.8592, 48.4512],
  [16.8631, 48.453],
  [16.8641, 48.4545],
  [16.8639, 48.4557],
  [16.8599, 48.4577],
  [16.8595, 48.4594],
  [16.8624, 48.4618],
  [16.8651, 48.4656],
  [16.8715, 48.4664],
  [16.8738, 48.4675],
  [16.8764, 48.4723],
  [16.8807, 48.4775],
  [16.8827, 48.4778],
  [16.8873, 48.4757],
  [16.89, 48.4764],
  [16.8904, 48.4812],
  [16.8949, 48.4837],
  [16.8962, 48.4863],
  [16.8952, 48.4878],
  [16.8906, 48.4902],
  [16.89, 48.4917],
  [16.8961, 48.4965],
  [16.8992, 48.498],
  [16.9049, 48.4985],
  [16.9071, 48.498],
  [16.9089, 48.4957],
  [16.9113, 48.4946],
  [16.9142, 48.4944],
  [16.917, 48.4955],
  [16.9175, 48.4964],
  [16.9172, 48.4975],
  [16.9139, 48.5009],
  [16.9144, 48.5034],
  [16.913, 48.5076],
  [16.9131, 48.5103],
  [16.9139, 48.512],
  [16.9157, 48.513],
  [16.92, 48.5126],
  [16.9221, 48.5134],
  [16.9225, 48.5147],
  [16.9197, 48.5181],
  [16.92, 48.5193],
  [16.9213, 48.5201],
  [16.9302, 48.5204],
  [16.9353, 48.5214],
  [16.9406, 48.5207],
  [16.9432, 48.5216],
  [16.9438, 48.523],
  [16.9405, 48.5255],
  [16.9404, 48.5272],
  [16.9425, 48.5299],
  [16.9489, 48.5336],
  [16.9507, 48.5382],
  [16.9539, 48.5433],
  [16.9537, 48.5448],
  [16.9528, 48.5459],
  [16.9478, 48.5478],
  [16.9427, 48.5524],
  [16.9426, 48.5538],
  [16.9447, 48.5575],
  [16.9446, 48.5602],
  [16.9386, 48.5652],
  [16.9356, 48.5714],
  [16.9357, 48.5749],
  [16.9387, 48.5802],
  [16.9391, 48.5831],
  [16.9358, 48.595],
  [16.934, 48.5985],
  [16.9336, 48.6006],
  [16.9343, 48.602],
  [16.9393, 48.6035],
  [16.9419, 48.6061],
  [16.9421, 48.6101],
  [16.9394, 48.6144],
  [16.9401, 48.6172],
  [16.9389, 48.6181],
  [16.9347, 48.6192],
  [16.9276, 48.6191],
  [16.9187, 48.6225],
  [16.9202, 48.624],
  [16.9188, 48.6257],
  [16.919, 48.6266],
  [16.9208, 48.6283],
  [16.924, 48.6289],
  [16.9229, 48.6311],
  [16.9258, 48.632],
  [16.9253, 48.6354],
  [16.9284, 48.6384],
  [16.9269, 48.6411],
  [16.9229, 48.6443],
  [16.9205, 48.6454],
  [16.921, 48.649],
  [16.9197, 48.6497],
  [16.9193, 48.6513],
  [16.9201, 48.6536],
  [16.9222, 48.6553],
  [16.9218, 48.6569],
  [16.9237, 48.6582],
  [16.9225, 48.6595],
  [16.922, 48.6629],
  [16.9228, 48.6653],
  [16.9221, 48.6672],
  [16.9233, 48.6696],
  [16.9227, 48.6706],
  [16.9192, 48.6728],
  [16.9131, 48.6737],
  [16.9105, 48.6757],
  [16.9101, 48.6781],
  [16.9108, 48.6799],
  [16.9133, 48.6819],
  [16.9132, 48.6849],
  [16.916, 48.6875],
  [16.9166, 48.6915],
  [16.9182, 48.6925],
  [16.9186, 48.6935],
  [16.9161, 48.6962],
  [16.9167, 48.7002],
  [16.9136, 48.7027],
  [16.9123, 48.7059],
  [16.9046, 48.7094],
  [16.9025, 48.7119],
  [16.9029, 48.7133],
  [16.9057, 48.714],
  [16.9062, 48.7147],
  [16.9033, 48.7163],
  [16.902, 48.718],
  [16.9007, 48.7179],
  [16.8976, 48.7159],
  [16.8958, 48.7165],
  [16.8925, 48.7157],
  [16.8876, 48.7166],
  [16.8863, 48.7162],
  [16.8792, 48.723],
  [16.8767, 48.7218],
  [16.8764, 48.72],
  [16.8748, 48.7188],
  [16.8754, 48.7186],
  [16.8747, 48.7179],
  [16.8721, 48.7169],
  [16.8735, 48.7158],
  [16.8694, 48.7125],
  [16.8415, 48.7115],
  [16.8343, 48.7165],
  [16.8273, 48.7111],
  [16.8223, 48.7103],
  [16.8163, 48.7102],
  [16.8054, 48.7122],
  [16.8061, 48.7091],
  [16.8019, 48.7073],
  [16.8003, 48.7059],
  [16.7997, 48.7094],
  [16.7983, 48.7108],
  [16.7965, 48.7101],
  [16.7952, 48.7105],
  [16.7921, 48.7119],
  [16.7899, 48.7138],
  [16.7855, 48.7128],
  [16.7801, 48.7132],
  [16.7793, 48.7123],
  [16.7782, 48.7141],
  [16.7758, 48.7119],
  [16.7695, 48.7143],
  [16.7672, 48.7167],
  [16.7637, 48.7187],
  [16.7598, 48.7165],
  [16.7573, 48.717],
  [16.7588, 48.7188],
  [16.7561, 48.7189],
  [16.7564, 48.7194],
  [16.7534, 48.7206],
  [16.7521, 48.7248],
  [16.7503, 48.7266],
  [16.7491, 48.7301],
  [16.7484, 48.73],
  [16.7473, 48.7321],
  [16.7396, 48.7305],
  [16.7375, 48.7306],
  [16.7367, 48.7293],
  [16.7348, 48.7305],
  [16.7361, 48.7319],
  [16.7328, 48.7338],
  [16.729, 48.7332],
  [16.7275, 48.7342],
  [16.7296, 48.7355],
  [16.7285, 48.7359],
  [16.7285, 48.7367],
  [16.7247, 48.738],
  [16.715, 48.7381],
  [16.7075, 48.7368],
  [16.7066, 48.7377],
  [16.7061, 48.7359],
  [16.7043, 48.7351],
  [16.7011, 48.7365],
  [16.6937, 48.7328],
  [16.6886, 48.7293],
  [16.6826, 48.7278],
  [16.6801, 48.7338],
  [16.6756, 48.7373],
  [16.6735, 48.7406],
  [16.674, 48.7429],
  [16.6779, 48.746],
  [16.6808, 48.7501],
  [16.6794, 48.76],
  [16.6776, 48.7665],
  [16.6747, 48.7715],
  [16.6664, 48.7738],
  [16.664, 48.7755],
  [16.6641, 48.7768],
  [16.6658, 48.7781],
  [16.6636, 48.7787],
  [16.6642, 48.7804],
  [16.6637, 48.781],
  [16.6564, 48.783],
  [16.6552, 48.7825],
  [16.6535, 48.7833],
  [16.6539, 48.7844],
  [16.6518, 48.7851],
  [16.6419, 48.7859],
  [16.6337, 48.7854],
  [16.632, 48.7827],
  [16.6302, 48.7818],
  [16.6306, 48.7804],
  [16.6286, 48.7801],
  [16.6274, 48.7801],
  [16.6273, 48.7808],
  [16.6264, 48.7809],
  [16.6226, 48.7807],
  [16.618, 48.7815],
  [16.6099, 48.7806],
  [16.5936, 48.7827],
  [16.5932, 48.7829],
  [16.5936, 48.7868],
  [16.5824, 48.7921],
  [16.5794, 48.7922],
  [16.5766, 48.7933],
  [16.5671, 48.7931],
  [16.5652, 48.7936],
  [16.5606, 48.7993],
  [16.5578, 48.8011],
  [16.5555, 48.8036],
  [16.5497, 48.8066],
  [16.5407, 48.8143],
  [16.5341, 48.811],
  [16.5328, 48.8077],
  [16.5281, 48.8055],
  [16.529, 48.804],
  [16.525, 48.8007],
  [16.5186, 48.7982],
  [16.5161, 48.8027],
  [16.4999, 48.8012],
  [16.4783, 48.8021],
  [16.4742, 48.8048],
  [16.4677, 48.8073],
  [16.4645, 48.8099],
  [16.4604, 48.809],
  [16.459, 48.8081],
  [16.4628, 48.8063],
  [16.461, 48.8058],
  [16.4619, 48.8046],
  [16.4535, 48.8018],
  [16.4487, 48.7994],
  [16.4467, 48.7956],
  [16.4479, 48.7908],
  [16.4435, 48.7871],
  [16.4436, 48.7864],
  [16.4427, 48.7862],
  [16.44, 48.7838],
  [16.4372, 48.7798],
  [16.4377, 48.7787],
  [16.4367, 48.778],
  [16.4358, 48.7782],
  [16.4352, 48.7766],
  [16.4393, 48.7743],
  [16.4376, 48.7685],
  [16.435, 48.7656],
  [16.43, 48.7632],
  [16.4288, 48.7633],
  [16.4275, 48.7621],
  [16.4258, 48.7623],
  [16.4232, 48.7613],
  [16.4228, 48.762],
  [16.4193, 48.7592],
  [16.4161, 48.7562],
  [16.4157, 48.755],
  [16.4136, 48.7539],
  [16.4149, 48.7534],
  [16.4136, 48.7514],
  [16.4126, 48.7516],
  [16.4095, 48.7443],
  [16.4103, 48.7433],
  [16.4043, 48.7405],
  [16.405, 48.7414],
  [16.4036, 48.7421],
  [16.4023, 48.741],
  [16.4006, 48.7411],
  [16.4009, 48.7405],
  [16.3997, 48.7398],
  [16.4005, 48.7394],
  [16.3952, 48.7364],
  [16.3935, 48.7369],
  [16.3923, 48.7391],
  [16.3909, 48.7383],
  [16.3903, 48.7391],
  [16.3888, 48.7391],
  [16.3886, 48.7356],
  [16.3856, 48.735],
  [16.3831, 48.7332],
  [16.3831, 48.7327],
  [16.3846, 48.7322],
  [16.3839, 48.7308],
  [16.3817, 48.7294],
  [16.378, 48.7285],
  [16.377, 48.7289],
  [16.3781, 48.7295],
  [16.3774, 48.731],
  [16.3665, 48.728],
  [16.3598, 48.7281],
  [16.3604, 48.7302],
  [16.3598, 48.7309],
  [16.3582, 48.7301],
  [16.3553, 48.7322],
  [16.3514, 48.7336],
  [16.3573, 48.7378],
  [16.3567, 48.7385],
  [16.3537, 48.7408],
  [16.3497, 48.7422],
  [16.3456, 48.741],
  [16.3441, 48.7439],
  [16.3433, 48.7441],
  [16.3443, 48.7445],
  [16.3427, 48.7456],
  [16.3414, 48.7454],
  [16.3416, 48.745],
  [16.3425, 48.7454],
  [16.3426, 48.7446],
  [16.3409, 48.7438],
  [16.3417, 48.7431],
  [16.3403, 48.7427],
  [16.3362, 48.7323],
  [16.3299, 48.7312],
  [16.3296, 48.7325],
  [16.3246, 48.7319],
  [16.311, 48.7336],
  [16.3067, 48.7369],
  [16.3053, 48.7387],
  [16.3023, 48.7395],
  [16.299, 48.7397],
  [16.2985, 48.7384],
  [16.2966, 48.7377],
  [16.2883, 48.7402],
  [16.2852, 48.7399],
  [16.2779, 48.7415],
  [16.2683, 48.7413],
  [16.2631, 48.737],
  [16.2487, 48.7396],
  [16.2241, 48.7401],
  [16.2044, 48.7429],
  [16.189, 48.7433],
  [16.1727, 48.7463],
  [16.1634, 48.747],
  [16.154, 48.7488],
  [16.153, 48.7472],
  [16.1533, 48.7452],
  [16.1509, 48.745],
  [16.1499, 48.7432],
  [16.1436, 48.7441],
  [16.1393, 48.7454],
  [16.1389, 48.7427],
  [16.118, 48.7467],
  [16.1172, 48.7483],
  [16.1118, 48.7473],
  [16.1121, 48.7459],
  [16.107, 48.7454],
  [16.0942, 48.7466],
  [16.0803, 48.7498],
  [16.0649, 48.7546],
  [16.0528, 48.761],
  [16.0412, 48.7641],
  [16.021, 48.7721],
  [16.0145, 48.7739],
  [16.0129, 48.7736],
  [16.007, 48.7761],
  [15.9944, 48.7793],
  [15.9865, 48.786],
  [15.9726, 48.7935],
  [15.9684, 48.797],
  [15.9647, 48.7984],
  [15.9596, 48.7984],
  [15.9496, 48.8052],
  [15.9501, 48.8092],
  [15.952, 48.8139],
  [15.9556, 48.8175],
  [15.9599, 48.8198],
  [15.9584, 48.8231],
  [15.9545, 48.8237],
  [15.9467, 48.8225],
  [15.9456, 48.8236],
  [15.9481, 48.8256],
  [15.9479, 48.8267],
  [15.9462, 48.8277],
  [15.9418, 48.8277],
  [15.9402, 48.8271],
  [15.9413, 48.8228],
  [15.9404, 48.8195],
  [15.9377, 48.8188],
  [15.9346, 48.8191],
  [15.9255, 48.8231],
  [15.9242, 48.8246],
  [15.9267, 48.8268],
  [15.9269, 48.8306],
  [15.9309, 48.8336],
  [15.9289, 48.8344],
  [15.9218, 48.835],
  [15.9209, 48.8356],
  [15.9206, 48.8381],
  [15.9198, 48.8388],
  [15.9172, 48.8387],
  [15.9149, 48.8371],
  [15.9103, 48.837],
  [15.9069, 48.8355],
  [15.9027, 48.836],
  [15.8951, 48.8345],
  [15.8932, 48.8346],
  [15.8918, 48.8362],
  [15.8909, 48.8386],
  [15.8915, 48.8423],
  [15.8928, 48.8433],
  [15.8938, 48.8431],
  [15.895, 48.8404],
  [15.8978, 48.8381],
  [15.9028, 48.8374],
  [15.9052, 48.8389],
  [15.9046, 48.841],
  [15.8976, 48.8484],
  [15.8966, 48.849],
  [15.8935, 48.849],
  [15.8917, 48.8449],
  [15.8902, 48.8431],
  [15.8876, 48.842],
  [15.8846, 48.842],
  [15.8823, 48.8439],
  [15.8797, 48.8479],
  [15.8799, 48.8525],
  [15.8809, 48.8539],
  [15.8807, 48.8556],
  [15.8769, 48.8595],
  [15.8736, 48.8607],
  [15.8714, 48.8603],
  [15.8713, 48.8588],
  [15.8746, 48.8581],
  [15.8754, 48.8566],
  [15.875, 48.855],
  [15.8729, 48.8538],
  [15.8643, 48.8524],
  [15.8626, 48.8529],
  [15.8571, 48.8578],
  [15.8515, 48.8576],
  [15.8427, 48.8596],
  [15.841, 48.8609],
  [15.8415, 48.862],
  [15.8499, 48.8649],
  [15.8521, 48.8664],
  [15.8521, 48.8671],
  [15.8515, 48.8687],
  [15.8437, 48.8729],
  [15.843, 48.8746],
  [15.845, 48.8757],
  [15.8415, 48.8771],
  [15.8396, 48.8776],
  [15.8369, 48.8768],
  [15.8353, 48.8745],
  [15.8328, 48.8726],
  [15.8276, 48.871],
  [15.8217, 48.8727],
  [15.8131, 48.8731],
  [15.8061, 48.8722],
  [15.7795, 48.8749],
  [15.7749, 48.87],
  [15.7735, 48.8673],
  [15.7708, 48.8641],
  [15.7609, 48.8564],
  [15.7537, 48.8522],
  [15.7512, 48.8521],
  [15.7381, 48.8551],
  [15.7139, 48.858],
  [15.7135, 48.8581],
  [15.7147, 48.8597],
  [15.7091, 48.8607],
  [15.6979, 48.8584],
  [15.6944, 48.8558],
  [15.6897, 48.8557],
  [15.6865, 48.857],
  [15.6849, 48.8599],
  [15.6805, 48.8638],
  [15.6716, 48.8678],
  [15.6664, 48.8724],
  [15.6653, 48.8742],
  [15.6601, 48.8772],
  [15.6588, 48.8789],
  [15.6572, 48.8793],
  [15.6569, 48.8805],
  [15.6557, 48.8814],
  [15.6446, 48.8851],
  [15.6424, 48.8866],
  [15.64, 48.8865],
  [15.6389, 48.8873],
  [15.636, 48.8871],
  [15.6374, 48.8861],
  [15.6368, 48.8846],
  [15.6303, 48.885],
  [15.6254, 48.8888],
  [15.6252, 48.8901],
  [15.6258, 48.8908],
  [15.6207, 48.8938],
  [15.6196, 48.8956],
  [15.6124, 48.8983],
  [15.6107, 48.8965],
  [15.5948, 48.8971],
  [15.5932, 48.8964],
  [15.578, 48.8959],
  [15.5586, 48.9046],
  [15.541, 48.908],
  [15.5282, 48.9117],
  [15.5134, 48.9141],
  [15.5117, 48.9151],
  [15.5096, 48.9175],
  [15.5061, 48.9196],
  [15.5053, 48.922],
  [15.5055, 48.9258],
  [15.5032, 48.9278],
  [15.5035, 48.9298],
  [15.5024, 48.9329],
  [15.502, 48.936],
  [15.4982, 48.9385],
  [15.49, 48.9404],
  [15.4843, 48.9434],
  [15.4801, 48.9436],
  [15.4795, 48.9442],
  [15.477, 48.9445],
  [15.4773, 48.9457],
  [15.4734, 48.9464],
  [15.4736, 48.9474],
  [15.4685, 48.9518],
  [15.4664, 48.9515],
  [15.4652, 48.9503],
  [15.4559, 48.9453],
  [15.4505, 48.9498],
  [15.4439, 48.951],
  [15.4349, 48.9499],
  [15.4248, 48.9516],
  [15.4128, 48.9563],
  [15.4034, 48.9634],
  [15.3958, 48.9646],
  [15.3928, 48.9656],
  [15.391, 48.9671],
  [15.389, 48.9712],
  [15.3894, 48.9719],
  [15.389, 48.9725],
  [15.3841, 48.9738],
  [15.3799, 48.976],
  [15.3755, 48.977],
  [15.3723, 48.9795],
  [15.3693, 48.9802],
  [15.367, 48.9819],
  [15.3575, 48.9822],
  [15.3535, 48.984],
  [15.3484, 48.9848],
  [15.347, 48.984],
  [15.336, 48.9832],
  [15.3322, 48.9848],
  [15.3277, 48.9806],
  [15.3281, 48.9801],
  [15.327, 48.9798],
  [15.327, 48.9792],
  [15.3217, 48.9761],
  [15.3121, 48.9808],
  [15.3057, 48.9779],
  [15.3029, 48.9794],
  [15.2969, 48.9807],
  [15.296, 48.9821],
  [15.291, 48.9843],
  [15.2923, 48.9857],
  [15.2918, 48.9869],
  [15.2937, 48.9891],
  [15.2917, 48.9903],
  [15.29, 48.9925],
  [15.2789, 48.9947],
  [15.2778, 48.9946],
  [15.2771, 48.9933],
  [15.2769, 48.9904],
  [15.2761, 48.9899],
  [15.2757, 48.9884],
  [15.2758, 48.9858],
  [15.277, 48.9849],
  [15.2779, 48.9829],
  [15.2818, 48.9807],
  [15.2814, 48.9794],
  [15.2766, 48.9721],
  [15.2719, 48.9664],
  [15.2691, 48.9671],
  [15.2671, 48.9672],
  [15.2667, 48.9666],
  [15.2654, 48.964],
  [15.2673, 48.9639],
  [15.2676, 48.9614],
  [15.2691, 48.9583],
  [15.2684, 48.957],
  [15.2646, 48.958],
  [15.2619, 48.9576],
  [15.2618, 48.9563],
  [15.2623, 48.9562],
  [15.2616, 48.9536],
  [15.248, 48.958],
  [15.2464, 48.9595],
  [15.2408, 48.9594],
  [15.2385, 48.9575],
  [15.2332, 48.959],
  [15.2286, 48.959],
  [15.2244, 48.9601],
  [15.2216, 48.9585],
  [15.2172, 48.9587],
  [15.2146, 48.9582],
  [15.2128, 48.9569],
  [15.2096, 48.9575],
  [15.2094, 48.9559],
  [15.2053, 48.9535],
  [15.2, 48.9522],
  [15.1974, 48.9483],
  [15.1923, 48.9457],
  [15.1929, 48.9446],
  [15.1903, 48.9433],
  [15.1893, 48.943],
  [15.1819, 48.9452],
  [15.177, 48.9477],
  [15.1739, 48.9461],
  [15.1736, 48.9452],
  [15.1713, 48.9449],
  [15.171, 48.9443],
  [15.1718, 48.9438],
  [15.1702, 48.943],
  [15.1681, 48.943],
  [15.1657, 48.944],
  [15.1647, 48.9431],
  [15.1602, 48.9417],
  [15.1606, 48.9433],
  [15.1591, 48.9451],
  [15.1554, 48.9461],
  [15.1576, 48.9497],
  [15.1617, 48.9531],
  [15.1616, 48.955],
  [15.1624, 48.956],
  [15.1624, 48.9573],
  [15.1646, 48.9584],
  [15.1669, 48.9586],
  [15.1691, 48.9604],
  [15.1698, 48.9623],
  [15.1686, 48.9643],
  [15.1684, 48.967],
  [15.1661, 48.9688],
  [15.1656, 48.9699],
  [15.1595, 48.9721],
  [15.1631, 48.9755],
  [15.162, 48.9777],
  [15.1532, 48.9789],
  [15.1511, 48.9809],
  [15.1511, 48.9824],
  [15.153, 48.9845],
  [15.1561, 48.9842],
  [15.1575, 48.9848],
  [15.1586, 48.9899],
  [15.1576, 48.9907],
  [15.1562, 48.9933],
  [15.1426, 48.9971],
  [15.1368, 48.9976],
  [15.1328, 49.0007],
  [15.1319, 48.9991],
  [15.129, 48.9975],
  [15.1256, 48.999],
  [15.1239, 48.9988],
  [15.1219, 48.9973],
  [15.1142, 48.9993],
  [15.1082, 48.9991],
  [15.1026, 48.9938],
  [15.092, 48.9969],
  [15.0854, 48.9979],
  [15.075, 48.9981],
  [15.0648, 48.9996],
  [15.0641, 49.0006],
  [15.0646, 49.0013],
  [15.0644, 49.0043],
  [15.0656, 49.0044],
  [15.0673, 49.0062],
  [15.067, 49.0088],
  [15.0643, 49.0121],
  [15.0654, 49.0142],
  [15.0602, 49.0147],
  [15.0585, 49.0155],
  [15.0543, 49.0156],
  [15.0482, 49.014],
  [15.0456, 49.0124],
  [15.0408, 49.0115],
  [15.0387, 49.0118],
  [15.0365, 49.0131],
  [15.0347, 49.0131],
  [15.0318, 49.0152],
  [15.0283, 49.0156],
  [15.0256, 49.0188],
  [15.0206, 49.0205],
  [15.0166, 49.0181],
  [15.0155, 49.0185],
  [15.0141, 49.0177],
  [15.0115, 49.0144],
  [15.0049, 49.0127],
  [15.003, 49.0115],
  [15.0022, 49.012],
  [15.0023, 49.0128],
  [15.0003, 49.0126],
  [14.9959, 49.0151],
  [14.995, 49.0146],
  [14.9934, 49.0114],
  [14.9904, 49.0097],
  [14.995, 49.0054],
  [14.9975, 49.0044],
  [14.9989, 49.0048],
  [15.0008, 49.0037],
  [14.9995, 49.0009],
  [15.0004, 49.0008],
  [14.9992, 49.0005],
  [14.9974, 48.9987],
  [14.9966, 48.9971],
  [14.9965, 48.995],
  [14.9956, 48.9945],
  [14.9957, 48.9937],
  [14.9951, 48.9932],
  [14.9978, 48.992],
  [14.9964, 48.9919],
  [14.9941, 48.9896],
  [14.9912, 48.9892],
  [14.991, 48.9884],
  [14.9916, 48.988],
  [14.9877, 48.9881],
  [14.9845, 48.9866],
  [14.9831, 48.9846],
  [14.9835, 48.9841],
  [14.9826, 48.9842],
  [14.9822, 48.9826],
  [14.9805, 48.981],
  [14.9811, 48.9806],
  [14.9802, 48.9802],
  [14.981, 48.9781],
  [14.9784, 48.9804],
  [14.9785, 48.9745],
  [14.9762, 48.971],
  [14.9778, 48.9605],
  [14.9776, 48.9582],
  [14.9765, 48.9558],
  [14.9806, 48.9439],
  [14.9846, 48.9415],
  [14.9833, 48.9404],
  [14.9852, 48.9395],
  [14.9865, 48.9359],
  [14.9837, 48.9325],
  [14.9794, 48.9313],
  [14.979, 48.928],
  [14.9849, 48.9245],
  [14.9839, 48.9231],
  [14.9859, 48.9195],
  [14.99, 48.9159],
  [14.9903, 48.9098],
  [14.9925, 48.906],
  [14.9929, 48.9037],
  [14.9916, 48.8973],
  [14.9896, 48.8973],
  [14.9873, 48.8957],
  [14.9888, 48.8948],
  [14.9889, 48.891],
  [14.9835, 48.891],
  [14.9838, 48.8747],
  [14.9729, 48.8747],
  [14.9733, 48.864],
  [14.9723, 48.8606],
  [14.9729, 48.8596],
  [14.9724, 48.8585],
  [14.9742, 48.855],
  [14.9734, 48.8531],
  [14.9777, 48.8531],
  [14.9782, 48.8507],
  [14.98, 48.8497],
  [14.982, 48.8471],
  [14.9845, 48.846],
  [14.9845, 48.8424],
  [14.9721, 48.8423],
  [14.9719, 48.8393],
  [14.9683, 48.8368],
  [14.9675, 48.8309],
  [14.9685, 48.8283],
  [14.9685, 48.8248],
  [14.9697, 48.8239],
  [14.9653, 48.82],
  [14.9609, 48.8175],
  [14.9582, 48.8139],
  [14.9574, 48.8107],
  [14.9588, 48.8062],
  [14.9605, 48.8045],
  [14.9553, 48.8014],
  [14.9565, 48.801],
  [14.9562, 48.8005],
  [14.9568, 48.8005],
  [14.9574, 48.7995],
  [14.9552, 48.7985],
  [14.9533, 48.7957],
  [14.9534, 48.794],
  [14.9556, 48.7928],
  [14.9547, 48.791],
  [14.955, 48.7905],
  [14.9533, 48.7898],
  [14.96, 48.7866],
  [14.9602, 48.787],
  [14.9737, 48.7832],
  [14.9789, 48.7802],
  [14.9801, 48.7792],
  [14.978, 48.7764],
  [14.9808, 48.7753],
  [14.9795, 48.7723],
  [14.9756, 48.7688],
  [14.9702, 48.7672],
  [14.9693, 48.7659],
  [14.9678, 48.7652],
  [14.9686, 48.7648],
  [14.968, 48.764],
  [14.9671, 48.7643],
  [14.9651, 48.7631],
  [14.9607, 48.7623],
  [14.9597, 48.7604],
  [14.9558, 48.7581],
  [14.9523, 48.7617],
  [14.9504, 48.7608],
  [14.9482, 48.7629],
  [14.9437, 48.7613],
  [14.9401, 48.7613],
  [14.9346, 48.7637],
  [14.9319, 48.7666],
  [14.9293, 48.7664],
  [14.927, 48.7673],
  [14.919, 48.7684],
  [14.9175, 48.7694],
  [14.9177, 48.7698],
  [14.9163, 48.7686],
  [14.9118, 48.767],
  [14.9062, 48.767],
  [14.8993, 48.7714],
  [14.8964, 48.7723],
  [14.893, 48.7724],
  [14.8881, 48.7701],
  [14.887, 48.7716],
  [14.8847, 48.7719],
  [14.8845, 48.7738],
  [14.8853, 48.7755],
  [14.8863, 48.776],
  [14.8861, 48.7764],
  [14.8813, 48.7801],
  [14.8722, 48.7808],
  [14.871, 48.7803],
  [14.8683, 48.7811],
  [14.8632, 48.7773],
  [14.8577, 48.7772],
  [14.8588, 48.776],
  [14.8572, 48.7758],
  [14.8547, 48.7771],
  [14.8511, 48.7773],
  [14.8489, 48.7804],
  [14.8468, 48.7807],
  [14.847, 48.78],
  [14.846, 48.7794],
  [14.8441, 48.7829],
  [14.8425, 48.784],
  [14.8409, 48.7833],
  [14.841, 48.7823],
  [14.8403, 48.782],
  [14.84, 48.7825],
  [14.8349, 48.7821],
  [14.8335, 48.781],
  [14.8293, 48.7805],
  [14.8272, 48.7815],
  [14.8255, 48.7838],
  [14.8226, 48.7831],
  [14.8202, 48.7813],
  [14.8129, 48.7803],
  [14.8104, 48.7787],
  [14.8098, 48.7793],
  [14.8087, 48.7788],
  [14.8088, 48.7745],
  [14.8099, 48.7739],
  [14.8063, 48.7717],
  [14.8109, 48.7672],
  [14.8112, 48.7655],
  [14.8122, 48.7644],
  [14.8114, 48.7631],
  [14.8115, 48.7615],
  [14.8084, 48.7578],
  [14.8073, 48.7578],
  [14.8049, 48.7533],
  [14.8031, 48.7527],
  [14.8038, 48.7516],
  [14.8017, 48.7507],
  [14.8005, 48.7474],
  [14.8025, 48.7425],
  [14.8081, 48.7339],
  [14.8017, 48.7317],
  [14.8011, 48.733],
  [14.7972, 48.7303],
  [14.7944, 48.7298],
  [14.7931, 48.7282],
  [14.7931, 48.7262],
  [14.7907, 48.7237],
  [14.787, 48.7222],
  [14.7873, 48.7208],
  [14.7856, 48.7183],
  [14.7804, 48.7149],
  [14.7754, 48.7131],
  [14.774, 48.7116],
  [14.757, 48.7093],
  [14.7566, 48.7052],
  [14.7554, 48.7032],
  [14.7507, 48.7027],
  [14.7482, 48.7032],
  [14.7408, 48.7013],
  [14.7366, 48.6989],
  [14.734, 48.6964],
  [14.7334, 48.6942],
  [14.7317, 48.6924],
  [14.731, 48.6908],
  [14.727, 48.6871],
  [14.726, 48.6852],
  [14.7259, 48.683],
  [14.727, 48.6787],
  [14.7252, 48.6764],
  [14.7235, 48.6757],
  [14.7182, 48.6661],
  [14.7123, 48.6501],
  [14.714, 48.6493],
  [14.7155, 48.6497],
  [14.7185, 48.6492],
  [14.7188, 48.6486],
  [14.7182, 48.6479],
  [14.7187, 48.6474],
  [14.7181, 48.6471],
  [14.718, 48.6457],
  [14.7188, 48.6444],
  [14.7183, 48.6439],
  [14.7191, 48.6428],
  [14.72, 48.6427],
  [14.7201, 48.6419],
  [14.7191, 48.6412],
  [14.7192, 48.6402],
  [14.72, 48.6389],
  [14.7222, 48.6384],
  [14.7141, 48.6174],
  [14.7211, 48.6024],
  [14.7192, 48.6006],
  [14.7184, 48.6008],
  [14.7141, 48.5977],
  [14.7114, 48.5966],
  [14.7116, 48.5941],
  [14.7081, 48.5936],
  [14.706, 48.5909],
  [14.7077, 48.5882],
  [14.7077, 48.5871],
  [14.7061, 48.585],
  [14.7017, 48.5837],
  [14.7015, 48.5827],
  [14.6936, 48.5854],
  [14.6915, 48.5841],
  [14.691, 48.5843],
  [14.6913, 48.5852],
  [14.6877, 48.5851],
  [14.6825, 48.5827],
  [14.6763, 48.5831],
  [14.6699, 48.5814],
  [14.6664, 48.5822],
  [14.6635, 48.582],
  [14.6577, 48.5981],
  [14.6558, 48.6002],
  [14.6538, 48.6043],
  [14.6496, 48.6071],
  [14.6477, 48.6094],
  [14.6457, 48.6101],
  [14.6403, 48.6079],
  [14.6392, 48.6065],
  [14.6362, 48.6061],
  [14.6346, 48.6046],
  [14.6326, 48.605],
  [14.6307, 48.6032],
  [14.6264, 48.6045],
  [14.6242, 48.6058],
  [14.6244, 48.6074],
  [14.6227, 48.6089],
  [14.6233, 48.6104],
  [14.623, 48.6113],
  [14.6214, 48.6122],
  [14.6213, 48.6129],
  [14.622, 48.6131],
  [14.6212, 48.615],
  [14.6216, 48.6156],
  [14.6209, 48.6157],
  [14.6203, 48.6175],
  [14.6187, 48.6184],
  [14.6193, 48.6192],
  [14.6182, 48.6202],
  [14.6178, 48.6219],
  [14.6163, 48.6224],
  [14.6157, 48.6239],
  [14.6141, 48.6244],
  [14.6148, 48.6249],
  [14.6141, 48.6251],
  [14.6142, 48.6258],
  [14.6105, 48.6281],
  [14.6085, 48.6279],
  [14.6071, 48.6286],
  [14.6031, 48.6281],
  [14.6035, 48.6278],
  [14.6026, 48.6271],
  [14.6031, 48.6269],
  [14.6025, 48.6267],
  [14.6024, 48.6256],
  [14.599, 48.6253],
  [14.5987, 48.6245],
  [14.5993, 48.6243],
  [14.5982, 48.6242],
  [14.5953, 48.6218],
  [14.5958, 48.6206],
  [14.593, 48.62],
  [14.5901, 48.6173],
  [14.5864, 48.618],
  [14.5844, 48.6176],
  [14.583, 48.6162],
  [14.5822, 48.6169],
  [14.5809, 48.6169],
  [14.5795, 48.6159],
  [14.5798, 48.615],
  [14.5782, 48.615],
  [14.5773, 48.6135],
  [14.5757, 48.6128],
  [14.5752, 48.6122],
  [14.576, 48.6116],
  [14.5756, 48.6111],
  [14.5723, 48.6117],
  [14.5704, 48.6104],
  [14.5685, 48.6107],
  [14.5672, 48.6086],
  [14.564, 48.6084],
  [14.5637, 48.6052],
  [14.5621, 48.6033],
  [14.559, 48.6042],
  [14.557, 48.606],
  [14.5535, 48.6058],
  [14.5515, 48.6077],
  [14.552, 48.6087],
  [14.5513, 48.6112],
  [14.5466, 48.6146],
  [14.5456, 48.6137],
  [14.5442, 48.6147],
  [14.5264, 48.6147],
  [14.5264, 48.6155],
  [14.5245, 48.6155],
  [14.5242, 48.6161],
  [14.5225, 48.6164],
  [14.5232, 48.617],
  [14.5221, 48.617],
  [14.5221, 48.6179],
  [14.5205, 48.6188],
  [14.5156, 48.6199],
  [14.5115, 48.6194],
  [14.5062, 48.6174],
  [14.5033, 48.6174],
  [14.5002, 48.6199],
  [14.4951, 48.6225],
  [14.4948, 48.6237],
  [14.4959, 48.6278],
  [14.4944, 48.6287],
  [14.4943, 48.6301],
  [14.4936, 48.6308],
  [14.4947, 48.631],
  [14.493, 48.6329],
  [14.4889, 48.6332],
  [14.4883, 48.634],
  [14.4872, 48.6337],
  [14.4874, 48.6341],
  [14.4864, 48.6345],
  [14.4852, 48.6342],
  [14.4853, 48.6351],
  [14.4839, 48.6356],
  [14.4836, 48.6352],
  [14.4827, 48.6359],
  [14.483, 48.6364],
  [14.4804, 48.637],
  [14.4796, 48.6385],
  [14.4766, 48.6395],
  [14.4754, 48.6407],
  [14.4755, 48.6416],
  [14.4777, 48.6418],
  [14.4776, 48.6426],
  [14.4747, 48.644],
  [14.4726, 48.644],
  [14.4707, 48.6465],
  [14.4715, 48.6467],
  [14.4699, 48.6485],
  [14.4687, 48.6476],
  [14.4686, 48.6462],
  [14.4592, 48.6442],
  [14.4591, 48.6433],
  [14.4533, 48.6447],
  [14.4533, 48.6439],
  [14.4438, 48.6434],
  [14.4443, 48.6399],
  [14.4456, 48.6378],
  [14.4525, 48.6319],
  [14.456, 48.6251],
  [14.4556, 48.6245],
  [14.4519, 48.6247],
  [14.4502, 48.6223],
  [14.4473, 48.6198],
  [14.4475, 48.6175],
  [14.4486, 48.6153],
  [14.4483, 48.613],
  [14.4447, 48.6084],
  [14.4435, 48.6037],
  [14.4414, 48.6013],
  [14.4422, 48.6002],
  [14.4393, 48.5998],
  [14.4355, 48.598],
  [14.4349, 48.5965],
  [14.4353, 48.5957],
  [14.4343, 48.5951],
  [14.4344, 48.5941],
  [14.4317, 48.5905],
  [14.4314, 48.5891],
  [14.4303, 48.5885],
  [14.4266, 48.5889],
  [14.4248, 48.5883],
  [14.42, 48.5913],
  [14.4122, 48.5928],
  [14.4115, 48.5924],
  [14.4094, 48.5928],
  [14.4073, 48.592],
  [14.4039, 48.5933],
  [14.4, 48.5923],
  [14.3989, 48.5929],
  [14.3958, 48.592],
  [14.3954, 48.5922],
  [14.3956, 48.5932],
  [14.3926, 48.5933],
  [14.3919, 48.5943],
  [14.3906, 48.5931],
  [14.3862, 48.5927],
  [14.3858, 48.5918],
  [14.387, 48.5911],
  [14.3866, 48.5902],
  [14.3876, 48.5888],
  [14.3869, 48.5882],
  [14.3873, 48.587],
  [14.3867, 48.587],
  [14.3879, 48.5861],
  [14.3871, 48.5848],
  [14.3879, 48.5838],
  [14.3877, 48.5832],
  [14.3889, 48.5824],
  [14.3915, 48.5821],
  [14.391, 48.5791],
  [14.3936, 48.5787],
  [14.3937, 48.5775],
  [14.3881, 48.5719],
  [14.3839, 48.5701],
  [14.3797, 48.5693],
  [14.3713, 48.5695],
  [14.3685, 48.5698],
  [14.3683, 48.5725],
  [14.3661, 48.5747],
  [14.3658, 48.5758],
  [14.3629, 48.5749],
  [14.3577, 48.5746],
  [14.3579, 48.5734],
  [14.3564, 48.5728],
  [14.3555, 48.5712],
  [14.3524, 48.5689],
  [14.3524, 48.5673],
  [14.3532, 48.5663],
  [14.3515, 48.565],
  [14.3534, 48.563],
  [14.3531, 48.5625],
  [14.3481, 48.5619],
  [14.3447, 48.5599],
  [14.3452, 48.559],
  [14.345, 48.5573],
  [14.3434, 48.5563],
  [14.3427, 48.5548],
  [14.3367, 48.5542],
  [14.3332, 48.5518],
  [14.3271, 48.5541],
  [14.3271, 48.5576],
  [14.3261, 48.5577],
  [14.3243, 48.5642],
  [14.3216, 48.563],
  [14.3153, 48.5634],
  [14.309, 48.5644],
  [14.3044, 48.5672],
  [14.3008, 48.5668],
  [14.2956, 48.5681],
  [14.2861, 48.5724],
  [14.2788, 48.5742],
  [14.2739, 48.5778],
  [14.2715, 48.5814],
  [14.2699, 48.5809],
  [14.2666, 48.5816],
  [14.2651, 48.581],
  [14.2616, 48.5818],
  [14.2577, 48.5813],
  [14.2559, 48.5816],
  [14.2545, 48.5807],
  [14.252, 48.5809],
  [14.2495, 48.5802],
  [14.2482, 48.5781],
  [14.2448, 48.5786],
  [14.2406, 48.5777],
  [14.2387, 48.5785],
  [14.2373, 48.5813],
  [14.2282, 48.5852],
  [14.2227, 48.5864],
  [14.2157, 48.5867],
  [14.2123, 48.5883],
  [14.208, 48.5882],
  [14.2047, 48.5904],
  [14.2013, 48.59],
  [14.1974, 48.5909],
  [14.1944, 48.5927],
  [14.1902, 48.593],
  [14.1877, 48.5925],
  [14.1817, 48.5939],
  [14.1799, 48.5925],
  [14.1782, 48.5931],
  [14.1772, 48.5927],
  [14.1775, 48.5911],
  [14.174, 48.5913],
  [14.1712, 48.5902],
  [14.1689, 48.5905],
  [14.1635, 48.5892],
  [14.1629, 48.5899],
  [14.1627, 48.591],
  [14.1635, 48.5916],
  [14.1628, 48.5926],
  [14.1581, 48.5923],
  [14.1577, 48.5934],
  [14.1556, 48.5937],
  [14.1558, 48.5948],
  [14.1545, 48.5959],
  [14.1518, 48.5959],
  [14.151, 48.5949],
  [14.148, 48.5943],
  [14.1434, 48.5948],
  [14.143, 48.594],
  [14.1419, 48.5937],
  [14.1403, 48.5947],
  [14.1379, 48.595],
  [14.1374, 48.5957],
  [14.1362, 48.5955],
  [14.1329, 48.5975],
  [14.1302, 48.5978],
  [14.1286, 48.5971],
  [14.1279, 48.5952],
  [14.1238, 48.593],
  [14.1201, 48.593],
  [14.1188, 48.5913],
  [14.1192, 48.5906],
  [14.1158, 48.5892],
  [14.1057, 48.5896],
  [14.0956, 48.5922],
  [14.0959, 48.594],
  [14.0983, 48.5978],
  [14.0971, 48.5998],
  [14.0942, 48.599],
  [14.0862, 48.6001],
  [14.0818, 48.5994],
  [14.0722, 48.5999],
  [14.0711, 48.5994],
  [14.0709, 48.5979],
  [14.0692, 48.5955],
  [14.067, 48.5949],
  [14.0663, 48.5961],
  [14.0662, 48.6011],
  [14.067, 48.6026],
  [14.0694, 48.6045],
  [14.0697, 48.6063],
  [14.069, 48.607],
  [14.0675, 48.6061],
  [14.061, 48.6065],
  [14.058, 48.6049],
  [14.0542, 48.6041],
  [14.0531, 48.6065],
  [14.0508, 48.6077],
  [14.0516, 48.6095],
  [14.049, 48.6109],
  [14.0421, 48.6129],
  [14.0437, 48.614],
  [14.0427, 48.6148],
  [14.0427, 48.6162],
  [14.0409, 48.6174],
  [14.0457, 48.6191],
  [14.0453, 48.6202],
  [14.0464, 48.6223],
  [14.0454, 48.6235],
  [14.0483, 48.6268],
  [14.0481, 48.6274],
  [14.0456, 48.6286],
  [14.0424, 48.629],
  [14.0382, 48.6276],
  [14.0325, 48.6276],
  [14.0287, 48.6262],
  [14.0301, 48.6268],
  [14.0302, 48.6287],
  [14.023, 48.6307],
  [14.0233, 48.6324],
  [14.0205, 48.6339],
  [14.0183, 48.6369],
  [14.0156, 48.6374],
  [14.0106, 48.6397],
  [14.0116, 48.6395],
  [14.0145, 48.6407],
  [14.017, 48.6432],
  [14.0229, 48.6456],
  [14.0242, 48.6476],
  [14.0242, 48.6527],
  [14.0256, 48.6522],
  [14.0287, 48.6527],
  [14.0326, 48.6544],
  [14.0406, 48.6547],
  [14.045, 48.6545],
  [14.0513, 48.6526],
  [14.0535, 48.6529],
  [14.0548, 48.6545],
  [14.0547, 48.6555],
  [14.0578, 48.6577],
  [14.0585, 48.6591],
  [14.0575, 48.6603],
  [14.058, 48.6618],
  [14.0601, 48.664],
  [14.0602, 48.6655],
  [14.0585, 48.6677],
  [14.0598, 48.6695],
  [14.0586, 48.6716],
  [14.0597, 48.6722],
  [14.0601, 48.6733],
  [14.0595, 48.6738],
  [14.0558, 48.6755],
  [14.0498, 48.6751],
  [14.0433, 48.6775],
  [14.0389, 48.6761],
  [14.0388, 48.677],
  [14.0371, 48.6774],
  [14.0342, 48.677],
  [14.0345, 48.6778],
  [14.0332, 48.6788],
  [14.0335, 48.6797],
  [14.0299, 48.681],
  [14.0275, 48.6827],
  [14.0246, 48.6834],
  [14.026, 48.6839],
  [14.0257, 48.6849],
  [14.0279, 48.6847],
  [14.0287, 48.6854],
  [14.0256, 48.6871],
  [14.0254, 48.6891],
  [14.0193, 48.6905],
  [14.0162, 48.6919],
  [14.0185, 48.6941],
  [14.0182, 48.6962],
  [14.0162, 48.6964],
  [14.0156, 48.6978],
  [14.015, 48.6977],
  [14.0146, 48.6965],
  [14.0127, 48.6949],
  [14.0099, 48.6954],
  [14.0116, 48.6968],
  [14.0127, 48.6971],
  [14.0134, 48.6984],
  [14.0115, 48.7003],
  [14.0103, 48.6998],
  [14.0088, 48.7023],
  [14.0083, 48.7038],
  [14.0098, 48.7048],
  [14.0073, 48.7065],
  [14.0053, 48.7061],
  [14.0052, 48.7072],
  [14.0034, 48.7085],
  [13.9841, 48.7109],
  [13.9813, 48.7098],
  [13.9782, 48.7098],
  [13.9762, 48.7114],
  [13.974, 48.7115],
  [13.9705, 48.7132],
  [13.9672, 48.7127],
  [13.9559, 48.7144],
  [13.9558, 48.7173],
  [13.9537, 48.7207],
  [13.9501, 48.721],
  [13.9442, 48.7224],
  [13.9428, 48.7214],
  [13.9392, 48.7232],
  [13.9378, 48.7245],
  [13.9372, 48.726],
  [13.9342, 48.7276],
  [13.9335, 48.7287],
  [13.9271, 48.7318],
  [13.9257, 48.7356],
  [13.9208, 48.737],
  [13.9197, 48.7408],
  [13.9163, 48.7426],
  [13.9102, 48.7475],
  [13.9045, 48.7499],
  [13.9009, 48.7537],
  [13.8955, 48.7571],
  [13.8892, 48.7585],
  [13.8829, 48.7619],
  [13.8761, 48.7666],
  [13.8684, 48.7696],
  [13.8619, 48.7695],
  [13.8573, 48.7713],
  [13.8552, 48.7714],
  [13.8485, 48.7698],
  [13.8432, 48.7726],
  [13.8396, 48.7716],
  [13.8396, 48.7664],
  [13.8361, 48.7627],
  [13.8262, 48.7581],
  [13.8252, 48.7569],
  [13.8229, 48.7566],
  [13.821, 48.7544],
  [13.8209, 48.7525],
  [13.8221, 48.7493],
  [13.8206, 48.7476],
  [13.8215, 48.7448],
  [13.8203, 48.742],
  [13.8205, 48.7393],
  [13.8184, 48.7375],
  [13.8188, 48.7369],
  [13.8178, 48.7358],
  [13.8181, 48.7341],
  [13.8192, 48.7337],
  [13.8191, 48.7318],
  [13.818, 48.7309],
  [13.8146, 48.7301],
  [13.814, 48.7292],
  [13.8104, 48.7289],
  [13.81, 48.7276],
  [13.8081, 48.7261],
  [13.8084, 48.7246],
  [13.8063, 48.724],
  [13.8062, 48.7233],
  [13.8036, 48.7216],
  [13.803, 48.7201],
  [13.8021, 48.7202],
  [13.8019, 48.7173],
  [13.8011, 48.7166],
  [13.7984, 48.7164],
  [13.7949, 48.7151],
  [13.7961, 48.7134],
  [13.7997, 48.7119],
  [13.8032, 48.7081],
  [13.8049, 48.7079],
  [13.8063, 48.7089],
  [13.8098, 48.7093],
  [13.8114, 48.7087],
  [13.8117, 48.7074],
  [13.8125, 48.7072],
  [13.8129, 48.7051],
  [13.8112, 48.7045],
  [13.8112, 48.7026],
  [13.8141, 48.7009],
  [13.8168, 48.7015],
  [13.8205, 48.6991],
  [13.8248, 48.6999],
  [13.8254, 48.7006],
  [13.8278, 48.7],
  [13.8279, 48.7007],
  [13.8299, 48.6997],
  [13.8306, 48.7],
  [13.8299, 48.7007],
  [13.8322, 48.701],
  [13.8331, 48.7003],
  [13.834, 48.7006],
  [13.8331, 48.701],
  [13.8336, 48.7012],
  [13.8347, 48.7008],
  [13.8344, 48.7002],
  [13.8374, 48.7005],
  [13.836, 48.6973],
  [13.835, 48.6969],
  [13.8353, 48.6956],
  [13.8346, 48.695],
  [13.8345, 48.6931],
  [13.8335, 48.6919],
  [13.8303, 48.6925],
  [13.8295, 48.6919],
  [13.8271, 48.6921],
  [13.825, 48.6927],
  [13.8237, 48.6941],
  [13.8171, 48.6948],
  [13.8158, 48.6944],
  [13.8135, 48.6918],
  [13.814, 48.6915],
  [13.8135, 48.6902],
  [13.8142, 48.6889],
  [13.8144, 48.6856],
  [13.8131, 48.6836],
  [13.8146, 48.6821],
  [13.8167, 48.6813],
  [13.8162, 48.681],
  [13.8173, 48.6796],
  [13.8165, 48.679],
  [13.8177, 48.6774],
  [13.8181, 48.6757],
  [13.8193, 48.675],
  [13.8187, 48.6736],
  [13.8195, 48.6729],
  [13.8198, 48.6704],
  [13.8175, 48.6665],
  [13.8184, 48.6636],
  [13.8174, 48.6622],
  [13.8177, 48.6594],
  [13.8163, 48.6577],
  [13.8166, 48.6563],
  [13.8145, 48.6527],
  [13.8147, 48.6505],
  [13.8141, 48.6497],
  [13.8186, 48.6464],
  [13.8183, 48.6456],
  [13.8188, 48.6448],
  [13.8196, 48.645],
  [13.8203, 48.6438],
  [13.823, 48.643],
  [13.824, 48.6421],
  [13.8237, 48.641],
  [13.822, 48.6399],
  [13.8216, 48.6387],
  [13.8223, 48.6375],
  [13.8251, 48.6367],
  [13.8265, 48.6348],
  [13.8253, 48.633],
  [13.8258, 48.6319],
  [13.8254, 48.6307],
  [13.8272, 48.628],
  [13.8235, 48.6254],
  [13.8245, 48.6239],
  [13.8245, 48.6221],
  [13.8255, 48.6215],
  [13.8247, 48.6198],
  [13.8253, 48.6194],
  [13.8248, 48.6192],
  [13.8256, 48.619],
  [13.825, 48.6187],
  [13.8258, 48.6186],
  [13.8251, 48.6178],
  [13.823, 48.6175],
  [13.8235, 48.6169],
  [13.8221, 48.6156],
  [13.8229, 48.6155],
  [13.8224, 48.615],
  [13.8226, 48.6142],
  [13.8196, 48.6133],
  [13.8177, 48.6139],
  [13.8174, 48.6147],
  [13.816, 48.6146],
  [13.8141, 48.6122],
  [13.8149, 48.6118],
  [13.8144, 48.6115],
  [13.815, 48.6112],
  [13.8145, 48.6098],
  [13.8149, 48.6096],
  [13.8134, 48.6087],
  [13.8122, 48.6091],
  [13.8104, 48.6086],
  [13.8114, 48.6079],
  [13.81, 48.6066],
  [13.8101, 48.6059],
  [13.8074, 48.605],
  [13.8085, 48.6037],
  [13.8081, 48.6032],
  [13.8087, 48.6033],
  [13.8088, 48.6016],
  [13.8093, 48.6016],
  [13.8084, 48.6014],
  [13.8086, 48.6009],
  [13.8081, 48.6003],
  [13.8087, 48.5999],
  [13.8051, 48.5992],
  [13.8051, 48.5986],
  [13.8029, 48.5986],
  [13.8013, 48.5974],
  [13.8023, 48.5965],
  [13.8016, 48.5965],
  [13.8021, 48.5961],
  [13.8008, 48.5954],
  [13.8016, 48.5941],
  [13.8015, 48.5926],
  [13.804, 48.591],
  [13.8071, 48.5901],
  [13.8054, 48.5897],
  [13.8051, 48.5889],
  [13.8063, 48.5885],
  [13.8057, 48.587],
  [13.8073, 48.5844],
  [13.8048, 48.5816],
  [13.8059, 48.5798],
  [13.8039, 48.5786],
  [13.8025, 48.575],
  [13.8009, 48.5742],
  [13.8009, 48.5736],
  [13.7962, 48.5727],
  [13.7953, 48.5719],
  [13.7936, 48.5726],
  [13.7904, 48.5719],
  [13.7898, 48.5701],
  [13.7885, 48.5685],
  [13.7849, 48.5675],
  [13.783, 48.566],
  [13.7812, 48.5654],
  [13.7814, 48.5634],
  [13.7802, 48.5621],
  [13.7759, 48.56],
  [13.7753, 48.5581],
  [13.7734, 48.5579],
  [13.772, 48.556],
  [13.7732, 48.5551],
  [13.7701, 48.5536],
  [13.7681, 48.5536],
  [13.7664, 48.5582],
  [13.7645, 48.5598],
  [13.7603, 48.5655],
  [13.7557, 48.565],
  [13.7541, 48.5636],
  [13.7505, 48.5577],
  [13.7496, 48.5568],
  [13.7481, 48.5567],
  [13.7477, 48.556],
  [13.7493, 48.554],
  [13.7476, 48.5542],
  [13.7467, 48.5524],
  [13.7516, 48.5527],
  [13.7549, 48.5512],
  [13.7518, 48.5496],
  [13.7502, 48.5478],
  [13.7478, 48.5465],
  [13.7459, 48.5464],
  [13.7437, 48.544],
  [13.745, 48.5404],
  [13.7484, 48.5396],
  [13.7489, 48.538],
  [13.7491, 48.5322],
  [13.748, 48.5315],
  [13.7478, 48.5294],
  [13.747, 48.5295],
  [13.7455, 48.5282],
  [13.7431, 48.5282],
  [13.7406, 48.5267],
  [13.7348, 48.5261],
  [13.7333, 48.5253],
  [13.7335, 48.5221],
  [13.7308, 48.5211],
  [13.7314, 48.5191],
  [13.7308, 48.5178],
  [13.7322, 48.5166],
  [13.7305, 48.5148],
  [13.7283, 48.5144],
  [13.7271, 48.513],
  [13.7068, 48.5173],
  [13.7039, 48.5186],
  [13.6982, 48.5231],
  [13.6859, 48.5284],
  [13.6715, 48.5317],
  [13.6641, 48.5342],
  [13.6607, 48.5369],
  [13.6576, 48.5438],
  [13.6555, 48.5473],
  [13.6537, 48.5489],
  [13.6421, 48.5523],
  [13.6301, 48.5531],
  [13.6246, 48.5545],
  [13.6132, 48.5604],
  [13.6057, 48.5669],
  [13.5998, 48.5694],
  [13.5946, 48.5699],
  [13.5897, 48.5685],
  [13.5873, 48.5666],
  [13.5837, 48.5609],
  [13.5815, 48.5597],
  [13.5791, 48.5595],
  [13.5709, 48.561],
  [13.5647, 48.5631],
  [13.5582, 48.5673],
  [13.5435, 48.5748],
  [13.5323, 48.5843],
  [13.5277, 48.5872],
  [13.5173, 48.5906],
  [13.5119, 48.5911],
  [13.509, 48.5906],
  [13.5052, 48.5878],
  [13.5017, 48.5809],
  [13.5026, 48.5807],
  [13.5038, 48.5798],
  [13.5034, 48.5794],
  [13.5051, 48.5792],
  [13.5052, 48.5777],
  [13.507, 48.5777],
  [13.5065, 48.5757],
  [13.5044, 48.5738],
  [13.504, 48.5725],
  [13.5004, 48.5706],
  [13.4959, 48.5694],
  [13.4919, 48.5697],
  [13.4914, 48.5691],
  [13.4932, 48.5679],
  [13.4934, 48.567],
  [13.4918, 48.5656],
  [13.4917, 48.5643],
  [13.4888, 48.5628],
  [13.4862, 48.563],
  [13.4849, 48.5615],
  [13.4789, 48.5647],
  [13.4745, 48.5624],
  [13.4764, 48.5589],
  [13.4748, 48.5575],
  [13.4754, 48.5561],
  [13.4683, 48.5539],
  [13.4636, 48.554],
  [13.462, 48.5555],
  [13.4588, 48.5562],
  [13.4562, 48.558],
  [13.4557, 48.5607],
  [13.45, 48.5639],
  [13.4458, 48.5613],
  [13.4394, 48.5588],
  [13.4378, 48.5574],
  [13.4368, 48.5543],
  [13.4387, 48.5485],
  [13.4427, 48.5438],
  [13.4492, 48.5392],
  [13.4501, 48.5376],
  [13.4506, 48.5354],
  [13.45, 48.5336],
  [13.4459, 48.5309],
  [13.445, 48.5291],
  [13.4464, 48.5236],
  [13.4574, 48.5136],
  [13.4582, 48.5119],
  [13.4578, 48.5106],
  [13.4533, 48.5054],
  [13.448, 48.4965],
  [13.4466, 48.491],
  [13.4385, 48.477],
  [13.437, 48.4731],
  [13.4326, 48.4681],
  [13.427, 48.4566],
  [13.4271, 48.4541],
  [13.4282, 48.4513],
  [13.4358, 48.4434],
  [13.4389, 48.4386],
  [13.44, 48.4344],
  [13.4393, 48.4308],
  [13.422, 48.4047],
  [13.4196, 48.3979],
  [13.418, 48.3849],
  [13.4146, 48.3786],
  [13.4114, 48.3747],
  [13.406, 48.3712],
  [13.3677, 48.3532],
  [13.3617, 48.3489],
  [13.3495, 48.3376],
  [13.3298, 48.3235],
  [13.3212, 48.3191],
  [13.2616, 48.2951],
  [13.2562, 48.2936],
  [13.2478, 48.2929],
  [13.1924, 48.2956],
  [13.1808, 48.295],
  [13.169, 48.2924],
  [13.1376, 48.281],
  [13.1282, 48.2785],
  [13.1171, 48.2773],
  [13.0889, 48.2783],
  [13.0806, 48.2771],
  [13.0729, 48.2744],
  [13.0625, 48.2684],
  [13.0575, 48.2662],
  [13.0217, 48.2578],
  [13.0162, 48.2553],
  [13.0123, 48.2524],
  [13.0036, 48.2416],
  [12.9991, 48.2376],
  [12.9759, 48.222],
  [12.9666, 48.2147],
  [12.9619, 48.2118],
  [12.9561, 48.2093],
  [12.9458, 48.2067],
  [12.917, 48.2064],
  [12.9028, 48.2043],
  [12.8782, 48.203],
  [12.8729, 48.2023],
  [12.8701, 48.2013],
  [12.8664, 48.1991],
  [12.865, 48.1976],
  [12.8627, 48.1898],
  [12.8605, 48.1851],
  [12.859, 48.1831],
  [12.8523, 48.1776],
  [12.8477, 48.1674],
  [12.8439, 48.1657],
  [12.8396, 48.1663],
  [12.836, 48.1653],
  [12.8348, 48.1634],
  [12.8352, 48.1597],
  [12.8346, 48.1582],
  [12.8328, 48.1561],
  [12.8275, 48.1529],
  [12.8118, 48.1516],
  [12.7994, 48.1468],
  [12.7976, 48.1445],
  [12.798, 48.1407],
  [12.7973, 48.1383],
  [12.7869, 48.1237],
  [12.7848, 48.1229],
  [12.7822, 48.1231],
  [12.7748, 48.1272],
  [12.7684, 48.1287],
  [12.7631, 48.1286],
  [12.759, 48.127],
  [12.7579, 48.1253],
  [12.7592, 48.1211],
  [12.7587, 48.1187],
  [12.7503, 48.1116],
  [12.7492, 48.1085],
  [12.753, 48.0868],
  [12.7562, 48.0798],
  [12.7595, 48.0752],
  [12.7702, 48.0661],
  [12.8387, 48.0251],
  [12.8502, 48.0162],
  [12.8549, 48.0112],
  [12.8573, 48.0076],
  [12.8594, 47.9991],
  [12.8623, 47.9917],
  [12.8685, 47.971],
  [12.8703, 47.9675],
  [12.8739, 47.9639],
  [12.8786, 47.9612],
  [12.8839, 47.9595],
  [12.9101, 47.9574],
  [12.9173, 47.955],
  [12.9197, 47.9534],
  [12.9207, 47.9514],
  [12.9192, 47.9449],
  [12.9193, 47.9423],
  [12.9205, 47.9406],
  [12.9226, 47.9394],
  [12.9259, 47.939],
  [12.9323, 47.9399],
  [12.9345, 47.941],
  [12.9358, 47.9439],
  [12.9382, 47.9433],
  [12.9389, 47.9422],
  [12.939, 47.9376],
  [12.9407, 47.9322],
  [12.9459, 47.9228],
  [12.9507, 47.9168],
  [12.9642, 47.9037],
  [12.9816, 47.8768],
  [12.9876, 47.8692],
  [13.0014, 47.8544],
  [13.0036, 47.8493],
  [13.0041, 47.8455],
  [13.0027, 47.8418],
  [12.9983, 47.8378],
  [12.9891, 47.832],
  [12.9842, 47.8278],
  [12.9767, 47.8154],
  [12.9642, 47.8],
  [12.9617, 47.7977],
  [12.9517, 47.7913],
  [12.947, 47.7864],
  [12.9433, 47.7862],
  [12.9396, 47.785],
  [12.9384, 47.7833],
  [12.9397, 47.78],
  [12.9395, 47.7782],
  [12.9328, 47.7757],
  [12.9296, 47.773],
  [12.9277, 47.7699],
  [12.9287, 47.7696],
  [12.9327, 47.7707],
  [12.9348, 47.7723],
  [12.9357, 47.772],
  [12.9348, 47.7702],
  [12.9422, 47.771],
  [12.9448, 47.7644],
  [12.9407, 47.7599],
  [12.9363, 47.7589],
  [12.9351, 47.7579],
  [12.9355, 47.757],
  [12.9369, 47.7583],
  [12.9379, 47.7579],
  [12.9379, 47.7567],
  [12.9359, 47.7539],
  [12.9363, 47.7491],
  [12.9352, 47.7473],
  [12.9342, 47.748],
  [12.9329, 47.7473],
  [12.931, 47.7449],
  [12.9213, 47.7442],
  [12.9211, 47.7435],
  [12.9182, 47.7426],
  [12.9161, 47.7392],
  [12.9151, 47.7394],
  [12.9144, 47.7377],
  [12.9123, 47.737],
  [12.9124, 47.7362],
  [12.9112, 47.7351],
  [12.9118, 47.7335],
  [12.9107, 47.7316],
  [12.9093, 47.731],
  [12.908, 47.7293],
  [12.9046, 47.7274],
  [12.9042, 47.7256],
  [12.9053, 47.7234],
  [12.9083, 47.7224],
  [12.9112, 47.7202],
  [12.9129, 47.7174],
  [12.9166, 47.7169],
  [12.9185, 47.715],
  [12.923, 47.7139],
  [12.9239, 47.7114],
  [12.925, 47.711],
  [12.9249, 47.7103],
  [12.9332, 47.7096],
  [12.9391, 47.7117],
  [12.9444, 47.7115],
  [12.9465, 47.7122],
  [12.9507, 47.7108],
  [12.9555, 47.7078],
  [12.9567, 47.7078],
  [12.9596, 47.7093],
  [12.9627, 47.7095],
  [12.9663, 47.708],
  [12.9738, 47.7072],
  [12.9754, 47.7076],
  [12.9872, 47.7074],
  [12.9915, 47.7086],
  [12.9912, 47.7097],
  [12.9923, 47.7112],
  [12.995, 47.7131],
  [13.0019, 47.7133],
  [13.0031, 47.7146],
  [13.0045, 47.7151],
  [13.006, 47.7169],
  [13.0048, 47.7181],
  [13.0075, 47.7205],
  [13.0079, 47.7203],
  [13.0087, 47.7224],
  [13.0105, 47.7229],
  [13.0129, 47.7224],
  [13.0183, 47.7229],
  [13.0194, 47.7215],
  [13.0228, 47.7209],
  [13.0265, 47.7176],
  [13.027, 47.7166],
  [13.0288, 47.7159],
  [13.0308, 47.7169],
  [13.0335, 47.7165],
  [13.043, 47.7139],
  [13.0423, 47.7128],
  [13.0461, 47.7126],
  [13.0495, 47.7105],
  [13.048, 47.7091],
  [13.0527, 47.7053],
  [13.0557, 47.7038],
  [13.0567, 47.7017],
  [13.0609, 47.6971],
  [13.0631, 47.6958],
  [13.0645, 47.6957],
  [13.0692, 47.6919],
  [13.0742, 47.6919],
  [13.0785, 47.6881],
  [13.0807, 47.687],
  [13.0795, 47.6844],
  [13.0797, 47.6819],
  [13.0788, 47.6814],
  [13.0777, 47.6772],
  [13.078, 47.6746],
  [13.0769, 47.6728],
  [13.0769, 47.6708],
  [13.0781, 47.6669],
  [13.0801, 47.6625],
  [13.0844, 47.6605],
  [13.0857, 47.658],
  [13.0895, 47.6543],
  [13.0882, 47.6501],
  [13.0885, 47.6491],
  [13.0906, 47.6468],
  [13.0918, 47.6445],
  [13.0952, 47.6426],
  [13.097, 47.6407],
  [13.0989, 47.6352],
  [13.0967, 47.6318],
  [13.0959, 47.628],
  [13.0931, 47.627],
  [13.0911, 47.6247],
  [13.0852, 47.6209],
  [13.0806, 47.619],
  [13.0794, 47.6168],
  [13.0784, 47.6164],
  [13.0778, 47.6148],
  [13.0717, 47.6106],
  [13.072, 47.6091],
  [13.0714, 47.6071],
  [13.0695, 47.6048],
  [13.0641, 47.603],
  [13.0631, 47.6022],
  [13.0634, 47.6017],
  [13.0626, 47.6015],
  [13.063, 47.5996],
  [13.0639, 47.5989],
  [13.0642, 47.5962],
  [13.0673, 47.5938],
  [13.0681, 47.5922],
  [13.0712, 47.5915],
  [13.0721, 47.5884],
  [13.0706, 47.587],
  [13.0685, 47.5858],
  [13.0654, 47.5864],
  [13.0604, 47.5855],
  [13.0564, 47.5856],
  [13.0437, 47.5834],
  [13.0441, 47.5808],
  [13.045, 47.5802],
  [13.0451, 47.5792],
  [13.0435, 47.5774],
  [13.0416, 47.5765],
  [13.0427, 47.5737],
  [13.0436, 47.5733],
  [13.0443, 47.5717],
  [13.0462, 47.5708],
  [13.0471, 47.5693],
  [13.0463, 47.5689],
  [13.0488, 47.5669],
  [13.0507, 47.5636],
  [13.0533, 47.5625],
  [13.0575, 47.5621],
  [13.0565, 47.5617],
  [13.0565, 47.5604],
  [13.0552, 47.5596],
  [13.0557, 47.5573],
  [13.0489, 47.5522],
  [13.0447, 47.5503],
  [13.0451, 47.548],
  [13.0435, 47.5461],
  [13.0372, 47.5428],
  [13.0367, 47.5421],
  [13.0381, 47.5411],
  [13.0371, 47.5407],
  [13.0367, 47.5395],
  [13.0349, 47.5389],
  [13.0341, 47.5366],
  [13.0317, 47.5355],
  [13.0309, 47.5326],
  [13.0331, 47.5303],
  [13.0357, 47.5293],
  [13.0374, 47.5276],
  [13.0422, 47.5264],
  [13.0463, 47.5239],
  [13.0473, 47.5215],
  [13.046, 47.5205],
  [13.0433, 47.5199],
  [13.0441, 47.519],
  [13.0434, 47.5188],
  [13.0438, 47.5161],
  [13.0461, 47.5158],
  [13.0467, 47.5148],
  [13.0461, 47.5104],
  [13.0469, 47.5058],
  [13.0461, 47.5037],
  [13.0478, 47.5008],
  [13.0483, 47.4981],
  [13.0481, 47.4964],
  [13.046, 47.4947],
  [13.0476, 47.4922],
  [13.0442, 47.491],
  [13.0419, 47.4887],
  [13.0362, 47.4891],
  [13.0326, 47.4869],
  [13.0269, 47.4867],
  [13.0258, 47.4851],
  [13.0265, 47.4834],
  [13.0246, 47.482],
  [13.024, 47.4801],
  [13.0224, 47.479],
  [13.0219, 47.4776],
  [13.0197, 47.4774],
  [13.0184, 47.4763],
  [13.0162, 47.4719],
  [13.0148, 47.4707],
  [13.0103, 47.4685],
  [13.0066, 47.4644],
  [13.0037, 47.4634],
  [13.001, 47.464],
  [12.9974, 47.4696],
  [12.9934, 47.4717],
  [12.9948, 47.4786],
  [12.992, 47.4786],
  [12.9894, 47.4776],
  [12.9862, 47.4795],
  [12.9864, 47.4803],
  [12.9856, 47.4815],
  [12.9811, 47.483],
  [12.9779, 47.483],
  [12.9775, 47.4838],
  [12.978, 47.4847],
  [12.9751, 47.485],
  [12.9735, 47.4833],
  [12.9744, 47.4807],
  [12.9726, 47.4785],
  [12.9727, 47.4743],
  [12.9682, 47.4745],
  [12.9638, 47.4753],
  [12.9604, 47.4771],
  [12.9527, 47.4792],
  [12.9326, 47.4882],
  [12.9319, 47.4878],
  [12.9299, 47.4884],
  [12.9285, 47.4897],
  [12.9087, 47.4969],
  [12.8862, 47.5124],
  [12.8845, 47.5128],
  [12.8855, 47.5145],
  [12.8846, 47.5154],
  [12.8848, 47.5166],
  [12.8843, 47.5167],
  [12.8853, 47.5185],
  [12.8828, 47.5206],
  [12.8807, 47.5219],
  [12.8755, 47.523],
  [12.8744, 47.5227],
  [12.8717, 47.5239],
  [12.8672, 47.524],
  [12.8647, 47.5252],
  [12.8638, 47.5264],
  [12.8639, 47.5277],
  [12.8633, 47.5281],
  [12.8573, 47.5269],
  [12.8547, 47.5298],
  [12.8532, 47.5297],
  [12.8517, 47.5308],
  [12.8502, 47.5331],
  [12.8501, 47.5346],
  [12.8493, 47.5361],
  [12.8501, 47.5365],
  [12.8496, 47.5391],
  [12.8503, 47.5405],
  [12.8483, 47.5424],
  [12.8485, 47.5444],
  [12.8477, 47.546],
  [12.8426, 47.5468],
  [12.8396, 47.5456],
  [12.8354, 47.5449],
  [12.8285, 47.5446],
  [12.8225, 47.5459],
  [12.8177, 47.5449],
  [12.8153, 47.5464],
  [12.8102, 47.5472],
  [12.8073, 47.5484],
  [12.8039, 47.5501],
  [12.7991, 47.5544],
  [12.7943, 47.557],
  [12.7928, 47.5601],
  [12.7924, 47.5651],
  [12.7892, 47.5659],
  [12.7885, 47.567],
  [12.787, 47.5672],
  [12.7843, 47.5689],
  [12.7817, 47.574],
  [12.7801, 47.5745],
  [12.7807, 47.576],
  [12.7801, 47.5783],
  [12.7791, 47.5791],
  [12.7817, 47.5811],
  [12.7815, 47.5824],
  [12.7837, 47.585],
  [12.7867, 47.5864],
  [12.7874, 47.5886],
  [12.7936, 47.5911],
  [12.7953, 47.5932],
  [12.794, 47.5953],
  [12.7928, 47.5957],
  [12.7913, 47.5978],
  [12.7929, 47.6006],
  [12.7943, 47.6015],
  [12.7965, 47.6018],
  [12.7975, 47.6038],
  [12.7994, 47.6052],
  [12.8012, 47.6058],
  [12.8028, 47.6054],
  [12.8032, 47.6073],
  [12.8074, 47.6103],
  [12.8105, 47.6107],
  [12.8133, 47.612],
  [12.8229, 47.6096],
  [12.8245, 47.6121],
  [12.811, 47.6213],
  [12.7993, 47.626],
  [12.7998, 47.6273],
  [12.7976, 47.6277],
  [12.7897, 47.6332],
  [12.785, 47.6322],
  [12.7809, 47.6327],
  [12.7719, 47.639],
  [12.7705, 47.6414],
  [12.766, 47.6439],
  [12.7648, 47.6472],
  [12.7597, 47.6502],
  [12.7586, 47.6516],
  [12.7584, 47.6529],
  [12.7607, 47.655],
  [12.7635, 47.6558],
  [12.7676, 47.6554],
  [12.7706, 47.6571],
  [12.7729, 47.6577],
  [12.7785, 47.6609],
  [12.778, 47.6629],
  [12.7819, 47.6668],
  [12.783, 47.6694],
  [12.7827, 47.67],
  [12.7841, 47.6715],
  [12.7812, 47.6738],
  [12.7789, 47.6723],
  [12.7741, 47.667],
  [12.7721, 47.6656],
  [12.7668, 47.6671],
  [12.7633, 47.667],
  [12.7614, 47.6663],
  [12.7587, 47.6635],
  [12.7572, 47.663],
  [12.757, 47.6642],
  [12.7561, 47.6643],
  [12.7555, 47.6654],
  [12.756, 47.6663],
  [12.7545, 47.6669],
  [12.7547, 47.6681],
  [12.7519, 47.6692],
  [12.7506, 47.6706],
  [12.7507, 47.6716],
  [12.7473, 47.6736],
  [12.7461, 47.675],
  [12.7442, 47.6759],
  [12.7392, 47.6762],
  [12.7378, 47.6776],
  [12.7353, 47.678],
  [12.7321, 47.6797],
  [12.7152, 47.6763],
  [12.7096, 47.6784],
  [12.7051, 47.6811],
  [12.7007, 47.6797],
  [12.6958, 47.6822],
  [12.6892, 47.6812],
  [12.6851, 47.6813],
  [12.6838, 47.6826],
  [12.6782, 47.6825],
  [12.6705, 47.6806],
  [12.6661, 47.681],
  [12.6573, 47.6761],
  [12.6569, 47.674],
  [12.6554, 47.6734],
  [12.6549, 47.6721],
  [12.6514, 47.6717],
  [12.6483, 47.6701],
  [12.6466, 47.6732],
  [12.6436, 47.6734],
  [12.6388, 47.671],
  [12.6363, 47.6733],
  [12.6301, 47.6762],
  [12.627, 47.675],
  [12.6232, 47.6748],
  [12.6218, 47.6734],
  [12.6169, 47.6724],
  [12.6092, 47.6739],
  [12.6073, 47.6737],
  [12.6037, 47.6725],
  [12.6021, 47.6687],
  [12.5969, 47.6661],
  [12.5829, 47.6473],
  [12.5808, 47.6403],
  [12.5784, 47.637],
  [12.578, 47.6342],
  [12.575, 47.6323],
  [12.5364, 47.6365],
  [12.5252, 47.6307],
  [12.5123, 47.6253],
  [12.4992, 47.6251],
  [12.4907, 47.6351],
  [12.4913, 47.6369],
  [12.4702, 47.6477],
  [12.4651, 47.6497],
  [12.4564, 47.6604],
  [12.4555, 47.6628],
  [12.4538, 47.6634],
  [12.4524, 47.6672],
  [12.4527, 47.6679],
  [12.45, 47.6687],
  [12.4477, 47.6705],
  [12.4453, 47.6709],
  [12.4442, 47.6717],
  [12.4457, 47.6727],
  [12.4446, 47.6739],
  [12.4407, 47.6739],
  [12.4389, 47.6762],
  [12.4408, 47.6771],
  [12.4409, 47.6787],
  [12.4395, 47.6797],
  [12.4416, 47.684],
  [12.4409, 47.685],
  [12.4416, 47.6864],
  [12.4412, 47.6878],
  [12.4423, 47.6887],
  [12.4427, 47.6899],
  [12.4419, 47.6907],
  [12.443, 47.6918],
  [12.4405, 47.6936],
  [12.4401, 47.6952],
  [12.4326, 47.6944],
  [12.4291, 47.6964],
  [12.4136, 47.6936],
  [12.4014, 47.6923],
  [12.3915, 47.6892],
  [12.3838, 47.6877],
  [12.3807, 47.6864],
  [12.3781, 47.6865],
  [12.374, 47.6851],
  [12.3636, 47.6838],
  [12.357, 47.6904],
  [12.3525, 47.6907],
  [12.3515, 47.6921],
  [12.3447, 47.6923],
  [12.3398, 47.6903],
  [12.3361, 47.6918],
  [12.3351, 47.6927],
  [12.338, 47.6971],
  [12.2921, 47.6901],
  [12.2847, 47.6901],
  [12.2775, 47.6879],
  [12.2712, 47.684],
  [12.2677, 47.6808],
  [12.2632, 47.6783],
  [12.2552, 47.6795],
  [12.253, 47.6838],
  [12.2459, 47.6878],
  [12.2413, 47.6944],
  [12.2469, 47.711],
  [12.2507, 47.7127],
  [12.2509, 47.7145],
  [12.2543, 47.7174],
  [12.2551, 47.7194],
  [12.2576, 47.7213],
  [12.265, 47.7325],
  [12.2632, 47.7369],
  [12.257, 47.743],
  [12.2497, 47.7416],
  [12.2398, 47.7324],
  [12.2267, 47.7181],
  [12.212, 47.7112],
  [12.208, 47.71],
  [12.2069, 47.7107],
  [12.206, 47.7105],
  [12.2036, 47.7074],
  [12.1994, 47.7076],
  [12.1977, 47.7088],
  [12.1965, 47.7085],
  [12.1864, 47.7037],
  [12.1858, 47.702],
  [12.1835, 47.7005],
  [12.1624, 47.7012],
  [12.1648, 47.6898],
  [12.1684, 47.6806],
  [12.1719, 47.6762],
  [12.1822, 47.668],
  [12.1836, 47.6654],
  [12.185, 47.6597],
  [12.1957, 47.6461],
  [12.1991, 47.6409],
  [12.2026, 47.6303],
  [12.2037, 47.623],
  [12.2082, 47.6135],
  [12.2073, 47.6097],
  [12.2059, 47.6079],
  [12.204, 47.6068],
  [12.1943, 47.6051],
  [12.1858, 47.6047],
  [12.1804, 47.6025],
  [12.1781, 47.6009],
  [12.1773, 47.6013],
  [12.1798, 47.605],
  [12.1801, 47.6082],
  [12.1814, 47.6104],
  [12.179, 47.6144],
  [12.1724, 47.6141],
  [12.171, 47.6145],
  [12.1636, 47.6134],
  [12.156, 47.6102],
  [12.1513, 47.6095],
  [12.1483, 47.6078],
  [12.1454, 47.6075],
  [12.1398, 47.6053],
  [12.1325, 47.6063],
  [12.129, 47.6056],
  [12.1251, 47.607],
  [12.1233, 47.6083],
  [12.1205, 47.6087],
  [12.1194, 47.6101],
  [12.1152, 47.6115],
  [12.1096, 47.6117],
  [12.0974, 47.61],
  [12.0933, 47.6105],
  [12.0824, 47.6097],
  [12.0796, 47.6111],
  [12.0782, 47.6135],
  [12.0708, 47.6147],
  [12.0653, 47.6168],
  [12.0642, 47.6187],
  [12.0607, 47.6188],
  [12.06, 47.6176],
  [12.0543, 47.6153],
  [12.0512, 47.6149],
  [12.0461, 47.6163],
  [12.0373, 47.6176],
  [12.0343, 47.6168],
  [12.0335, 47.6155],
  [12.0314, 47.6148],
  [12.0309, 47.613],
  [12.0286, 47.6113],
  [12.0219, 47.6111],
  [12.0196, 47.612],
  [12.0162, 47.6184],
  [12.0123, 47.6218],
  [12.0128, 47.6232],
  [12.0085, 47.6252],
  [12.0064, 47.6235],
  [11.9995, 47.6215],
  [11.9899, 47.6208],
  [11.9809, 47.6189],
  [11.9768, 47.6148],
  [11.9762, 47.613],
  [11.9744, 47.6154],
  [11.9682, 47.6172],
  [11.953, 47.6159],
  [11.9333, 47.6127],
  [11.9137, 47.6138],
  [11.9067, 47.6097],
  [11.9023, 47.6082],
  [11.8952, 47.609],
  [11.865, 47.6019],
  [11.8636, 47.6009],
  [11.86, 47.6011],
  [11.8585, 47.6019],
  [11.856, 47.6017],
  [11.855, 47.6024],
  [11.8474, 47.5823],
  [11.8454, 47.5821],
  [11.844, 47.5812],
  [11.8412, 47.5814],
  [11.8397, 47.5822],
  [11.8294, 47.5821],
  [11.8284, 47.5854],
  [11.8274, 47.5855],
  [11.8246, 47.5849],
  [11.8188, 47.585],
  [11.817, 47.5844],
  [11.7896, 47.5877],
  [11.781, 47.5912],
  [11.7758, 47.5906],
  [11.7722, 47.5896],
  [11.7696, 47.5894],
  [11.7673, 47.5902],
  [11.7595, 47.5889],
  [11.7534, 47.5892],
  [11.7453, 47.5877],
  [11.7233, 47.5891],
  [11.7002, 47.589],
  [11.6917, 47.5872],
  [11.6897, 47.5867],
  [11.6889, 47.5857],
  [11.6813, 47.5838],
  [11.6781, 47.5843],
  [11.678, 47.5851],
  [11.6728, 47.5855],
  [11.6639, 47.5836],
  [11.661, 47.5843],
  [11.6603, 47.5838],
  [11.6582, 47.5841],
  [11.6528, 47.5872],
  [11.6523, 47.5881],
  [11.6496, 47.5895],
  [11.6493, 47.5903],
  [11.6433, 47.5893],
  [11.6432, 47.5907],
  [11.6413, 47.5934],
  [11.6381, 47.5935],
  [11.6362, 47.5946],
  [11.633, 47.5926],
  [11.6324, 47.5915],
  [11.6326, 47.5896],
  [11.631, 47.5866],
  [11.631, 47.5846],
  [11.6324, 47.5842],
  [11.6331, 47.5828],
  [11.6344, 47.582],
  [11.6335, 47.5806],
  [11.6304, 47.5803],
  [11.6275, 47.5815],
  [11.6239, 47.584],
  [11.6195, 47.5844],
  [11.6177, 47.5836],
  [11.6165, 47.5814],
  [11.6131, 47.5798],
  [11.6086, 47.5806],
  [11.607, 47.5818],
  [11.6058, 47.5811],
  [11.6049, 47.5797],
  [11.6047, 47.5771],
  [11.6033, 47.5763],
  [11.6027, 47.5739],
  [11.6019, 47.573],
  [11.6026, 47.5713],
  [11.6015, 47.5703],
  [11.6014, 47.5689],
  [11.5999, 47.5665],
  [11.5984, 47.5656],
  [11.5972, 47.5635],
  [11.5952, 47.563],
  [11.5904, 47.5598],
  [11.5869, 47.5547],
  [11.5897, 47.5518],
  [11.5891, 47.5494],
  [11.5857, 47.5455],
  [11.5859, 47.5418],
  [11.5875, 47.5392],
  [11.5879, 47.5315],
  [11.5887, 47.5313],
  [11.5879, 47.5305],
  [11.5881, 47.5255],
  [11.5831, 47.5223],
  [11.5773, 47.5202],
  [11.5756, 47.5171],
  [11.5724, 47.5145],
  [11.5688, 47.5136],
  [11.5621, 47.5141],
  [11.5529, 47.5123],
  [11.5518, 47.5134],
  [11.545, 47.5118],
  [11.5397, 47.5095],
  [11.5379, 47.5098],
  [11.5337, 47.5089],
  [11.522, 47.5099],
  [11.5186, 47.511],
  [11.5125, 47.5064],
  [11.5092, 47.5062],
  [11.5057, 47.5047],
  [11.5022, 47.5068],
  [11.4991, 47.5073],
  [11.4944, 47.5074],
  [11.4913, 47.5067],
  [11.4895, 47.5071],
  [11.4876, 47.509],
  [11.4812, 47.5093],
  [11.4655, 47.5084],
  [11.4629, 47.5089],
  [11.4606, 47.5083],
  [11.4594, 47.5091],
  [11.4575, 47.5084],
  [11.4559, 47.509],
  [11.4493, 47.5072],
  [11.4479, 47.5104],
  [11.4459, 47.5113],
  [11.4432, 47.5142],
  [11.4422, 47.5158],
  [11.4421, 47.5179],
  [11.4403, 47.5167],
  [11.4381, 47.5157],
  [11.4372, 47.516],
  [11.4332, 47.5139],
  [11.4304, 47.511],
  [11.4219, 47.5063],
  [11.4219, 47.505],
  [11.421, 47.5046],
  [11.4206, 47.5035],
  [11.4166, 47.5023],
  [11.4162, 47.5008],
  [11.4131, 47.4989],
  [11.4116, 47.4955],
  [11.4098, 47.495],
  [11.4086, 47.4936],
  [11.4085, 47.492],
  [11.4076, 47.4906],
  [11.4063, 47.4904],
  [11.4027, 47.4878],
  [11.3993, 47.4868],
  [11.3985, 47.486],
  [11.3988, 47.4849],
  [11.398, 47.4842],
  [11.3956, 47.484],
  [11.3962, 47.4833],
  [11.3951, 47.4822],
  [11.3908, 47.4822],
  [11.3912, 47.4814],
  [11.3894, 47.4806],
  [11.3889, 47.4794],
  [11.3867, 47.478],
  [11.3869, 47.4773],
  [11.385, 47.476],
  [11.3851, 47.4741],
  [11.3838, 47.4724],
  [11.39, 47.4669],
  [11.3942, 47.4661],
  [11.3989, 47.4673],
  [11.4094, 47.4667],
  [11.4082, 47.4652],
  [11.4083, 47.4643],
  [11.4106, 47.4627],
  [11.4112, 47.4601],
  [11.4126, 47.4578],
  [11.4118, 47.4568],
  [11.4122, 47.4556],
  [11.4212, 47.4446],
  [11.4186, 47.445],
  [11.4154, 47.447],
  [11.4113, 47.4465],
  [11.4087, 47.447],
  [11.4074, 47.4459],
  [11.4024, 47.4481],
  [11.3975, 47.4474],
  [11.3946, 47.4477],
  [11.3888, 47.4465],
  [11.387, 47.448],
  [11.385, 47.4486],
  [11.3769, 47.4492],
  [11.3742, 47.4484],
  [11.3711, 47.4454],
  [11.3645, 47.4448],
  [11.3623, 47.4468],
  [11.3574, 47.4488],
  [11.3501, 47.4475],
  [11.3484, 47.4487],
  [11.3445, 47.4497],
  [11.3386, 47.4499],
  [11.3366, 47.449],
  [11.3324, 47.445],
  [11.3313, 47.4446],
  [11.3302, 47.442],
  [11.3313, 47.439],
  [11.3297, 47.4381],
  [11.3251, 47.4373],
  [11.3213, 47.4377],
  [11.3213, 47.4367],
  [11.3177, 47.4325],
  [11.3142, 47.4309],
  [11.311, 47.4302],
  [11.306, 47.4301],
  [11.3029, 47.4309],
  [11.2996, 47.4308],
  [11.2977, 47.4285],
  [11.2954, 47.4277],
  [11.293, 47.428],
  [11.291, 47.4271],
  [11.2902, 47.4221],
  [11.292, 47.4213],
  [11.2933, 47.4191],
  [11.2923, 47.4182],
  [11.2931, 47.4159],
  [11.2912, 47.4138],
  [11.2913, 47.413],
  [11.2902, 47.4115],
  [11.2901, 47.4073],
  [11.2882, 47.4066],
  [11.2849, 47.4027],
  [11.2811, 47.4006],
  [11.2801, 47.4008],
  [11.2726, 47.398],
  [11.2699, 47.3976],
  [11.2629, 47.3994],
  [11.2595, 47.3982],
  [11.2549, 47.3987],
  [11.2369, 47.3981],
  [11.2328, 47.3976],
  [11.2283, 47.3951],
  [11.225, 47.3953],
  [11.2223, 47.3973],
  [11.2233, 47.398],
  [11.2229, 47.3988],
  [11.224, 47.4015],
  [11.2277, 47.4033],
  [11.2283, 47.4044],
  [11.2307, 47.4056],
  [11.2305, 47.4072],
  [11.2324, 47.4089],
  [11.2319, 47.4095],
  [11.2324, 47.4108],
  [11.2344, 47.4119],
  [11.2347, 47.413],
  [11.2397, 47.4157],
  [11.2403, 47.4196],
  [11.2443, 47.421],
  [11.2452, 47.4225],
  [11.2531, 47.4273],
  [11.2534, 47.4282],
  [11.2508, 47.4316],
  [11.249, 47.4326],
  [11.2423, 47.4323],
  [11.2403, 47.4315],
  [11.239, 47.4323],
  [11.2367, 47.4323],
  [11.2256, 47.4309],
  [11.2217, 47.4315],
  [11.2213, 47.4305],
  [11.207, 47.4339],
  [11.2055, 47.4339],
  [11.1984, 47.4276],
  [11.18, 47.4264],
  [11.1774, 47.4255],
  [11.1764, 47.4241],
  [11.1692, 47.4225],
  [11.156, 47.4212],
  [11.1504, 47.4192],
  [11.1472, 47.4171],
  [11.1424, 47.4154],
  [11.141, 47.4141],
  [11.1361, 47.4127],
  [11.1281, 47.4122],
  [11.1265, 47.4107],
  [11.1265, 47.41],
  [11.1242, 47.4084],
  [11.1226, 47.4064],
  [11.123, 47.4057],
  [11.122, 47.4033],
  [11.1229, 47.4022],
  [11.1231, 47.4007],
  [11.1242, 47.4003],
  [11.1238, 47.3996],
  [11.1222, 47.3982],
  [11.1148, 47.3955],
  [11.1045, 47.3957],
  [11.1003, 47.3943],
  [11.0942, 47.3959],
  [11.0916, 47.3954],
  [11.0846, 47.3961],
  [11.0782, 47.3957],
  [11.0757, 47.3962],
  [11.0663, 47.3956],
  [11.0616, 47.3965],
  [11.0584, 47.3954],
  [11.0534, 47.3961],
  [11.0486, 47.3939],
  [11.0431, 47.3948],
  [11.0382, 47.3966],
  [11.0368, 47.3963],
  [11.0332, 47.3939],
  [11.0285, 47.3934],
  [11.0251, 47.3964],
  [11.0232, 47.3971],
  [11.018, 47.3969],
  [11.0112, 47.3949],
  [11.005, 47.3941],
  [11.0024, 47.3948],
  [10.9967, 47.3947],
  [10.994, 47.3953],
  [10.9927, 47.3964],
  [10.9883, 47.3957],
  [10.983, 47.397],
  [10.9796, 47.397],
  [10.9719, 47.3996],
  [10.9704, 47.4002],
  [10.9708, 47.4024],
  [10.9697, 47.404],
  [10.9697, 47.4053],
  [10.9711, 47.4085],
  [10.9702, 47.409],
  [10.9688, 47.4119],
  [10.9698, 47.4129],
  [10.9717, 47.4173],
  [10.9804, 47.4183],
  [10.9847, 47.421],
  [10.9836, 47.43],
  [10.9729, 47.4379],
  [10.9607, 47.4485],
  [10.9582, 47.4515],
  [10.9511, 47.4563],
  [10.9396, 47.4625],
  [10.9349, 47.4669],
  [10.9295, 47.4702],
  [10.9281, 47.4719],
  [10.9288, 47.4732],
  [10.9385, 47.48],
  [10.9372, 47.4811],
  [10.9343, 47.4827],
  [10.9254, 47.4825],
  [10.9099, 47.4855],
  [10.9001, 47.4834],
  [10.8958, 47.4833],
  [10.8934, 47.4824],
  [10.8922, 47.4811],
  [10.8871, 47.4808],
  [10.8848, 47.4793],
  [10.8815, 47.4792],
  [10.8785, 47.4794],
  [10.8766, 47.4805],
  [10.8745, 47.4804],
  [10.8727, 47.4817],
  [10.8713, 47.4816],
  [10.87, 47.4833],
  [10.8695, 47.4844],
  [10.8695, 47.488],
  [10.8718, 47.4931],
  [10.871, 47.4945],
  [10.8715, 47.4962],
  [10.8701, 47.4983],
  [10.872, 47.5004],
  [10.8769, 47.5031],
  [10.8861, 47.5052],
  [10.8908, 47.5076],
  [10.8977, 47.5081],
  [10.9039, 47.5098],
  [10.9054, 47.5109],
  [10.918, 47.5136],
  [10.9173, 47.5153],
  [10.9186, 47.5173],
  [10.9158, 47.5194],
  [10.9055, 47.5175],
  [10.9042, 47.5184],
  [10.9032, 47.5202],
  [10.9009, 47.5211],
  [10.8962, 47.5277],
  [10.8927, 47.5305],
  [10.8903, 47.5373],
  [10.8669, 47.5357],
  [10.8664, 47.5348],
  [10.8621, 47.534],
  [10.8536, 47.5347],
  [10.8531, 47.5334],
  [10.8485, 47.5302],
  [10.8467, 47.53],
  [10.8429, 47.5278],
  [10.8413, 47.5282],
  [10.84, 47.5277],
  [10.8385, 47.5254],
  [10.8344, 47.5281],
  [10.8317, 47.5284],
  [10.8254, 47.5281],
  [10.8189, 47.5263],
  [10.813, 47.5264],
  [10.8118, 47.5257],
  [10.8111, 47.5243],
  [10.8126, 47.52],
  [10.8097, 47.5197],
  [10.8067, 47.5206],
  [10.8044, 47.5201],
  [10.8013, 47.5206],
  [10.7986, 47.5202],
  [10.7954, 47.5212],
  [10.7867, 47.5166],
  [10.7853, 47.5178],
  [10.7831, 47.5173],
  [10.7775, 47.5139],
  [10.7764, 47.5157],
  [10.7726, 47.5157],
  [10.7668, 47.5188],
  [10.7638, 47.5196],
  [10.7622, 47.5227],
  [10.7646, 47.5249],
  [10.7635, 47.5269],
  [10.764, 47.5283],
  [10.7606, 47.5315],
  [10.7611, 47.532],
  [10.7585, 47.5345],
  [10.7538, 47.535],
  [10.7539, 47.5358],
  [10.751, 47.5373],
  [10.7463, 47.5372],
  [10.7378, 47.5388],
  [10.7349, 47.5378],
  [10.7333, 47.5386],
  [10.7315, 47.5382],
  [10.7303, 47.5389],
  [10.7243, 47.5376],
  [10.7184, 47.5381],
  [10.7156, 47.5406],
  [10.713, 47.5413],
  [10.7114, 47.5428],
  [10.709, 47.5437],
  [10.705, 47.5441],
  [10.7002, 47.5436],
  [10.6946, 47.5448],
  [10.6902, 47.5554],
  [10.6924, 47.556],
  [10.691, 47.5588],
  [10.6835, 47.5567],
  [10.678, 47.5562],
  [10.6766, 47.559],
  [10.666, 47.559],
  [10.6643, 47.5584],
  [10.6604, 47.5594],
  [10.6519, 47.5587],
  [10.6419, 47.5594],
  [10.6348, 47.559],
  [10.6261, 47.561],
  [10.6261, 47.563],
  [10.6223, 47.5655],
  [10.6191, 47.5669],
  [10.6146, 47.5667],
  [10.6133, 47.5655],
  [10.6081, 47.5658],
  [10.6052, 47.5667],
  [10.6032, 47.5682],
  [10.6005, 47.5682],
  [10.5979, 47.5697],
  [10.5958, 47.5671],
  [10.5959, 47.5649],
  [10.5932, 47.5636],
  [10.5899, 47.5598],
  [10.5827, 47.557],
  [10.5819, 47.5558],
  [10.5803, 47.5557],
  [10.5793, 47.5532],
  [10.5807, 47.5511],
  [10.5823, 47.5502],
  [10.5818, 47.548],
  [10.5734, 47.534],
  [10.5711, 47.5335],
  [10.564, 47.5341],
  [10.563, 47.5347],
  [10.5628, 47.5363],
  [10.5599, 47.5362],
  [10.5589, 47.5373],
  [10.5365, 47.5366],
  [10.5245, 47.5352],
  [10.4889, 47.5404],
  [10.4723, 47.5511],
  [10.4605, 47.5526],
  [10.4544, 47.5558],
]
